var _defs, _rect, _path, _rect2, _g, _g2, _g3, _g4, _path2, _path3, _g5, _g6, _g7, _g8, _g9, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _g10, _g11, _path213;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutside(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1859,
    height: 2160,
    viewBox: "0 0 1859 2160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24211",
    "data-name": "Rectangle 24211",
    width: 1859,
    height: 2160,
    transform: "translate(-5007 871)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3cabd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ccdeb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: 2.842,
    x2: 0.5,
    y2: 0.126,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4e6831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a3a387"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    y1: 2.745,
    x2: 0.5,
    y2: -3.591,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.5,
    y1: 3.996,
    x2: 0.5,
    y2: -2.272,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.5,
    y1: 1.084,
    x2: 0.5,
    y2: -0.035,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#60735a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449,
    stopColor: "#83a185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.5,
    y1: 2.44,
    x2: 0.5,
    y2: -0.251,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#326d35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.051,
    stopColor: "#386b34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229,
    stopColor: "#486931"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.366,
    stopColor: "#4e6831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#869650"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.429,
    y1: 2.403,
    x2: 0.575,
    y2: -1.352,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#60735a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.957,
    stopColor: "#83a185"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.428,
    y1: 1.991,
    x2: 0.578,
    y2: -0.951,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.429,
    y1: 2.115,
    x2: 0.571,
    y2: -1.367,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0.428,
    y1: 2.538,
    x2: 0.572,
    y2: -1.86,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.115,
    y1: 0.871,
    x2: 0.883,
    y2: -0.121,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.503,
    y1: 0.806,
    x2: 0.459,
    y2: -2.526,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c2da67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#5d9841"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d5a2d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 0.546,
    y1: 0.98,
    x2: 0.434,
    y2: -0.605,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 0.553,
    y1: 1.682,
    x2: 0.483,
    y2: -0.28,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff6ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff6ce",
    stopOpacity: 0
  })))), /*#__PURE__*/React.createElement("g", {
    id: "outside",
    transform: "translate(5007 -871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_6",
    "data-name": "Mask Group 6",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "outside-2",
    "data-name": "outside",
    transform: "translate(-4192 2055)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24206",
    "data-name": "Rectangle 24206",
    width: 1859.251,
    height: 1986.838,
    transform: "translate(-814.694 -1184)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_87759",
    "data-name": "Group 87759",
    transform: "translate(-818.584 461.666)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_162529",
    "data-name": "Path 162529",
    d: "M-81.052,1.654,1785.834,5.889V209.666L-81.052,205.431Z",
    transform: "translate(81.052 304.733)",
    fill: "#479900"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_87753",
    "data-name": "Group 87753",
    transform: "translate(1.818)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24209",
    "data-name": "Rectangle 24209",
    width: 1860,
    height: 203,
    transform: "translate(1.766 30.334)",
    fill: "url(#linear-gradient)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_87799",
    "data-name": "Group 87799",
    transform: "translate(916.535 4.334)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161749",
    "data-name": "Path 161749",
    d: "M429.618,31.79c3.255-2.042,4.014-5.211,3.524-8.45-.3-2.074-2.45-3.038-4.835-2.233a18.607,18.607,0,0,0-5.468,3.042c-.924-.774-2.358-1.081-4.482-.41a12.27,12.27,0,0,0-2.369,1.077,13.131,13.131,0,0,0-.9-2.611,3.715,3.715,0,0,0-4.954-1.611c-3.324,1.855-4.26,4.614-4.444,7.743-.034.586-.057,1.289-.042,2.006a25.185,25.185,0,0,0-8.182-1.441,37.171,37.171,0,0,0,4.448-4.568c1.269-1.667-.445-4.285-2.841-4.281a11.9,11.9,0,0,0,.242-7.016c-.533-1.883-3.37-2.614-5.353-1.738a16.052,16.052,0,0,0-7.837,7.372,32.949,32.949,0,0,0-3.244-6.73c-1.288-2.01-4.854-1.742-6.223,0a9.776,9.776,0,0,0,.18,12.166,22.889,22.889,0,0,0-3.888,2.625c-.571-4.123-1.714-8.083-5.732-11.156-1.238-.95-3.719-1.208-4.9,0-.1.1-.173.208-.268.307-.38-.382-.778-.742-1.192-1.084-2.511-2.063-7.561-2.2-9.493.53-1.553,2.165-1.3,4.6-.157,7.033-.13.007-.272.007-.406.021-2.592.276-4.578,2.717-2.3,4.451,1.679,1.275,3.4,2.561,5.211,3.794A23.66,23.66,0,0,0,343.2,34.577c-.579-3.533-1.415-6.987-4.935-9.474-1.3-.915-3.658-1.233-4.908,0a13.658,13.658,0,0,0-1.729,2.12c-2.354-2.134-5.241-3.338-8.3-1.908-3.439,1.607-3.531,5.666-2.2,8.241A11.509,11.509,0,0,0,322.894,36c-1.875.523-3.083,2.6-1.921,4.041q1.116,1.378,2.289,2.7a24.34,24.34,0,0,0-6.5,1.653,13.926,13.926,0,0,0-1.622-6.772c-.844-1.554-3.324-1.618-4.931-1.039a15.227,15.227,0,0,0-8.78,7.362,38.537,38.537,0,0,0-5.322-6.207c-1.787-1.632-5.387-.332-5.295,1.752a20.383,20.383,0,0,0,1.725,7.277,15.264,15.264,0,0,0-4.992,3.338,14.547,14.547,0,0,0-4.513-6.034,4.37,4.37,0,0,0-5.13,0,7.839,7.839,0,0,0-3.259,7.916,25.314,25.314,0,0,0-5.836-3.755,3.919,3.919,0,0,0-5.2,1.692c-2.178,4.462,2.151,8.627,7.17,9.33a14.658,14.658,0,0,0-1.465,1.4,4.182,4.182,0,0,0-4.045-.385,12.417,12.417,0,0,0-2.853,1.487c-2.143-3.6-4.482-7.058-8.454-9.722-2.78-1.869-6.315-.078-5.793,2.7a24.3,24.3,0,0,0,1.472,4.737,13.479,13.479,0,0,0-8.842-1.533c-3.014-4.882-11.376-.749-17.764,3.826a6.092,6.092,0,0,0-6.671-2.155,3.315,3.315,0,0,0-3.642-2.469c-.564.049-1.12.127-1.653.2a10.563,10.563,0,0,0,.207-2.932c-.134-1.911-2.623-3.229-4.82-2.215a24.256,24.256,0,0,0-3.374,1.893,26.731,26.731,0,0,0-2.554-9.111c-.867-1.805-2.876-2.392-5.053-1.65-5.437,1.844-6.4,5.786-5.617,10.089a10.79,10.79,0,0,0-6.027.226c-2.224.71-3.439,2.522-2.2,4.32a25.317,25.317,0,0,0,6.292,6.454,30.921,30.921,0,0,0-3.025,1.311,3.2,3.2,0,0,0-3.205-2,19.156,19.156,0,0,0-7.569,2.5,15.972,15.972,0,0,0-2.738-7.9,4.233,4.233,0,0,0-5.69-.586,12.424,12.424,0,0,0-3.121,3.469c-2.327-4.25-6.323-7.821-12.43-7.577a2.87,2.87,0,0,0-3.033,2.43c-.939,6.38,4.348,10.35,10.935,12.551a3.493,3.493,0,0,0,.192.689c-5.36-1.042-10.64-.555-14.382,3.5-1.219,1.342-.2,3.225,1.327,4.034.46.23.92.431,1.392.615a4.311,4.311,0,0,0,.107,1.357,4.534,4.534,0,0,0,.64,1.342,5.784,5.784,0,0,0-1.1.876,8.2,8.2,0,0,0-1.02,1.212,11.675,11.675,0,0,0-2.086-.795,11.373,11.373,0,0,0-9.4,1.869c-3.025,2.293-2.408,5.709.824,7.584a7.689,7.689,0,0,0,1.86.77c-.107.191-.261.364-.383.565-1.051,1.805-.2,3.812,2.266,4.44a13.06,13.06,0,0,0,8.945-.844c7.028,4.119,27.081.714,33.166-.551A803.105,803.105,0,0,1,285.008,80.96a524.886,524.886,0,0,1,65.415-1.074c20.256,1.032,41.263,1.039,61.086,4.561C450.675,91.406,431.5,51.283,429.618,31.79ZM337,38.452c.092.781.184,1.53.322,2.243-.395-.487-.824-.95-1.261-1.406A2.585,2.585,0,0,0,337,38.452Z",
    transform: "translate(-131.746 -10.535)",
    fill: "#2c592b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87747",
    "data-name": "Group 87747",
    transform: "translate(3.035 5.489)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161750",
    "data-name": "Path 161750",
    d: "M165.345,37.728c3.573-2.374.982-7.5-3.723-6.924.625-1.674-.311-4.988-3.389-3.038-3.217,2.049-2.653,4.765-4.831,7.051a.618.618,0,0,0-.211-.325c4.475-.484-7.162-8.45-8.362-8.92-3.006-1.2-3.182,1.763-2.389,3.119,1.323,2.236,3.957,5.119,7.3,5.433-2.833,1.759-8.761-1.883-11.533,1.985-3.915,5.44,8.566,5.048,11.656,3.352.234,3.218,4.559,14.5,9.294,7.259C161.53,43.087,164.3,47.81,168,45.1c2.561-1.876-.828-6.034-2.653-7.369C166.882,36.711,167.3,39.156,165.345,37.728Z",
    transform: "translate(-118.606 21.347)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161751",
    "data-name": "Path 161751",
    d: "M150.587,30.524c-1.952,1.766-7.254.523-10.6,2.876-3.086,2.162-7.22,6.885-.015,7.217,5.119.24,9.428-3.024,12.565-5.864,2.366-2.141,1.112-7.033-1.948-4.228C150.2,30.881,152.7,28.6,150.587,30.524Zm-4.463,3.72a15.129,15.129,0,0,1-2.891,1.54A8.659,8.659,0,0,1,146.124,34.244Z",
    transform: "translate(-122.804 32.458)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161752",
    "data-name": "Path 161752",
    d: "M144.83,31.881c-2.1-2.388-14.915-.59-11.809,2.974,1.81,2.056,7.185,1.335,9.585.682.7-.194,6.38-2.886,2.224-3.656C144.681,31.694,146.253,32.142,144.83,31.881Z",
    transform: "translate(-132.538 35.284)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161753",
    "data-name": "Path 161753",
    d: "M145.235,28.663a26.957,26.957,0,0,0-9.716.307c-3.727.933-.64,3.614,1.311,4.214,5.268,1.607,9.539-4.391,8.4-4.522C142.064,28.271,146.316,28.794,145.235,28.663Z",
    transform: "translate(-129.051 29.147)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161754",
    "data-name": "Path 161754",
    d: "M175.622,40.823c-1.25-2.409-3.938-4.13-6.852-5.15,3.3-2.165,4.689-5.716,3.539-9-1.434-4.14-8.976.495-10.517,2.144-1.058-1.47-5.571-8.51-8.289-4.6-2.73,3.939,4.421,7.3,5.433,10.117-4.137-.908-8.9.7-11.9,2.953-4.95,3.723,6.932,4.317,8.934,4.017-2.853,8.725,6.664,6.966,8.481-.035a21.082,21.082,0,0,0,4.336,1.452,1.47,1.47,0,0,0-.495,1.187c-1.626-1.59-4.647,4.529.771,6.242,4.183,1.328,4.057-5.419,3.11-6.963,1.568.113,4.405-.48,3.447-2.37C174.407,38.463,176.216,41.978,175.622,40.823Z",
    transform: "translate(-94.832 15.68)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161755",
    "data-name": "Path 161755",
    d: "M154.251,26.5c-2.749-.6-3.754-2.688-7.109-2.614-2.718.049-2.373,2.883-1.361,4.112C149.91,32.965,156.547,27,154.251,26.5Z",
    transform: "translate(-97.118 17.791)",
    fill: "#9aad3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161756",
    "data-name": "Path 161756",
    d: "M152.06,28.682c-1.557.876-9.551,5.1-4.544,6.7,6.081,1.95,8.282-8.789,4.544-6.7C151.5,29,153.59,27.827,152.06,28.682Z",
    transform: "translate(-94.701 29.128)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161757",
    "data-name": "Path 161757",
    d: "M161.6,24.784c-3.443-.106-12.235,5.447-6.8,7.666,6.84,2.777,11.963-7.493,6.8-7.666C159.9,24.734,162.8,24.826,161.6,24.784Z",
    transform: "translate(-74.349 20.023)",
    fill: "#9aad3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161758",
    "data-name": "Path 161758",
    d: "M182.656,30.707c.483-1.727-2.093-2.656-3.443-3.405-.686-2.317-2.964-3.879-5.583-4.818-7.419-2.671-4.118,3.72-.936,5.931-3.961,1.576-6.99,7.5-.587,7.931,2.987.2,13.163-1.441,10.548-5.638C182.852,29.976,182.982,31.237,182.656,30.707Z",
    transform: "translate(-30.892 12.61)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161759",
    "data-name": "Path 161759",
    d: "M193.518,33.351c-.368-2.844-5.042-1.883-7.254-1.508-4.743.812-2.454-.689-4.938-3.236a4.284,4.284,0,0,0-3.558-1.3,2.313,2.313,0,0,0-1.449-2.049c-4.026-1.424-5.7,5.514-5.111,7.323-1.492.314-9.854-1.77-8.036,2.19,1.472,3.2,8.8,2.141,11.085.343,3.19,1.6,5.464.385,8.473,1.48,2.956,1.081,11.3.816,10.789-3.239C193.379,32.305,193.817,35.788,193.518,33.351Z",
    transform: "translate(-46.45 20.768)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161760",
    "data-name": "Path 161760",
    d: "M181.639,28.034c-1.074-5.189-8.006-3.656-9.344.629-2.017,6.493,10.789,6.323,9.344-.629C181.52,27.5,181.826,28.953,181.639,28.034Z",
    transform: "translate(-20.473 19.977)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161761",
    "data-name": "Path 161761",
    d: "M182.921,21.816c-1.085-3.624-14.148,4.377-9.424,10.69,1.744,2.339,6.338-1.155,7.35-2.31a8.923,8.923,0,0,0,2.074-8.379C182.637,20.883,184.124,25.871,182.921,21.816Z",
    transform: "translate(-19.363 10.249)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161762",
    "data-name": "Path 161762",
    d: "M174.052,20.915c-2.143-1.258-3.294,1.431-3.439,2.445-.349,2.554,1.472,4.942,3.807,6.542,1.028.724,4.179-6.309-.368-8.987C173.212,20.431,176.514,22.364,174.052,20.915Z",
    transform: "translate(-24.75 9.433)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161763",
    "data-name": "Path 161763",
    d: "M189.347,25.021c-3.282-2.264-18.757-2.876-14.133,2.914,4.789,6,17.771-.424,14.133-2.914C185.954,22.686,190.095,25.533,189.347,25.021Z",
    transform: "translate(-14.011 16.543)",
    fill: "#9aad3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161764",
    "data-name": "Path 161764",
    d: "M185.722,20.465c-.575-4.614-9.815,4.515-9.045,8.259.529,2.5,3.037,2.081,4.938.76a9.9,9.9,0,0,0,4.106-9.019C185.584,19.373,185.99,22.613,185.722,20.465Z",
    transform: "translate(-7.571 5.899)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161765",
    "data-name": "Path 161765",
    d: "M208.543,20.775c-.648-1.738-6.74-.848-8.654-.608-3.355.431-8.3,3.356-7.3,6.567,1.572,5.062,17.84-1.01,15.958-5.959C208.294,20.111,209.444,23.146,208.543,20.775Z",
    transform: "translate(37.277 7.252)",
    fill: "#9aad3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161766",
    "data-name": "Path 161766",
    d: "M183.9,27.068c.541-2.052-11.506,1.367-7.27,5.917,3.14,3.4,11.265-4.342,7.27-5.917C184.06,26.454,184.773,27.407,183.9,27.068Z",
    transform: "translate(-10.13 24.302)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161767",
    "data-name": "Path 161767",
    d: "M188.156,26.6c-2.017-1.618-7.224,2.681-7.511,4.07-1.162,5.642,11.315-1.028,7.511-4.07Z",
    transform: "translate(3.587 23.763)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161768",
    "data-name": "Path 161768",
    d: "M207.993,13.082c-1.576-4.013-13.933,5.112-8.815,10.093,5.03,4.907,10.383-6.1,8.815-10.093C207.514,11.859,209.193,16.12,207.993,13.082Z",
    transform: "translate(52.834 -12.089)",
    fill: "#9aad3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161769",
    "data-name": "Path 161769",
    d: "M292.861,38.549c3.673-4.1-2.465-10.456-8.221-7.715-.962-3.1-3.773-4.437-7.664-3.525-4.034.94-.514,7.358,1.116,8.884a15.546,15.546,0,0,0-3.65.265c.153-2.66-1.292-5.786-5.073-6.037,3.182-3.829.51-6.648-4.9-5.352-2.508.593-4.958,1.964-5.839,4.024a3.3,3.3,0,0,0-2.128,1.515,18.516,18.516,0,0,0-4.486-1.272c5.122-2.96,1.139-8.733-4.233-10.153-5.3-1.424-2.592,8.676,1.422,9.98-1.867.035-5.218.321-6.215,1.9a9.989,9.989,0,0,0-3.777-2.766c4.218-1.339,8.01-11.513,2.055-9.99,1.952-3.169-2.289-8.92-5-3.879-2.442,4.543-1.158,3.918,2.523,4.8a14.725,14.725,0,0,0-5.169,3.6c-.2-2.286-3.152-8.846-7.572-6.91-3.976,1.734-1.81,7.948,1.645,9.185-2.715-.018-10.663,2.932-6.572,5.8,2.757,1.943,11.3-.565,11.767-3.561.495.844,1.894.6,2.8.95-3.892,1.367-3.175,4.737-.552,6.775-1.008-.378-2.853-.208-3.481.632-3.025-1.639-10.092-1.862-11,1.95-1.445,6.178,20.521,4.123,15.62-1.809,2.753,1.689,12.871,3.783,9.654-.926a24.139,24.139,0,0,0,9.992.88c-.541,1.148-5.268,2.413-6.6,3.868-2.251,2.42-.4,5.281-1.982,6.927-1.139-1.678-4.386-.2-5.475.608a16.6,16.6,0,0,0-2.853,2.8,2.335,2.335,0,0,0-2.78,1.06c-3.458-9.255-12.38-3.42-9.072,4.091-3.14-.851-3.98-.064-4.8-2.6-.579-1.773-2.109-2.784-4.045-3.607,4.835-1.342,9.129-4.928,2.623-7.63-3.324-1.385.564-7.267-7.139-4.822.441-.876,8.255-10.891,1.3-10.488-7.772.452-7.155,6.934-7.772,11.456-1.959-1.568-2.27-3.232-1.031-4.773.878-1.077-2.22-5.052-2.918-5.988-.663-.883-4.831-4.465-5.41-1.18a6.434,6.434,0,0,0,.982,5.182c.9,1.2-1.43,1.378-1.806,2.851-2.7-2.038-13.876-1.943-9.578,1.646a11.762,11.762,0,0,0,6.158,2.515c3.819.445,3.807-.177,6.913,1.512a19.626,19.626,0,0,0-8.527,2.533c-2.883,1.812-1.008,4.119-3.5,4.525,4.183-2.72-3.965-5.384-6.817-4.221-5.652,2.275-2.791,6.306,2.764,5.419-8.776,3.932-2.247,8.294,5.456,5.642-2.12,1.081-14.232,6.387-8.788,9.008,2.577,1.233,6.123-1.487,7.841-2.681,2.818-1.95,3.968-3.14,6.951-3.847-5.583,6.6,2.327,8.747,6.767,2.752.161,1.745,1.518,6.839,3.957,7.719,4.494,1.636,6.706-5.313,6.595-7.588a11.515,11.515,0,0,0,5.954-.6c.525,2.233,2.818,3.494,5.552,3.568-8.573,8.665,6.7,10.082,10.674,2.607,4.693,9.319,18.07,2.007,8.589-3.674a8.093,8.093,0,0,0,3.125-4.32c.207.926,1.426,1.088,2.389,1.024a8.8,8.8,0,0,0,7.112,3.9c-2.416,1.173-7.066,5.695-4.72,8.16,3.1,3.229,8.941-1.918,10.241-4.045,1.645-2.7-2.431-4.4-1.288-4.886,3.209-1.378,7.795-1.307,10.9-4.3-.368,2.151-.564,6.15,1.9,7.659,1.449.865,2.646,1.339,2.07,2.233-3.884,6.076,12.733,6.362,6.4-1.964,5.142-.463,3.884-4.19,7.285-4.91,4.839-1.014,1.779-8.983.521-11.294,5.257-.5,6.99-6.659,2.818-9.089C294.422,36.8,294.816,39.69,292.861,38.549Zm-60.45-12.6a8.392,8.392,0,0,0-2.35-.636c.82-.215,1.745.014,2.442-.431-.038.357-.065.714-.092,1.067C232.392,25.944,232.365,25.581,232.411,25.944ZM206.167,44.575a2.915,2.915,0,0,0-1.457.823c-1.058-.509-.56-1.113,1.522-1.816-.015.329-.034.664-.065.993C205.626,44.688,206.167,44.24,206.167,44.575Zm.87-3.2c-.2-2.127-.805.484.571-1.7.817.487.617,1.056-.571,1.7C207.037,41.364,207.309,40.912,207.037,41.378ZM247.572,55c-.426.438-.836-1.3-2.3-1.4.372-.293,3.267,1.208,1.871.7.9.028,1.051.265.426.7C247.476,55.1,247.668,54.83,247.572,55ZM260.8,39.478c-.23-.2.318,5.963.429,7.037-2.005.018-5.249-1.6-6.794.438-.372-2.593,4.858-4.762,6.365-7.475C260.915,39.58,259.431,41.968,260.8,39.478Zm.077,16.031c-1.879-2.028-5.065-2.794-8.1-2.483a5.83,5.83,0,0,0,1.737-3.964,5.617,5.617,0,0,0,3.911,1.554,21.082,21.082,0,0,0,4.068-.378,2.939,2.939,0,0,0,2.243,1.307,11.824,11.824,0,0,0-3.857,3.964C259,53.481,261.82,53.894,260.876,55.508Zm6.81-12.23c-.314-.442-.633-.883-.966-1.325,1.679.166,3.217-.717,4.528-.042a17.778,17.778,0,0,0-3.562,1.367C267.4,42.827,268.775,42.713,267.686,43.279Z",
    transform: "translate(-1.656 -11.214)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161770",
    "data-name": "Path 161770",
    d: "M207.883,26.383c-2.707-3.059-8.309,8.478-6.234,11.124,3.957,5.076,9.275-7.694,6.234-11.124C207,25.373,209.167,27.817,207.883,26.383Z",
    transform: "translate(62.054 22.815)",
    fill: "#5aa445"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_87748",
    "data-name": "Group 87748",
    transform: "translate(7.168 8.312)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161771",
    "data-name": "Path 161771",
    d: "M166.249,32.4c-.472-3.547-6.618.1-8.056.922,2.243-2.731,1.917-9.644-3.355-5.4-3.382,2.724-2.3,5.546-3.635,8.386a.855.855,0,0,1-.211-.011c1.86-2.218-5.54-4.1-7.308-4.179-3.7-.166-.2,6.436,4.866,5.454-3.152,2.077-2.12,1.883-6.422,1.5-2.956-.276-2.12,2.925-1.07,3.907-1.25,0-5.644-.138-6.553.456-3.393,2.215,3.9,2.812,5.513,2.222a2.876,2.876,0,0,0,2.488-1.756,7.869,7.869,0,0,0,3.922.424c2.626-.353,5-2.6,6.112-4.462,5.759,7.376,10.981-2.9,2.653-4.2.015-.961.744-1.477,2.174-1.551-1.576,2.9,9.578,3.794,8.88-1.713C166.1,31.391,166.444,33.966,166.249,32.4Z",
    transform: "translate(-133.616 21.791)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161772",
    "data-name": "Path 161772",
    d: "M139.21,24.684c-4.984-1.222-1.61,5.829.782,6.86,2.822,2.752,6.112-5.168-.782-6.86C137.9,24.362,142.281,25.44,139.21,24.684Z",
    transform: "translate(-125.058 16.626)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161773",
    "data-name": "Path 161773",
    d: "M143.489,29.675c-1.2-1.2-5.157-3.935-7.638-2.678C128.985,30.46,146.365,32.551,143.489,29.675Z",
    transform: "translate(-131.868 22.027)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161774",
    "data-name": "Path 161774",
    d: "M148.432,27.256c-.583-2.512-7.542-.364-5.874,1.809C140.15,31.344,149.758,33.138,148.432,27.256Z",
    transform: "translate(-109.377 20.634)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161775",
    "data-name": "Path 161775",
    d: "M161.718,31.871c-2.17-2.374-4.513-5.4-8.155-5.846-6.012-3.264-12.526,2.713-4.014,3.674-9.961,4.07.483,8.665,5.153,2.621-2.22,7.5,12.116,5.136,7.017-.449C161.338,31.468,162.3,32.51,161.718,31.871Z",
    transform: "translate(-100.26 17.934)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161776",
    "data-name": "Path 161776",
    d: "M154.584,26.285c-1.338-7.206-9.758-3-6.591,1.629,2.619,3.826,7.431,2.858,6.591-1.629C154.354,25.049,154.825,27.575,154.584,26.285Z",
    transform: "translate(-94.874 11.223)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161777",
    "data-name": "Path 161777",
    d: "M152.516,26.938c2.266-1.219-5.157-5.468-7.193-2.9-2.88,2.812,5.05,4.045,7.193,2.9C153.39,26.468,152.4,26.995,152.516,26.938Z",
    transform: "translate(-102.2 13.293)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161778",
    "data-name": "Path 161778",
    d: "M153.195,32.375c-.794-2.187-10.5-7.062-10.812-2.815-.322,4.059,12.262,6.744,10.812,2.815C152.508,30.5,153.72,33.816,153.195,32.375Z",
    transform: "translate(-108.788 25.075)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161779",
    "data-name": "Path 161779",
    d: "M149,32.677c-.456-1.978-5.7-4.924-6.622-1.978-1.837,5.85,7.964,7.694,6.622,1.978C148.805,31.85,149.258,33.75,149,32.677Z",
    transform: "translate(-109.421 29.062)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161780",
    "data-name": "Path 161780",
    d: "M165.322,32.824c-1.269-2.526-4.5-4.225-7.952-4.094,8.04-9.04-12.5-2.2-7.956,1.18,1.883,1.4,2.155.371,3.01,2.105a6.767,6.767,0,0,0,3.846,2.96c1.764.65,10.954,1.636,9.052-2.151C164.36,30.909,165.882,33.936,165.322,32.824Z",
    transform: "translate(-90.721 15.851)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161781",
    "data-name": "Path 161781",
    d: "M158.633,23.611c-1.1.449-11.223,6.037-4.2,6.249,6.177.194,7.764-7.722,4.2-6.249Z",
    transform: "translate(-81.593 13.805)",
    fill: "#d0d028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161782",
    "data-name": "Path 161782",
    d: "M156.294,30.038c-1.844-3.087-7.266-2.914-6.353,1.028,1.177,5,9.279,3.861,6.353-1.028C155.742,29.1,156.934,31.1,156.294,30.038Z",
    transform: "translate(-87.64 25.122)",
    fill: "#d0d028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161783",
    "data-name": "Path 161783",
    d: "M181.374,27.926c2.415-.979,6.3-5.422,2.093-6.913-3.271-1.141-6.549,3.593-6.181,5.627-2.262-.795-4.7-3.614-7.668-3-4.659.986,2.182,6.68,6.4,5.606-.978,1.957,1.066,4.7,3.14,5.649-2.27.371-4.777,1.9-3.662,4.352,1.779,3.893,7.2-1.311,5.372-3.79,7.055,1.42,4.494-5.91.506-7.535C184.046,26.834,183.916,28.971,181.374,27.926Z",
    transform: "translate(-36.009 7.244)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161784",
    "data-name": "Path 161784",
    d: "M177.721,26.912c-.41-.6-4.912-2.063-5.839-2.632-2.385-1.466-6.238-2.233-5.744,1.36.778,5.67,13.535,4.154,11.583,1.272C177.031,25.9,178.511,28.078,177.721,26.912Z",
    transform: "translate(-41.566 12.864)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161785",
    "data-name": "Path 161785",
    d: "M176.072,25.54c-2.274-.014-5.456.053-7.442,1.024-1.457.717-5.168,4.338-1,4.886a12.4,12.4,0,0,0,7.7-1.625c1.089-.664,4.582-4.243.748-4.285C175.332,25.537,177.118,25.554,176.072,25.54Z",
    transform: "translate(-42.654 19.15)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161786",
    "data-name": "Path 161786",
    d: "M201.817,30.1c-1.871-.915-5.448-.908-6.668-2.144,2.116-1.18,7.1-4.409,3.988-6.673-4.961-3.589-10.774,3.868-11.549,6.917-.441-.321.376-1.268-.031-1.876-.893-1.307-2.082-2.932-3.194-4.243-4.482-5.278-9,.516-5.368,4.437-6.361-2.363-8.861,4.44-1.848,3.359-4.459,4.405,4.846,4.423,7.9,2.95-1.591,2.837,2.611,10.926,5.832,6.521,3.412-4.7-3.876-6.843-2.918-9.111a2.009,2.009,0,0,0,2.577-.509c.479,2.494,5.172,3.575,7.615,3.773C200.153,33.672,206.073,32.174,201.817,30.1Z",
    transform: "translate(-22.201 5.048)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161787",
    "data-name": "Path 161787",
    d: "M180.092,25.329c-2.665-3.027-7.135,3.363-6.541,5.362,1.212,4.186,9.98-1.459,6.541-5.362C179.927,25.138,182.124,27.632,180.092,25.329Z",
    transform: "translate(-20.587 16.591)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161788",
    "data-name": "Path 161788",
    d: "M208.4,19.617c2.009-4.034-5.835-1.268-7.013-.385a5.732,5.732,0,0,0-2.4,3.232,4.214,4.214,0,0,0-2.427.805c-2.469-1.42-2.91-3.416-6.522-3.847-6.284-.745-1.074,6.27,2.032,7.161-2.484,1.141-11.575.689-10.92,5.115.732,4.871,10.548.827,12.867-.9-.782,1.918-2.427,7.323,1,8.333,4.659,1.364,7.155-3.338,6.284-6.193,8.443,3.72,8.393-5.592.188-6.779a12.222,12.222,0,0,0,6.905-6.539C209.064,18.271,207.423,21.567,208.4,19.617Zm-12.2,8.128c.054-1.71,0-1.611,1.932-1.229-1,.491-.824.95-1.932,1.229C196.208,27.661,196.457,27.678,196.2,27.745Z",
    transform: "translate(1.022 -1.248)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161789",
    "data-name": "Path 161789",
    d: "M191.074,20.8c-.748-2.215-9.428-7.563-9.7-2.964-.276,4.861,10.889,6.408,9.7,2.964C190.99,20.519,191.362,21.611,191.074,20.8Z",
    transform: "translate(1.723 -4.948)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161790",
    "data-name": "Path 161790",
    d: "M190.007,23.673c-2.308-3.9-8.447,2.656-9.16,4.907-1.595,5.009,12.641,1,9.16-4.907C189.965,23.6,191.652,26.474,190.007,23.673Z",
    transform: "translate(-0.109 11.352)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161791",
    "data-name": "Path 161791",
    d: "M193.144,25.726c-.755-1.328-5.28-4.882-6.38-1.558-.633,1.858,2.128,3.31,2.243,5.175-.322,3.268,6.756.943,4.137-3.617C192.315,24.26,193.976,27.167,193.144,25.726Z",
    transform: "translate(16.747 12.182)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161792",
    "data-name": "Path 161792",
    d: "M188.7,24.16c-4.348-.961-6.012,6.175-3.458,7.814,4.267,2.741,8.362-6.73,3.458-7.814Z",
    transform: "translate(9.293 15.433)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161793",
    "data-name": "Path 161793",
    d: "M196.483,16.837c-.322-.007-4.064-2.137-4.459-2.314-3.712-1.717-3.535,3.176-2.289,4.518,4.363,4.684,11.012-2.038,6.748-2.2C196.426,16.837,197.753,16.883,196.483,16.837Z",
    transform: "translate(23.161 -9.663)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161794",
    "data-name": "Path 161794",
    d: "M199.278,15.425c-.011-3.529-9.482.858-6.664,5.935,1.729,3.08,6.664-4.345,6.664-5.935Z",
    transform: "translate(32.11 -9.693)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161795",
    "data-name": "Path 161795",
    d: "M199.578,17.952c-.855-3.268-10.245,1.265-9.547,4.476.966,4.55,10.7-.219,9.547-4.476C199.39,17.21,200.463,21.259,199.578,17.952Z",
    transform: "translate(26.167 -2.929)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161796",
    "data-name": "Path 161796",
    d: "M200.885,16.2c-2.991,1.731-10.433,1.579-7.829,6.659,1.07,2.095,8.661,4.465,8.313.721-.318-3.289-2.592-1.752.621-4.158,1.384-1.039,1.53-4.737-1.1-3.222C200.417,16.466,202.1,15.495,200.885,16.2Z",
    transform: "translate(33.306 -5.417)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161797",
    "data-name": "Path 161797",
    d: "M206.908,20.862c-2.078-2.883-7.576-3.112-9.635-.088-1.629,2.36-5.107,3.692-5.625,7.3-.571,4.066,7.415.9,7.967-2.07.671-3.533,1.787-.735,4.306-3.434,1.353.4,4.306.138,2.987-1.71C204.795,17.93,207.625,21.879,206.908,20.862Z",
    transform: "translate(30.773 1.58)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161798",
    "data-name": "Path 161798",
    d: "M209.835,33c-1.6-6.14-13.209-7.108-7.48-.1a1.737,1.737,0,0,0-2.262.445c1.549-3.843-1.71-8.627-4.682-11.559-7.228-7.136-9.808,8.185,1,6.475-2.124,1.773-3.915,4-4.191,6.511-.433,4.1,6.185,1.268,7.35-.473-5.414,11.3,11.23,8.128,6.208.855,1.978.685,4.6,0,4.053-2.155C209.244,30.715,210.2,34.428,209.835,33Z",
    transform: "translate(23.735 4.825)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161799",
    "data-name": "Path 161799",
    d: "M206.4,13.75c-3.3.615-12.239,5.309-4.754,6.518,6.25,1.01,9.221-7.334,4.754-6.518C203.415,14.3,208.12,13.435,206.4,13.75Z",
    transform: "translate(50.955 -10.885)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161800",
    "data-name": "Path 161800",
    d: "M204.944,21.931c.564-2.346,2.933-3.879-.357-7.026-5.882-5.62-9.532,1.946-3.221,5.253-1.047.127-2.987-.332-3.7-.219-3.658.572-1.817,3.925.748,4.419-1.81,1.36-3.773,6.532,1.089,5.38,2.293-.548,10.582-7.991,5.445-7.807C205.013,21.6,205.546,21.9,204.944,21.931Z",
    transform: "translate(42.076 -12.888)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161801",
    "data-name": "Path 161801",
    d: "M200.537,16.029c-3.539.092-2.454,9.178,1.695,9.248,5.26.074,3.731-9.39-1.695-9.248Z",
    transform: "translate(50.018 -5.047)",
    fill: "#d0d028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161802",
    "data-name": "Path 161802",
    d: "M195.368,27.825c-.748-3.441-4.018-1.251-5.475.929-3.754,5.55,6.694,4.712,5.475-.929C195.314,27.613,195.847,30.058,195.368,27.825Z",
    transform: "translate(23.563 20.401)",
    fill: "#d0d028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161803",
    "data-name": "Path 161803",
    d: "M196.657,25.32c-2.047,0-2.047,2.54,0,2.54S198.7,25.32,196.657,25.32Z",
    transform: "translate(40.701 18.596)",
    fill: "#d0d028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161804",
    "data-name": "Path 161804",
    d: "M204.624,18.208c-3.29.989-6.131,1.643-8.32,4.1-1.886,2.141,1.595,3.54,3.7,3.359,5.951-.505,5.966-7.864,4.624-7.461C204.029,18.385,205.693,17.894,204.624,18.208Z",
    transform: "translate(42.516 0.312)",
    fill: "#d0d028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161805",
    "data-name": "Path 161805",
    d: "M209.667,16.709c-.441-2.286-4.5-1.024-5.59,0-1.982,1.89-.648,3.706.2,5.634,3.117,7.076,6.085-2.017,5.387-5.638C209.533,15.985,210.127,19.069,209.667,16.709Z",
    transform: "translate(63.157 -6.462)",
    fill: "#d0d028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161806",
    "data-name": "Path 161806",
    d: "M217.115,18.359c-.748-4.458-7.465,2.063-7.5,4.416-3.9,1.007-3.566,2.985-5.648,4.525-2.465,1.809-8.243,6.327-5.709,9.556,3.06,3.893,8.121-2.215,7.837-4.762,1.553.922.464,7.372,5.425,6.129,6.756-1.71-.368-7.938-2.948-9.559,6.342-.6,9.336-5.6,8.546-10.3C216.9,17.084,217.545,20.878,217.115,18.359Z",
    transform: "translate(47.799 -2.887)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161807",
    "data-name": "Path 161807",
    d: "M204.581,21.869c-1.189-3.43-10.69,2.059-9.49,5.02,1.883,4.748,10.7-1.441,9.49-5.02C204.378,21.283,204.73,22.325,204.581,21.869Z",
    transform: "translate(40.319 7.094)",
    fill: "#d0d028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161808",
    "data-name": "Path 161808",
    d: "M208.329,22.131c-2.251-4.048-8.918-2.9-5.023.94-.4,5.906,8.4,5.126,5.023-.94C207.643,20.891,209.05,23.409,208.329,22.131Z",
    transform: "translate(60.507 4.091)",
    fill: "#d0d028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161809",
    "data-name": "Path 161809",
    d: "M194.54,18.579c-1.8.247-8.312,2.639-6.438,4.871,4.068,4.847,11.859-5.642,6.438-4.871C193.47,18.724,196.069,18.356,194.54,18.579Z",
    transform: "translate(19.856 1.337)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161810",
    "data-name": "Path 161810",
    d: "M202.647,24.645c-1.63-4.387-4.436,3.812-4.375,4.734a2.251,2.251,0,0,0,3.021,1.636c3.094-.89,2.032-4.6,1.353-6.369C202.213,23.451,203.337,26.457,202.647,24.645Z",
    transform: "translate(49.626 13.637)",
    fill: "#5aa445"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_87743",
    "data-name": "Group 87743",
    transform: "translate(133.083 41.387)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161601",
    "data-name": "Path 161601",
    d: "M270.936,49.169c.628-2.667-1.659-4.485-5.154-5.4.949-.61,1.891-1.245,2.861-1.887a2.272,2.272,0,0,0,0-3.717,15.36,15.36,0,0,0-7.558-2.95c3.1-6.1,5.107-13.964-4.424-14.738-5.571-.44-8.493,2.315-10.056,6.1a4.26,4.26,0,0,0-3.079.05,19.738,19.738,0,0,0-8.548,7.3,24.456,24.456,0,0,0-3.823-7.315,3.852,3.852,0,0,0-5.2-.522c-4.663,3.919-5.387,8.485-5.352,13.366-4.165-2.409-7.885-3.994-12.05-3.95,3.393-4.007,5.489-8.372.655-11.964-3.85-2.843-7.906-.409-10.814,2.906-1.406-6.227-2.444-12.693-10.09-15.763-1.884-.767-4.233-.157-4.827,1.579-1.509,4.328-.512,8.819,1.836,12.888a22.979,22.979,0,0,0-5.271.4c-2.663.5-5.011.918-7.066,2.365-.075.057-.171.145-.287.226-.171-4.2-2.547-7.41-6.718-6.542a16.317,16.317,0,0,0-.5-4.95,3.014,3.014,0,0,0-2.97-1.786c-5.632.554-9.2,2.579-11.224,5.737-3.359-5.07-8.309-10.756-13.866-5.957-3.072,2.661-2.192,5.705.068,8.58a32.27,32.27,0,0,0-13.286,5.6c-3.939-6.428-13.845-4.019-20.966,1.057-.546-6.6-1.447-15.687-10.787-12.637-3.612,1.17-4.772,4.309-4.711,7.881a17.878,17.878,0,0,0-9.708-2.025c-2.164.12-3.905,2.013-2.6,3.648,2.164,2.774,4.458,5.46,6.718,8.183a9.682,9.682,0,0,0-4.526,1.346c-3.878-5.3-10.131-5.045-15.948-2.157a21,21,0,0,0-.259-10.624c-.321-1.17-2.041-1.906-3.427-1.573a22.4,22.4,0,0,0-6.861,2.925,18.654,18.654,0,0,0-.6-2.805A2.89,2.89,0,0,0,47.13,20.5a22.169,22.169,0,0,0-6,2.7c-2.369-4.894-6.93-9.951-13.449-6.076-2.656,1.56-2.813,4.258-1.85,7.164-.444-.157-.881-.3-1.359-.421-1.673-.409-3.612.711-3.523,2.132a13.881,13.881,0,0,0,1.079,4.34C16.148,28.11,10.1,27.267,7.9,31.456a3.748,3.748,0,0,0,.1,3.56A30.971,30.971,0,0,0-1.3,37.01c-2.171.805-1.666,3.189,0,4.082,19.225,10.5,44.212,12.4,66.53,15.927,26.093,4.139,51.811,5.944,78.232,7.749,25.185,1.73,50.145,4.875,75.419,5.743,19.2.673,43.434,1.994,57.314-10.486a2.153,2.153,0,0,0,.778-1.453,2.525,2.525,0,0,0,1.01-1.629C278.658,52.465,275.422,49.924,270.936,49.169Z",
    transform: "translate(2.747 29.508)",
    fill: "#2c592b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161602",
    "data-name": "Path 161602",
    d: "M220.264,38.377a28.555,28.555,0,0,0-7.3-.365,2.966,2.966,0,0,1,.218-.371c1.031-1.723-.157-4.183-2.9-4.076a27.264,27.264,0,0,0-5.83.887c.027-.346.048-.692.048-1.088.007-1.849-2.082-2.755-4.137-2.51-5.025.591-8.5,2.51-10.944,5.321a12.133,12.133,0,0,0-6.9-.528,3.033,3.033,0,0,0-1.092-.855c-2.977-1.39-6.534-.994-9.858.019,1.133-3.673,1.8-7.133-.771-10.951-1.208-1.774-4.226-1.5-5.537,0-1.953,2.321-2.56,4.806-3.161,7.529-.082.377-1.475,5-1.126,5.2-1.482-.925-2.492-2.686-4.274-3.321a12.366,12.366,0,0,0-5.366-.774c2.43-2.805,3.461-6.774-.7-9.033-2.922-1.573-5.933-.4-8.513,1.723a37.9,37.9,0,0,0-5.079-11.008c-.99-1.277-3.755-1.893-5.079-.516-3.113,3.189-3.564,6.712-3.222,10.328a22.8,22.8,0,0,0-4.984-3.9c-2.471-1.44-5.086.893-4.615,2.837a16.487,16.487,0,0,0,1.891,4.718,13.224,13.224,0,0,0-6.11-1.3,37.175,37.175,0,0,0-6.848,1.283c.4-2.126-1.734-3.573-4.335-3.252a15.787,15.787,0,0,0-6.233,2.025c-.744-5.233-2.349-10.247-9.4-12.14a3.445,3.445,0,0,0-4.4,2.667,19.69,19.69,0,0,0,.287,4.724,14.054,14.054,0,0,0-8-1.12,2.8,2.8,0,0,0-2.43,3.428,19.676,19.676,0,0,0,3.065,6.674,2.715,2.715,0,0,0-1.393,1.812,14.891,14.891,0,0,0-10.384-3.158c-1.755.107-3.332,1.113-3.284,2.617a13.668,13.668,0,0,0,1.024,4.919,47.022,47.022,0,0,0-8.179.554c-2.738.428-2.547,3.239-.7,4.321A21.919,21.919,0,0,0,63.821,44.44C69.3,48.108,76.908,48.4,83.858,48.579c12.282.3,24.393-1.032,36.655-.277,17.983,1.126,35.931,2.088,53.934,2.56,14.235.371,27.445,1.2,40.219-4.485a2.2,2.2,0,0,0,1.263-1.132c2.035-.1,2.786-.352,5.182-1.673C223.452,42.245,223.493,38.956,220.264,38.377Z",
    transform: "translate(323.691 42.916)",
    fill: "#2c592b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161603",
    "data-name": "Path 161603",
    d: "M413.969,28.11a1.923,1.923,0,0,0-1.775-.918c-.99,0-1.748,0-2.41.013,1.843-4.17-4.226-7.1-10.794-5.888.935-7.334-5.98-8.435-12.541-3.673-2.7-4.623-9.039-.868-13.545,3.585-2.553-2.629-7.8-1.227-12.651.78,1.379-4.963,2.335-11.473-4.595-11a9.4,9.4,0,0,0-7.073,3.806,25.088,25.088,0,0,0-6.363-9.687,3.086,3.086,0,0,0-3.687,0c-6.4,5.529-1.953,12.857,2.915,18.638a59.941,59.941,0,0,0-20.761,2.409c-.642-3.5-3.666-4.862-7.271-4.68,2.492-3.743,3.612-7.8-.1-10.637-4.062-3.07-8.677-.157-12.371,3.611-.116-3.3-1.461-6.045-6.383-6.045-3.864,0-6.691,2.3-8.711,5.177-1.338-4.189-3.905-7.957-9.367-7.089-4.376.692-6.062,3.309-6.561,6.416a11.165,11.165,0,0,0-7.4-2.447c-1.488,0-3.181,1.107-2.977,2.4a29.315,29.315,0,0,0,1.488,5.711,31.952,31.952,0,0,0-17.662,1.17c-.116-5.359-2.164-11.3-10.37-9.9-3.905.667-6.1,2.824-7.128,5.5a15.883,15.883,0,0,0-7.216-4.29c-1.761-.516-3.864.83-3.775,2.3.389,4.636,2.745,8.177,6.083,11.341a30.965,30.965,0,0,0-12.221,3.158,17.563,17.563,0,0,0-.683-6.919c-.532-1.862-3.359-2.158-4.977-1.05a54.921,54.921,0,0,0-5.994,4.982c-.847-6.523-3.823-14.719-11.968-12.807-6.854,1.6-7.885,6.68-6.54,11.806A17.662,17.662,0,0,0,167.2,21.134c-1.5.17-3.106.962-2.956,2.384a10.737,10.737,0,0,0,4.4,7.517c-5.707.22-10.958,1.61-13.8,5.126-3.311-3.151-7.523-6.756-12.576-4.4a8.055,8.055,0,0,0-4.724,6.265c-1.058-1.189-2.157-2.384-3.373-3.516a3.266,3.266,0,0,0-3.932,0c-2.635,2.7-3.011,5.126-2.232,7.429-2.772-.988-5.407-.975-7.284,1.227a5.584,5.584,0,0,0-.7,6.441,6.564,6.564,0,0,0-6.7,3.139c-2.56,4.164.034,7.2,4.124,9.083a6.212,6.212,0,0,0-.9,2.409,15.4,15.4,0,0,0-5.209-1.472c-2.847-.258-7.039-.4-8.254,2.29-.888,2.038.266,3.755,2.294,5.108-4.485,1.164-8.459,3.283-10.746,6.749-1.14,1.717.3,3.434,2.574,3.6a31.654,31.654,0,0,0,4.021.031c-.232,1.126.375,2.321,2.389,3.447,6.158,3.434,18.454,1.761,25.329,1.466C167.933,83.8,206.445,73.248,244.4,66.429c48.165-8.655,97-14.933,145.377-22.915a62.406,62.406,0,0,0,25.984-10.662C419.546,30.117,417.2,28.708,413.969,28.11ZM124.335,55.969a51.677,51.677,0,0,1,5.277,2.824,13.917,13.917,0,0,0-6.042-.673C121,54.912,121.249,54.17,124.335,55.969Z",
    transform: "translate(567.728 -1.346)",
    fill: "#2c592b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161604",
    "data-name": "Path 161604",
    d: "M359.008,17.359a2.56,2.56,0,0,0-1.741-1.44c-.082-5.328-.594-11.907-7.653-11.907-4.963,0-7.38,3.843-8.554,8.177-.41-.4-.867-.843-1.345-1.283a3.653,3.653,0,0,0-4.322,0,25.23,25.23,0,0,0-4.349,4.73c-2.751-2.246-6.868-1.679-10.473.7-2.567-2.7-7.162-1.7-11.026.6-1.823-4.189-5.2-8.334-11.06-7.705-6.431.692-6.7,6.076-5.926,10.788-5.455-1.642-10.514.088-17.061,1.749a5.5,5.5,0,0,0-5.892-4.384c.457-2.8-.109-5.447-3.373-6.573-6.267-2.2-9.292,2.793-11.21,7.309-2.431-2.906-5.946-5.3-10.22-4.422-6.261,1.289-5.318,6.02-3.243,10.02-4.581-.082-8.213,1.4-8.541,3.894-4.554-.692-9.292-.34-11.244,1.5-4.287-2.409-9.066-3.7-14.289-1.384-3.721,1.661-3.093,4.208-1.222,6.491A12.07,12.07,0,0,0,196.912,40a2.162,2.162,0,0,0-.293,1.554c-5.4,1.157-10.186,3.258-12.951,7.655a2.158,2.158,0,0,0,1.673,3.3c6.841.849,13.129-.315,19.293-2.264-.075.465-.164.981-.239,1.547-.218,1.283,1.434,2.2,2.82,2.264,6.841.327,13.449-.811,20.174-1.252-.266,1.34.833,2.749,2.744,2.73,31.3-.434,61.553,10.133,93.06,10.033,11.838-.019,24.748-1.837,33.173-9.039C367.883,46.677,363.787,28.6,359.008,17.359Z",
    transform: "translate(1087.096 -4.011)",
    fill: "#367137"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_87745",
    "data-name": "Group 87745",
    transform: "translate(147.24 49.774)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161605",
    "data-name": "Path 161605",
    d: "M23.73,13.108a7.759,7.759,0,0,0-2.772,4.221c-.853-2.233-5.086-7.278-8.6-4.353-3.236,2.68,2.553,5.2,2.983,7.076-3.571-2.667-9.811-1.044-5,1.856C7.857,20.984,3.187,17.247.92,20.487-3.893,27.343,16.7,26.726,12.554,23.1c2.977,1.459,9.066.346,9.012-3.076,5.605,6.227,9.251-12.241,2.164-6.919C22.535,14,25.355,11.863,23.73,13.108Z",
    transform: "translate(5.682 30.328)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161606",
    "data-name": "Path 161606",
    d: "M21.094,13.169c.437-4.837-12.712,5.233-6.247,5.743-.888.3-10.7,6.038-10.773,6.2-5.414,10.121,8.9,8.014,4.929,1.56a7.033,7.033,0,0,0,3.229-.151c-4.192,1.113.58,6.825,4.26,5.68,5.2-1.642-.328-5.906-3.68-5.762,2.861-.516,9.176-6.278,3.946-7.768a6.342,6.342,0,0,0,4.335-5.5C21.189,12.113,20.916,15.289,21.094,13.169Z",
    transform: "translate(21.111 29.116)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161607",
    "data-name": "Path 161607",
    d: "M17.783,14.235C15.3,9.48,11.584,17.871,11.5,19.2c-1.1-6.586-10.9,2.076-2.956,2.434,3.332.145,11.743-2.617,9.237-7.4C17.025,12.782,18.964,16.475,17.783,14.235Z",
    transform: "translate(36.452 34.045)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161608",
    "data-name": "Path 161608",
    d: "M8.575,14.214c-3.161,0-3.161,3.944,0,3.944C11.757,18.158,11.757,14.214,8.575,14.214Z",
    transform: "translate(40.75 41.576)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161609",
    "data-name": "Path 161609",
    d: "M4.768,14.974C3.874,12.653-.673,13.71-.673,15.987c0,4.768,9.223.793,5.441-1.013C4.734,14.886,5.683,15.421,4.768,14.974Z",
    transform: "translate(0.673 38.709)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161610",
    "data-name": "Path 161610",
    d: "M21.477,14.934c-2.6-2.352-10.643-.088-11.968,2.8-3.837,8.24,17.389,2.051,11.968-2.8C20.2,13.77,22.228,15.6,21.477,14.934Z",
    transform: "translate(57.281 40.202)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161611",
    "data-name": "Path 161611",
    d: "M37.217,14.655c-1.72-4.076-6.82-.761-7.715,1.711-2.492-2.8-12-7.1-9.394-.044C15.5,15.1,6.748,17.448,13.786,21.178c-4.615-.239-9.592,4.661-2.1,4.541,1.386-.031,8.957-2.107,6.581-3.378,3.216.17,5.892-1.359,8.759-1.8-.02-.019,5.441,1.692,3.632,2.107-5.762,1.264.874,8.083,3.5,3.906,1.386-2.233-1.106-3.221,1.256-4.7,2.553-1.6,2.751-4.963,1.8-7.2C36.4,12.693,38.152,16.838,37.217,14.655Z",
    transform: "translate(50.293 32.417)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161612",
    "data-name": "Path 161612",
    d: "M17,13.556c-8.725.459-1.85,3.85-4.206,4.793,1.017-.4,7.995-4.994,4.206-4.793C15.792,13.625,17.949,13.512,17,13.556Z",
    transform: "translate(76.982 38.039)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161613",
    "data-name": "Path 161613",
    d: "M32.6,24.687c-1.6-2.906-.888-6.8-2.622-10.3-3.113-6.208-6.773,1.937-3.543,6.24-9.346-1.6-12.357,5.535-1.959,6.158-5.851,8.46,12.009,5.051,8.124-2.1C32.536,24.593,34.1,27.474,32.6,24.687Z",
    transform: "translate(109.093 30.6)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161614",
    "data-name": "Path 161614",
    d: "M28.36,12.052c-2.874.862-12.084,8.347-6.22,10.536,8.752,3.246,11.62-12.127,6.22-10.536C25.6,12.876,30.026,11.555,28.36,12.052Z",
    transform: "translate(122.451 29.523)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161615",
    "data-name": "Path 161615",
    d: "M27.109,15.362c-3.366-2.875-8.377-.855-5.919,2.856,3.9,5.875,11.429,1.893,5.919-2.856C25.744,14.2,28.454,16.532,27.109,15.362Z",
    transform: "translate(124.255 40.441)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161616",
    "data-name": "Path 161616",
    d: "M33.617,13.6c-3.059-1.409-16.051.346-11.094,4.378,3.885,3.158,16.713-1.761,11.094-4.378C31.671,12.7,35.016,14.265,33.617,13.6Z",
    transform: "translate(129.34 35.808)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161617",
    "data-name": "Path 161617",
    d: "M29.75,16.822c-1.263-1.648-9.162-4.189-6.9-.264,1.83,3.17,8.3,2.095,6.9.264C28.794,15.6,30.365,17.646,29.75,16.822Z",
    transform: "translate(135.377 42.981)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161618",
    "data-name": "Path 161618",
    d: "M42.794,20.078c3.878-1.434.02-6.837-2.526-7.743-5.421-1.944-2.861,6.127-1.154,7.6-5.83-2.761-5.284.252-8.834,1.277-14.378.535-2.13,8.781,3.3,3.491,1.932-1.491,1.3-.642,4.738-.642,5.25.025,3.973-.981,4.479-3.982C42.992,20.015,42.719,20.531,42.794,20.078Z",
    transform: "translate(141.723 30.045)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161619",
    "data-name": "Path 161619",
    d: "M34.832,15.7c.908-3.409-10.1-1.013-10.063,2.667.041,4.793,11.893.925,10.063-2.667C35.01,14.982,35.174,16.378,34.832,15.7Z",
    transform: "translate(148.926 40.746)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161620",
    "data-name": "Path 161620",
    d: "M31.814,13.257c-2.226.937-8.9,7.391-1.679,6.925,5.687-.346,6.035-8.75,1.679-6.925C29.944,14.056,33.685,12.477,31.814,13.257Z",
    transform: "translate(161.161 35.143)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161621",
    "data-name": "Path 161621",
    d: "M33.523,17.223c-1.639-4.3-7.121-3.793-7.073.811.055,6.139,9.353,5.089,7.073-.811C33.045,16,34.09,18.7,33.523,17.223Z",
    transform: "translate(158.722 41.888)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161622",
    "data-name": "Path 161622",
    d: "M31.789,15.535c-1.393-1.573-4.171-1.428-4.021.635.191,2.472,6.062,1.673,4.021-.635C31.291,14.95,33.257,17.2,31.789,15.535Z",
    transform: "translate(166.368 42.948)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161623",
    "data-name": "Path 161623",
    d: "M50.523,18.275c-.5-8.819-11.8-3.982-4.861,3.541.819-.352-17.512-5.793-9.974,1.723-.307.006-11.62,2.22-4.888,3.73,2.779.629,9.128-1.39,11.586-2.164-3.81,5.321,2.956,6.378,5.728,1.824a45.837,45.837,0,0,0,2.41-8.655C50.454,16.942,50.611,19.766,50.523,18.275Z",
    transform: "translate(171.625 37.987)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161624",
    "data-name": "Path 161624",
    d: "M38.14,15.5c-1.024.082-9.968-2.415-4.834,2.686,4.813,4.755,10.541-3.126,4.834-2.686C38.017,15.5,40.325,15.332,38.14,15.5Z",
    transform: "translate(189.476 45.497)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161625",
    "data-name": "Path 161625",
    d: "M55.61,18.627c-7.79,2.107-4.021,3.2-7.025,6.227-.253-1.981-2.895-2.214-.608-3.422,2.144-1.132,4.4-3.868,3.284-6.038-2.983-5.674-13.245-.05-8.841,5.372-2.608.283-5.837-4.466-8.814-1.969-4.24,3.548,5.3,6.844,8.52,6.189-1.994,4.762,3.468,7.385,5.987,2.308.232,7.429,12.091,2.554,5.7-1.944,4-.805,6.711-8.058,1.8-6.724C53.582,19.174,57.494,18.111,55.61,18.627Z",
    transform: "translate(194.201 35.295)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161626",
    "data-name": "Path 161626",
    d: "M62.856,19.986c.471-6.988-7.38-9.077-5.264-1.409,1.126,4.114,8.711,6.686,5.264,1.409C63.013,17.759,63.321,20.709,62.856,19.986Z",
    transform: "translate(338.08 38.899)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161627",
    "data-name": "Path 161627",
    d: "M67.74,20.319c-2.492-11.2-17.908-3.095-4.984-.05-.191.107-11.79,4.334-4.526,5.548,3.216.541,10.056-3.044,9.51-5.5Z",
    transform: "translate(329.987 43.491)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87744",
    "data-name": "Group 87744",
    transform: "translate(378.782 64.403)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161628",
    "data-name": "Path 161628",
    d: "M55.306,16.355c-.369-.082.089.094,0,0Z",
    transform: "translate(-52.76 -11.62)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161629",
    "data-name": "Path 161629",
    d: "M60.933,18.626c-1.365-6.705-10.514-.566-3.516,1.7,1.447.371,4.014.736,3.516-1.7C60.831,18.161,61.288,20.394,60.933,18.626Z",
    transform: "translate(-54.809 -15.583)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161630",
    "data-name": "Path 161630",
    d: "M55.194,16.349c.075.025-.055-.044,0,0Z",
    transform: "translate(-52.647 -11.614)",
    fill: "#367137"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_161631",
    "data-name": "Path 161631",
    d: "M65.73,15.068c-7.271,1.315-12.555,8.259-3.011,11.473,4.048,1.365,1.83-4.787,3.734-5.617,2.533-1.107,3.816-6.7-.724-5.856C63.491,15.465,67.294,14.785,65.73,15.068Z",
    transform: "translate(339.985 45.641)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161632",
    "data-name": "Path 161632",
    d: "M83.017,15.593c-2.54-3.837-6.827,4.453-3.9,7.705a9.858,9.858,0,0,0-5.516.767c.765-1.346-8.391-3.535-10.145-3.378-9.162.837.621,7.051,6.725,5.472-4.622,4.107,7.667,4.032,10.643,1.5,5.154-4.4,5.974-6.34,2.192-12.071C82.129,14.266,84.443,17.77,83.017,15.593Z",
    transform: "translate(352.553 43.619)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161633",
    "data-name": "Path 161633",
    d: "M79.85,19.837a26.243,26.243,0,0,0-7.011,1.038c.382-3.5-1.475-9.989-6.042-4.441-3.161,3.843.9,5.95-1.85,9.448-4.827,6.152,3.263,9.265,4.758,3.277.553-2.208-1.365-6.4,2.6-3.919-4.042.453,1.57,7.057,2.826,7.926,4.417,3.063,6.472-7.41-.177-7.781,2.151-.315,11.258-5.755,4.9-5.548C77.563,19.9,81.85,19.768,79.85,19.837Z",
    transform: "translate(374.195 41.897)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161634",
    "data-name": "Path 161634",
    d: "M75.291,18.581c-2.4-2.409-6.581-3.755-9.169-1.013-2.847,3,12.118,4.007,9.169,1.013C73.939,17.229,76.267,19.575,75.291,18.581Z",
    transform: "translate(387.786 51.267)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161635",
    "data-name": "Path 161635",
    d: "M80.981,22.9c4.1-9.548-10.4-10.957-4.39.9-18.413-2.132-4.649,9.919.969,1.56a2.081,2.081,0,0,0,2.465,1.315c1.154-.629.546-2.824.956-3.774C82.142,20.192,80.844,23.255,80.981,22.9Z",
    transform: "translate(396.904 47.418)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161636",
    "data-name": "Path 161636",
    d: "M87.479,20.107c-1.639-2.415-14.439-4.85-17.389-2.529C64.909,21.7,90.039,23.925,87.479,20.107Z",
    transform: "translate(408.907 54.421)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161637",
    "data-name": "Path 161637",
    d: "M78.388,16.414c-2.028.05-5,2.617-5.53,4.34-2.021,6.271,14.535-4.6,5.53-4.34C77.979,16.421,80.191,16.351,78.388,16.414Z",
    transform: "translate(428.143 53.076)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161638",
    "data-name": "Path 161638",
    d: "M83.087,16.785c-1.939.327-9.49,1.679-9.544,4.045-.034,1.535,1.638,1.573,2.922,1.189,4.834,3.938,12.63-6.3,6.622-5.233C79.987,17.314,84.937,16.446,83.087,16.785Z",
    transform: "translate(433.132 54.749)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161639",
    "data-name": "Path 161639",
    d: "M77.922,16.246c-2.041,0-2.041,2.541,0,2.541S79.977,16.246,77.922,16.246Z",
    transform: "translate(449.732 52.326)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161640",
    "data-name": "Path 161640",
    d: "M112.5,14.98c-2.71-.239-2.874-.893-6.1-1.315-1.912-.239-11.811,1.95-6.554,4.233a18.16,18.16,0,0,0,8.978,1.384c1.591-.189,8.513-3.887,3.68-4.3C111.867,14.929,113.608,15.08,112.5,14.98Z",
    transform: "translate(577.494 38.578)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161641",
    "data-name": "Path 161641",
    d: "M109.3,15.492c-2.232-1.1-17.013-1.893-11.968,1.3,3.782,2.34,14.637,0,11.968-1.3C105.9,13.831,110.682,16.152,109.3,15.492Z",
    transform: "translate(565.701 43.223)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161642",
    "data-name": "Path 161642",
    d: "M133.453,17.958a9.366,9.366,0,0,0-7.175-2c.956-1.566,7.885-3.378,3.851-5.869-5.346-3.3-7.735,6.617-9.319,7.227.512-11.165-12.446-4.063-9.906,3.554-12.692-10.089-15.4,3.428-1.044,5.384C101.871,26.921,97.3,38,106.745,34.3c-2.533,8.756,6.158,6.944,4.779-.283,5.585,5.007,9.121-2.258,5.994-6.3,6.356,3.422,20.167,2.906,10.63-4.46,1.782-.66,8.234-2.881,5.3-5.3C131.3,16.178,134.607,18.92,133.453,17.958ZM114.91,20.115a4.4,4.4,0,0,1,.669-3.611A11.518,11.518,0,0,1,114.91,20.115Z",
    transform: "translate(588.406 16.213)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161643",
    "data-name": "Path 161643",
    d: "M110.449,18.934c6.295-2.308-7.995-6.856-9.517-7.454-3.7-1.44-2.97,2.7-2.26,3.843,1.8,2.831,6.11,4.24,9.933,3.963-2.649,1.132-9.811,2.277-6.909,5.68,5.189,6.1,14.166-5.378,8.752-6.032C111.2,18.657,111.678,19.085,110.449,18.934Z",
    transform: "translate(576.209 25.522)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161644",
    "data-name": "Path 161644",
    d: "M104.9,13.035c-3.181-1.472-.928,7.913.273,8.655,4.451,2.761,4.212-6.542-.273-8.655C103.791,12.538,108.536,14.745,104.9,13.035Z",
    transform: "translate(606.352 34.509)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161645",
    "data-name": "Path 161645",
    d: "M152.088,15.879c-.451-2.673-11.586-.226-9.572,3.277-5.441-1.774-5.414,1.856-8.6.6,11.77-5.516,3.946-12-5.68-4.221-1.195-4.177-10.978-12.907-9.92-3.478-6.083-5.032-14.5-.648-4.991,4.491-10.835.447-10.48,6.774.43,7.127-6.295,1.025-13.545,8.894-3.011,7.026,5-.874,10.766-5.29,4.444-7.057a17.912,17.912,0,0,0,5.673-.855c-1.427,2.176-5.475,8.328-2.342,10.574,5.257,3.8,9.408-6.233,9.776-8.687,2.492,1.271,17.942,2.856,12-1.5,2.669.755,8.247.8,4.636-2.661,1.659.094,11.128-1.9,7.155-4.636C152.027,15.464,152.743,16.338,152.088,15.879Z",
    transform: "translate(618.707 7.838)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161646",
    "data-name": "Path 161646",
    d: "M109.647,12.741c-.212.6-7.6,11.171-.812,8.422a8.306,8.306,0,0,0,4.827-5.617c.717-2.485-2.8-6.41-4.014-2.805C109.414,13.458,110.3,10.8,109.647,12.741Z",
    transform: "translate(622.111 26.085)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161647",
    "data-name": "Path 161647",
    d: "M112.625,11.773c-4.5-3.321-3.83,3.881-2.69,5.108,6.226,6.774,7.312-1.736,2.69-5.108C112.031,11.327,115.233,13.667,112.625,11.773Z",
    transform: "translate(640.297 24.077)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161648",
    "data-name": "Path 161648",
    d: "M127.144,9.031c-3.045.359-16.221-3.378-14.241,4.409,1.024,4,10.357,2.485,13.1,1.088,1.488-.774,6.124-6.089,1.14-5.5C126.748,9.094,128.3,8.9,127.144,9.031Z",
    transform: "translate(661.314 11.051)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161649",
    "data-name": "Path 161649",
    d: "M126.1,9.934c1,0-19.532-6.466-13.927.5,2.512,3.12,7.38,4.56,11.831,3.774,1.9-.327,7.394-3.994,2.1-4.277Z",
    transform: "translate(652.581 4.492)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161650",
    "data-name": "Path 161650",
    d: "M122.243,9.984c-3.393.579-15.074,8.221-8.52,10.762,8.09,3.107,14.241-11.712,8.52-10.762C117.5,10.783,124.08,9.688,122.243,9.984Z",
    transform: "translate(655.837 18.923)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161651",
    "data-name": "Path 161651",
    d: "M117.918,12.989c-4.1-16.681-16.426,2.692-5.264,5.007.847.17,1.01-.61,1.106-1.044,2.547,4.145,4.649-2,4.158-3.963C117.256,10.266,118.328,14.612,117.918,12.989Z",
    transform: "translate(634.464 -0.418)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161652",
    "data-name": "Path 161652",
    d: "M175.047,24.71c6.056-1.428-1.044-7.309-4.424-5.894,1.714-1.289,4.513-7.951.457-8.6-3.734-.623-3.775,5.271-4.185,6.328a43.564,43.564,0,0,0-1.925-8.963c-1.536-4.925-5.721,2.107-4.984,4.818-5-4.277-13.736-.667-8.978,4.7-2.478-.591-11.763-1.535-10.6,2.717,1.174,4.321,7.817.421,10.459.289-4.253,2.7-2.389,5.85,2.99,5.17-1.256.95-3.2,3.717-4.97,4.447-.43,1.717-1,2.239-1.741,1.541-1.154-.616-5.4-1.824-5.789.352-3.373-2.025,5.387-11.624-5.1-12.612,2.028-2.365,3.318-8.6-2.683-5.925-4.9,2.17-5.858,4.535-7.872,8.051-2.826-1.289-4.875-7.039-8.288-9.1-5.557-3.39-2.888,6.862-1.229,8.46,2.226,2.113,4.642,2.843,7,4.957-2.642-.025-5.5,3.994-6.411,5.51-4.117,6.925,3.557,10.618,8.063,3.4,3.5,3.283,2.69.264.485,3.667-1.331,2.025-.744,5.466,2.929,4.686,2.54-.541,1.748-4.642,1.236-5.894,5.564,1.327,4.683-2.787,3.168-5.623,1.475.541,17.723,10.706,16.228,2.648,4.574,2.541,10.575-7.907,6.923-8.938,4.028-1,7.23-4.579,7.339-7.624a39.8,39.8,0,0,0,6.929,1.856c-.874,1.132-.628,2.132.683,3.013-3.536,1.516-8.452-4.076-8.589,2.17-1.065,1.988-4.485,5.214-2.574,7.4,3.12,3.573,6.9-2.132,7.619-4.076,5.639,3.491,16.412,1.623,7.824-2.937C175.286,24.641,177.846,26.176,175.047,24.71Z",
    transform: "translate(669.31 -2.566)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161653",
    "data-name": "Path 161653",
    d: "M143.937,24.693c-.669-4.076-4.581-4.114-4.916-7.831-.4-4.346-3.106-3.862-6.718-2.264,1.837-8.284-10.848-13.052-8.821-3,.655,3.214,6.472,7.762,10.514,6.29-1.632,2.485-9.531,1.6-3.577,6.63,2.164,1.83,14.446,5.623,13.518.176C143.48,21.957,144.108,25.725,143.937,24.693Z",
    transform: "translate(722.861 -2.272)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161654",
    "data-name": "Path 161654",
    d: "M151.318,14.389a13.383,13.383,0,0,0-8.4-.4,8.393,8.393,0,0,0-2.28-5.277c-5.311-5.114-7.885,2.227-4.349,5.592-3.011-.906-12.815,2.39-7.7,4.774,2.062.962,12.76,1.239,12.234-1.868,3.844,7.479,13.32-2.069,10.5-2.818C148.608,13.659,152.561,14.716,151.318,14.389Z",
    transform: "translate(745.41 3.157)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161655",
    "data-name": "Path 161655",
    d: "M153.613,19.2c-1.195-5.667-7.257.264-3.229-5.787,4.376-6.573-5.366-3.258-8.445-1.05-1.01-1.981-7.455-8.687-10.719-4.906-4.1,4.7,6.807,7.083,7.489,8.9-2.942-.138-5.509,5.843-2.628,6.995,3.536,1.422,7.455-4.328,4.506-5.68,1.208.226,14.405,8,13.026,1.528C153.32,17.769,153.839,20.178,153.613,19.2Z",
    transform: "translate(763.869 -0.16)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161656",
    "data-name": "Path 161656",
    d: "M140.688,6.789c-1.277.711-8.056,7.743-4.2,8.542,9.49,1.969,7.96-10.687,4.2-8.542C138.367,8.072,142.2,5.933,140.688,6.789Z",
    transform: "translate(793.098 0.996)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161657",
    "data-name": "Path 161657",
    d: "M143.846,7.26c-.655.308-9.148,3.8-6.6,5.774,6.1,4.674,11.859-8.158,6.6-5.774C142.57,7.845,145.321,6.593,143.846,7.26Z",
    transform: "translate(801.593 3.21)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161658",
    "data-name": "Path 161658",
    d: "M243.019,10.716c1.133-8.026-6.458-6.416-5.906,1.289.116,1.78-5.209,4.567-6.65,8.108-1.72-11.643-16.126-1.956-3.837,2.453-7.148-1.749-14.74.673-20.7,3.548-4-9.41-9.756-2.007-4.909,3.208-2.123.566-4.076-2.409-5.148-3.1-7.134-4.529-11.941,1.6-4.656,5.642-1.1.554-7.5,6.4-1.311,6.02,4.608-.3,8.07-2.447,11.627-4.573.928,6.693,7.851,10.75,6.882,1.547,9.251,1.692,12.255-3.925,3.045-5.969,4.014-4.2,6.486,1.39,13.163-1.019-5.113,11.781,4.861,11.171,6.923,1.094,9.729,5.026,15.218-1.528,3.291-4.7a8.215,8.215,0,0,0,4.752-5.932c.635-3.277,2.97-4.246,3.434-7.611C243.278,8.823,242.787,12.276,243.019,10.716Z",
    transform: "translate(1095.677 -4.989)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161659",
    "data-name": "Path 161659",
    d: "M195.621,10.485c-2.417-.585-11.449-3.158-10.186,1.522,1.741,5.957,15.307-.315,10.186-1.522C194.344,10.164,197.526,10.925,195.621,10.485Z",
    transform: "translate(1084.443 15.333)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161660",
    "data-name": "Path 161660",
    d: "M203.829,6.862c-2.581.591-14.043,7.888-5.762,8.41,7.216.465,10.029-9.366,5.762-8.41C201.467,7.409,205.106,6.573,203.829,6.862Z",
    transform: "translate(1141.516 2.337)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161661",
    "data-name": "Path 161661",
    d: "M223.4,12.348c-.942-1.774-3.011.56-4.554-1.17-2.7-2.994-17.771-5.472-14.31-.006-1.461-.3-12.924-.4-7.837,2.881,3.475,2.246,5.755,0,9.257.554-2.321.478-9.654,1.723-10.343,4.183-1.085,4,5.981,3.139,8.411,2.17,2.615-1.025,3.871-2.956,6.131-4.227,1.256-1.208.99-2.051-.86-2.535-2.253.83-2.922.44-1.98-1.17a21.308,21.308,0,0,0,6.144,2.252C202.812,26.337,227.84,21,223.4,12.348,223,11.606,224.44,14.4,223.4,12.348Z",
    transform: "translate(1143.264 8.369)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161662",
    "data-name": "Path 161662",
    d: "M201.913,8.792c-4.492-.906-.785,7.007-1.133,8.07-.915,2.912,5.653,5.95,6.868,2.4,1.311-3.768-.355-9.347-5.735-10.467C199.981,8.408,207.245,9.9,201.913,8.792Z",
    transform: "translate(1168.105 12.51)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161663",
    "data-name": "Path 161663",
    d: "M245.195,28.69c-4.4-4.585-7.482-1.453-10.09-5.095,3.106.4,2.908-1.837,2.963-3.46,10.166,2.384,6.67-17.455-3.331-5.994-1.584-2.428-10.671-5-7.981-.862,1.5,2.29,4.622,5.516,5.325,7.353-3.611-2.371-11.572-1.629-9.633,3.5-3.134-2.56,2.745-10.6-8.821-6.384,4.205-2.189,2.533-14.53-3.113-12.09-3.748,1.617-1.242,13.429,2.71,12.234-2.314.95-2.492,2.837-4.956,3.233.109-6.894-10.261-10.442-9.524-1.591.3,3.384,8.6,6.422,12.173,6.46a14.3,14.3,0,0,0,8.978,5.5c-.437,1.6-.628,5.158,1.045,6.435a3.836,3.836,0,0,0,4.731.013c.751-1.673,1.966-1.673,3.652.063,4.608.4,7.3-4.856,8.042-7.592,3.823,7.561,13.852,4.56,7.831-1.723C243.938,27.407,246.41,29.98,245.195,28.69Zm-13.62.352c-1.5,1.208-2.5,2.755-4.049,3.975-.4-1.925-2.219-5-3.216-6.724,2.192,1.44,5.428,1.39,7.892.572-.218.723-.444,1.453-.628,2.176C231.561,29.062,231.759,28.275,231.575,29.043Z",
    transform: "translate(1162.475 -5.344)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161664",
    "data-name": "Path 161664",
    d: "M210.847,10.293c.3-3.2-6.854-3.4-6.206.113.526,2.931,7.189,2.893,6.206-.113C210.9,9.935,211.148,11.212,210.847,10.293Z",
    transform: "translate(1196.823 7.807)",
    fill: "#367137"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_87746",
    "data-name": "Group 87746",
    transform: "translate(149.767 42.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161665",
    "data-name": "Path 161665",
    d: "M9.842,12.359C4.982,8.107,8.19,18.31,8.1,17.945-.61,13.919.066,23.638,7.651,22.814c6.076-.66,5.776-7.322,2.192-10.454C8.368,11.083,11.74,14.007,9.842,12.359Z",
    transform: "translate(12.352 33.404)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161666",
    "data-name": "Path 161666",
    d: "M5.954,14.832c-.478-.226-6.165-4.479-5.038-.44,1.386,5.032,7.332,1.516,5.038.44C5.818,14.763,6.971,15.31,5.954,14.832Z",
    transform: "translate(6.545 40.48)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161667",
    "data-name": "Path 161667",
    d: "M7.718,14.169C5.458,12.66-3.2,12.949.686,15.692c2.055,1.44,8.944-.245,7.032-1.522C5.875,12.949,8.749,14.861,7.718,14.169Z",
    transform: "translate(0.303 43.677)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161668",
    "data-name": "Path 161668",
    d: "M9,14.521c.833-2.768-7.134-.516-7.1,2.17.007,3.73,7.858,1.227,7.1-2.17C9.241,13.7,9.166,15.389,9,14.521Z",
    transform: "translate(13.11 43.64)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161669",
    "data-name": "Path 161669",
    d: "M10.1,16.989c-1.154-3.057-8.616-5.774-6.629-2.478-.328,4.68,7.954,5.944,6.629,2.478C9.281,14.863,10.742,18.65,10.1,16.989Z",
    transform: "translate(20.347 42.329)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161670",
    "data-name": "Path 161670",
    d: "M9.568,11.916c-2.294.157-9.176,4.032-4.759,5.8,5.748,2.29,8.944-6.064,4.759-5.8C6.9,12.105,11.138,11.816,9.568,11.916Z",
    transform: "translate(21.652 36.439)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161671",
    "data-name": "Path 161671",
    d: "M9.866,12.514c-1.038.239-8.8,4.466-3.891,5.051,5.8.723,7.421-5.862,3.891-5.051C8.173,12.9,11,12.25,9.866,12.514Z",
    transform: "translate(27.484 39.351)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161672",
    "data-name": "Path 161672",
    d: "M9.262,13.121c-2.383-2.673-5.871,4.2-.628,5.724,3.4.969,1.406-4.869.628-5.724C8.559,12.322,10.457,14.448,9.262,13.121Z",
    transform: "translate(36.445 39.694)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161673",
    "data-name": "Path 161673",
    d: "M11.949,13.654c-2.007-.686-9.961.566-5.571,2.831,3.475,1.8,8.582-1.824,5.571-2.831C10.481,13.157,12.768,13.93,11.949,13.654Z",
    transform: "translate(31.648 44.753)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161674",
    "data-name": "Path 161674",
    d: "M12.9,13.511c-1.481-.107-8.589.245-6.131,3.038,4.042,4.629,10.876-2.692,6.131-3.038C11.021,13.367,14.387,13.606,12.9,13.511Z",
    transform: "translate(38.522 44.738)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161675",
    "data-name": "Path 161675",
    d: "M22.272,20.016c.492.289,1.918-5.29,1.529-6.517-1.038-3.164-5.482,1.069-5.12,3.114-5.5-5.655-10.248-1.189-4.4,2.113-6.3-1.528-7.4,3.321-1.953,4.183,2.7.409,7.824-2.415,3.693-3.673a4.689,4.689,0,0,0,1.871-.742c-.594-.371,3.83,1.484,3.059,1.384-12.821,4.667,14.856,8.353,1.318.138C22.128,19.934,24.4,21.306,22.272,20.016Z",
    transform: "translate(53.508 38.919)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161676",
    "data-name": "Path 161676",
    d: "M15.1,12.348c-3.4-3.5-5.905,8.85-1.557,8.366,4.622-.491,3.618-6.221,1.557-8.366C14.36,11.6,17.1,14.424,15.1,12.348Z",
    transform: "translate(67.517 35.535)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161677",
    "data-name": "Path 161677",
    d: "M13.39,13.313c-3.55-1.107-1.57,4.906-.976,5.529,2.656,2.78,6.377-3.875.976-5.529C12.182,12.917,15.889,14.074,13.39,13.313Z",
    transform: "translate(68.07 43.225)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161678",
    "data-name": "Path 161678",
    d: "M26.579,19.2c2.936-.648,2.738-4.919,2.191-6.636-1.1-3.434-5.994,3.491-4.342,6.548-6.711-3.5-6.779,3.724-.853,4.328,4.956.516,2.226-3.227,3-4.24C26.7,19.173,26.34,19.519,26.579,19.2Z",
    transform: "translate(114.277 35.032)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161679",
    "data-name": "Path 161679",
    d: "M28.43,12.217c-3.564.277-12.139,7.12-5.393,8.315,5.182.887,10.213-8.674,5.393-8.315C26.4,12.374,29.57,12.135,28.43,12.217Z",
    transform: "translate(121.657 38.051)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161680",
    "data-name": "Path 161680",
    d: "M30.47,13.265c-2.055-.572-11.429.849-7.995,3.881,1.577,5.592,14.05-2.176,7.995-3.881C27.6,12.453,31.924,13.667,30.47,13.265Z",
    transform: "translate(128.67 42.173)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161681",
    "data-name": "Path 161681",
    d: "M29.548,14.851c-1.154-2.6-6.786-.83-8.37.365-7.7,5.843,11.5,6.491,8.37-.365C29.131,13.908,30.319,16.518,29.548,14.851Z",
    transform: "translate(114.77 44.983)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161682",
    "data-name": "Path 161682",
    d: "M30.431,13.741c-3.25-5.189-9.394-.025-2.833,3.956,1.359,3.655,4.875-.717,2.833-3.956C29.742,12.609,31.087,14.779,30.431,13.741Z",
    transform: "translate(145.947 34.639)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161683",
    "data-name": "Path 161683",
    d: "M36.672,16.664c-.812.063-1.625.132-2.43.176,3.953-10.353-22.311,1.434-3.523,1.34-4.137,2.158-3.113,5.982,2.267,4.516,1.208-.333,7.646-5.724,3.687-6.032C35.86,16.6,38.133,16.771,36.672,16.664Z",
    transform: "translate(141.173 40.069)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161684",
    "data-name": "Path 161684",
    d: "M29.283,12.811c-6.117,2.4-1.775,8.781-.778,6.743-.43.918,8.868-9.945.778-6.743C26.367,13.95,30.8,12.195,29.283,12.811Z",
    transform: "translate(154.032 38.154)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161685",
    "data-name": "Path 161685",
    d: "M33.916,14.231c-2.212-1.673-9.025-1.044-7,2.277,3.154,5.24,11.49,1.132,7-2.277C32.435,13.111,34.865,14.961,33.916,14.231Z",
    transform: "translate(156.73 44.069)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161686",
    "data-name": "Path 161686",
    d: "M40.448,18.747c6.609-4.17-16.788-9.007-5.257-.1-6.766-.453-7.4,6.372-.218,4.51,1.953-.5,8.111-2.025,5.475-4.409C41.164,18.3,40.6,18.91,40.448,18.747Z",
    transform: "translate(175.985 45.61)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161687",
    "data-name": "Path 161687",
    d: "M36.969,13.964c-2.861.522-8.1,6.712-3.543,6,5.448,1.3,8.7-6.995,3.543-6C34.333,14.461,38.655,13.63,36.969,13.964Z",
    transform: "translate(186.414 46.946)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161688",
    "data-name": "Path 161688",
    d: "M47.793,14.153A6.392,6.392,0,0,0,41.573,17.8c-2.144-1.2-2.055-2.447-3.714-4.145-2.376-2.409-6.1,4.151-.765,6.517-6.22,1.107-4.547,6.579,1.249,4.7,3.625-1.189,2-2.849,3.577-4.567,2.97,3.044,12.972-5.825,5.871-6.152C45.922,14.065,49.411,14.235,47.793,14.153Z",
    transform: "translate(195.224 42.99)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161689",
    "data-name": "Path 161689",
    d: "M42.089,15.245c-2.137-1.264-6.95-1.692-7,1.3-.15,7.322,13.777-1.12,7-1.3C42.021,15.207,43.918,15.289,42.089,15.245Z",
    transform: "translate(206.54 49.068)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161690",
    "data-name": "Path 161690",
    d: "M35.766,13.893c-3.707-1.535-11.313,2.113-5.817,3.931,5.851,1.95,10.357-4.353,5.817-3.931C33.766,13.056,37.029,13.78,35.766,13.893Z",
    transform: "translate(165.333 44.904)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161691",
    "data-name": "Path 161691",
    d: "M28.314,11.466c-2.929-2.994-3.468,4.1-1.727,5.944,3.113,3.321,3.714-3.919,1.727-5.944C27.556,10.692,29.925,13.114,28.314,11.466Z",
    transform: "translate(151.218 30.322)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161692",
    "data-name": "Path 161692",
    d: "M61.128,17.85c-1.318-1.51-9.5-4.189-6.923-.44,1.481,2.176,8.37,2.063,6.923.44C60.043,16.618,61.675,18.454,61.128,17.85Z",
    transform: "translate(315.018 55.533)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161693",
    "data-name": "Path 161693",
    d: "M80.106,23.248c-1.516-3-5.441-3.371-8.875-3.516,1.3-1.491,1.154-7.819-2.178-4.906-2.5,2.157-1.447,4.133-2.881,6.41-1.768-7.347-12.432-4.428-6.39-.579-8.93.8-1.167,5.516,5.776,1.673-4.26,8.561,7.906,6.278,5.018.893,1.086.692,11.572,4.107,9.531.025C78.878,20.826,80.584,24.229,80.106,23.248Z",
    transform: "translate(327.008 47.94)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161694",
    "data-name": "Path 161694",
    d: "M98.03,21.664c-1.782-1.711-4.649-2.12-7.23-1.774.614-1.277,1.359-5.177-1.748-5.252-2.471-.05-2.758,4.233-3.8,5.529-5.639-1.7,1.427-3.063-6.274-3.151-5.509-.063-.4,5.586,2.321,6.133a3.288,3.288,0,0,0-1.748,2.271,11.047,11.047,0,0,0-7.919-3.3c3.96-9.284-10.411-7.787-4.485-.56C56.419,22,59.1,30.879,69.145,24.325c.949,4.787,13.531,3.919,16.617,2.151,3.27-1.881-.177-4.089,3.728-1.585,2.628,1.686,12.268.346,8.541-3.227C96.794,20.488,99.361,22.941,98.03,21.664Z",
    transform: "translate(353.207 50.952)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161695",
    "data-name": "Path 161695",
    d: "M90.034,23.482c-1.243-.5-3.065-.459-4.158-1.145,7.373-4.372-2.041-9.624-6.424-2.61-2.28-7.869-13.777-3.862-6.015,1.151-16.8-3.126,4.376,11.486,3.721,2.34,1.816-1.761,3.4.849,4.806,1.9,3.891,2.919,11.934-.107,8.07-1.635Z",
    transform: "translate(392.144 54.387)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161696",
    "data-name": "Path 161696",
    d: "M88.745,20.674c-1.714-.113-6.52.654-7.394,2.365-.792-2.786-2.99-6.718-7.011-7.183-6.138-.7-1.953,8.555,4.035,7.749,1.126,1.371,2.458.616,3.755,1.12,3.27,5.85,13.654-3.673,6.615-4.051C87.448,20.586,90.288,20.75,88.745,20.674Z",
    transform: "translate(417.676 57.194)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161697",
    "data-name": "Path 161697",
    d: "M79.08,16.972c-3.434-1.422-5.694,2.529-2.867,4.158,3.018,2.264,6.9-2.485,2.867-4.158C77.408,16.28,80.521,17.557,79.08,16.972Z",
    transform: "translate(438.715 61.695)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161698",
    "data-name": "Path 161698",
    d: "M106.541,15.062c1.038-2.057-5.27-7.133-7.086-4.007-4.008,6.957,9.148,6.68,7.086,4.007C106.636,14.861,107.217,15.943,106.541,15.062Z",
    transform: "translate(577.146 26.751)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161699",
    "data-name": "Path 161699",
    d: "M126.473,11.595c-3.83-.962-8.1.843-10.637,3.044.751-5.208-5.769-5.969-7.469-1.3-1.058,2.956,2.062,4.56,2.164,6.787-1.454-1.352-5.516-6.491-8.916-4.944-3.871,1.755.778,5.881,3.147,6.611-8.773,5.862,5.148,9.341,6.179-.667.034.05,4.752,5.183,3.693,4.321,5.9,4.887,10.787-2.931,2.226-6.334-1.086.78,20.4-4.768,9.613-7.523C122.923,10.708,127.873,11.966,126.473,11.595Z",
    transform: "translate(585.54 27.715)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161700",
    "data-name": "Path 161700",
    d: "M106.038,9.9c-1.959-3.044-8.882,3.529-3.12,5.68,4.629,1.723,4.4-3.724,3.12-5.68C105.348,8.829,106.932,11.288,106.038,9.9Z",
    transform: "translate(588.703 21.725)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161701",
    "data-name": "Path 161701",
    d: "M110.733,13.307c-3.584-.78-7.025-1.906-10.828-1.4a2.134,2.134,0,0,0-.662,4.126c4.608,1.786,14.344-2.107,11.49-2.724C106.978,12.5,112.549,13.7,110.733,13.307Z",
    transform: "translate(572.32 35.828)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161702",
    "data-name": "Path 161702",
    d: "M110.362,13.13c-3.707-.384-7.728-.434-11.149.969-4.41,1.824.744,4.56,3.318,4.51,2.021-.057,14.255-4.818,7.831-5.479C106.675,12.746,112.083,13.312,110.362,13.13Z",
    transform: "translate(570.164 41.742)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161703",
    "data-name": "Path 161703",
    d: "M104.282,14.546c-3.721-2.145-10.93.83-6.37,3.434,2.963,1.7,9.23-1.78,6.37-3.434C103.265,13.967,105.381,15.187,104.282,14.546Z",
    transform: "translate(564.079 46.572)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161704",
    "data-name": "Path 161704",
    d: "M109.9,8.92c-6.656.912-5.783,7.227-4.642,6.29.109-.082,12.036-7.309,4.642-6.29C106.864,9.329,111.6,8.674,109.9,8.92Z",
    transform: "translate(610.829 20.181)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161705",
    "data-name": "Path 161705",
    d: "M136.973,18.2c-.8-3.944-6.11-4.428-10.111-3.831,5.148-11.492-10.623-5.919-7.469,1.34-2.724-.635-3.338-3.648-7.189-2.126-3.564,1.4-2.178,5,1.167,5.642-10.6,1.44-7.653,10.146-.082,6.108,1.823-.981,6.848-4.812,2.84-5.969,3.161-.3,8.561-4.787,7.209,1.315.28-1.541-1.311-3.2-2.983-1.661-8.52,7.875,6.26,14.769,4.465,6.252,4.178,4.4,6.179-.352,4.738-3.68,2.71.22,8.042-.289,7.414-3.39C136.174,14.3,137.137,19.092,136.973,18.2Z",
    transform: "translate(622.502 14.696)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161706",
    "data-name": "Path 161706",
    d: "M113.721,10.644c-4.54-2.428-13.012,1.7-7.2,3.6,2.588.837,11.1-1.484,7.2-3.6C111.653,9.536,114.589,11.128,113.721,10.644Z",
    transform: "translate(611.304 25.886)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161707",
    "data-name": "Path 161707",
    d: "M114.505,12.641c2.267-2.365-12.214-2.3-9.408,3.529,2.956,6.12,8.466-2.541,9.408-3.529C115.188,11.949,114.341,12.823,114.505,12.641Z",
    transform: "translate(612.371 32.664)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161708",
    "data-name": "Path 161708",
    d: "M114.145,10.33c-.669-.195-9.189-5.837-8.472-.912,1.174,7.85,12.453,2.076,8.472.912C114.022,10.292,115.695,10.777,114.145,10.33Z",
    transform: "translate(617.585 12.695)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161709",
    "data-name": "Path 161709",
    d: "M115.254,12.514c-1.188-5.334-9.38-8.863-8.042-1.453.71,4.095,9.312,7.284,8.042,1.453C114.872,10.766,115.432,13.42,115.254,12.514Z",
    transform: "translate(625.945 9.668)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161710",
    "data-name": "Path 161710",
    d: "M125.544,9.871c-3.379-2.818-17.778-2.246-12.8,1.541,3.134,2.409,15.511.723,12.8-1.541C122.833,7.626,126.568,10.752,125.544,9.871Z",
    transform: "translate(653 16.374)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161711",
    "data-name": "Path 161711",
    d: "M117.827,9.248c.157-2.554-9.066-.893-7.8,2.107,1.413,3.327,9.046,1.025,7.8-2.107C117.854,8.738,118.291,10.411,117.827,9.248Z",
    transform: "translate(642.495 15.79)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161712",
    "data-name": "Path 161712",
    d: "M122.525,10.77c-3.591-5.2-16.023,3.919-8.991,5.076,2.485.415,10.971-2.239,8.991-5.076C121.624,9.449,122.757,11.11,122.525,10.77Z",
    transform: "translate(651.301 22.086)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161713",
    "data-name": "Path 161713",
    d: "M119.536,8.549C114.4,3.6,109.7,9.958,116.307,13.99c5.981,3.623,5.8-3,3.229-5.441C118.355,7.385,120.724,9.656,119.536,8.549Z",
    transform: "translate(660.871 9.193)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161714",
    "data-name": "Path 161714",
    d: "M124.593,9.806c-7.039-5.29-15.313,3.044-6.534,3.774-4.479,2.837-4.274,9.831,2.956,6.145,2.765-1.4,6.015-8.089,3.577-9.919C121.74,7.667,125.508,10.479,124.593,9.806Z",
    transform: "translate(667.911 16.144)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161715",
    "data-name": "Path 161715",
    d: "M132.2,15.2c5.667-5.271-6.971-9.347-9.271-2.4-.375-1.742-5.823-9.737-7.933-4.34-.949,2.4,5.161,10.1,7.838,6,.771,2.4-1.8,5.894,2.4,8.938,4.1,2.944,6.192-5.177-.6-7.341,2.833.371,5.23,1.308,7.571-.862C134.047,13.469,130.634,16.626,132.2,15.2Z",
    transform: "translate(671.566 8.525)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161716",
    "data-name": "Path 161716",
    d: "M119.577,6.537C116.2,3.486,112.2,8.613,114.839,11.3c3.14,3.208,7.653-2.164,4.738-4.768C118.573,5.619,120.819,7.644,119.577,6.537Z",
    transform: "translate(666.272 3.128)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161717",
    "data-name": "Path 161717",
    d: "M133.558,12.045c-1.092-3.485-7.612-2.875-11.313-4.78-5.885-2.711-5.339,5.856,3.878,5.5-6.4,6.479,9.845,6.768,7.435-.723C133.517,11.982,134.52,15.083,133.558,12.045Z",
    transform: "translate(691.99 9.137)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161718",
    "data-name": "Path 161718",
    d: "M125.387,7.355c-3.489-5.523-4.561,3.837-4.9,4.806-1.652,4.963,10,3.334,4.9-4.806C124.964,6.657,126.6,9.286,125.387,7.355Z",
    transform: "translate(703.247 3.259)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161719",
    "data-name": "Path 161719",
    d: "M129.091,7.48c-3.782-1.906-11.306,1.019-6.534,4.133s12.685-1.025,6.534-4.133C127.282,6.58,130.545,8.209,129.091,7.48Z",
    transform: "translate(707.271 9.878)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161720",
    "data-name": "Path 161720",
    d: "M126.314,9.468c-.983-2.994-7.578.7-8.268,1.9C115.24,16.28,128.185,15.155,126.314,9.468Z",
    transform: "translate(687.607 17.557)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161721",
    "data-name": "Path 161721",
    d: "M126.927,10.009c-3.2-5.139-8.309-.554-5.161,3.353,3.584,4.409,7.407.258,5.161-3.353C126.456,9.255,127.725,11.249,126.927,10.009Z",
    transform: "translate(705.858 14.368)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161722",
    "data-name": "Path 161722",
    d: "M139.572,16.29c-2.888-1.579-.594-3.246-.13-5.359,1.393-6.158-5.817-3.85-6.315.774-.423-2.478-8.793-8.712-9.476-3.837-.451,3.327,4.977,5.472,8.356,5.378,3.106-.088,2.977,1.654,2.826,4.032-.478,8.5,11.579,2.812,4.738-.988C139.484,16.234,141.388,17.278,139.572,16.29Z",
    transform: "translate(722.446 5.552)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161723",
    "data-name": "Path 161723",
    d: "M134.805,7.6c-4.124-1.742-15.655,2.692-10.159,4.711C129.309,14.034,138.089,9,134.805,7.6,133.29,6.957,135.543,7.926,134.805,7.6Z",
    transform: "translate(719.908 11.614)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161724",
    "data-name": "Path 161724",
    d: "M145.984,7.322c-3.222.591-4.547,3.623-6.465,3.868-.423.057-5.571-2.648-7.018-2.937-1.195-.245-8.739-.214-4.683,2.491,3.345,2.246,5.489.56,8.493,1.585-11.429,6.372,7.558,7.951,5.359,1.484.963,2.837,12.767-8.039,4.315-6.491C143.69,7.744,147.67,7.014,145.984,7.322Z",
    transform: "translate(739.957 11.45)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161725",
    "data-name": "Path 161725",
    d: "M149.85,14.8c-1.106-4.214-4.629-.805-4.52-5.372.171-6.743-6.54-1.239-6.445,2.768-2.26-2.831-7.79-1.013-8.24,1.868-.689,4.183,7.011,4.17,8.991,1.271,1.9-2.768,11.3,3.554,10.213-.535C149.5,13.456,150.2,16.11,149.85,14.8Z",
    transform: "translate(763.099 6.594)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161726",
    "data-name": "Path 161726",
    d: "M137.789,12.523c-1.017-1.289-1.4-8.963-5.626-6.523C125.548,9.812,140.185,15.605,137.789,12.523Z",
    transform: "translate(762.106 2.74)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161727",
    "data-name": "Path 161727",
    d: "M129.7,9.122c.341-2.409-7,2.158-5.523,6.152,1.679,4.523,11.715-3.34,5.523-6.152C129.7,9.066,131.384,9.883,129.7,9.122Z",
    transform: "translate(724.497 18.23)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161728",
    "data-name": "Path 161728",
    d: "M143.385,9.328c-1.85-1.837-11.258-4.183-8.814.642,1.877,3.7,10.514,1.063,8.814-.642C141.617,7.567,144.048,9.982,143.385,9.328Z",
    transform: "translate(783.887 11.137)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161729",
    "data-name": "Path 161729",
    d: "M144.594,7.155c-3.721-2.994-12.152,5.862-7.243,6.378,2.424.252,9.933-4.233,7.243-6.378C143.823,6.519,145.263,7.683,144.594,7.155Z",
    transform: "translate(793.71 8.102)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161730",
    "data-name": "Path 161730",
    d: "M145.339,6.864c-1.577-.05-9.729.749-7.25,3.975,3.6,4.755,13.361-3.724,7.25-3.975C143.864,6.826,147.325,6.958,145.339,6.864Z",
    transform: "translate(804.012 9.789)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161731",
    "data-name": "Path 161731",
    d: "M195.555,10.928c-3.393-5.913-12.022-3.3-4.868,3.051,4.909,4.346,8.377,3.013,4.868-3.051C194.456,9.022,196.476,12.519,195.555,10.928Z",
    transform: "translate(1097.146 13.802)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161732",
    "data-name": "Path 161732",
    d: "M199.273,10.7c-2.608-.528-5.237-1.371-7.947-1.793-5-.78-7.162,2.378-2.13,4.8,5.906,2.862,12.937-2.409,10.077-3.007C198.4,10.52,200.4,10.929,199.273,10.7Z",
    transform: "translate(1087.85 20.009)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161733",
    "data-name": "Path 161733",
    d: "M204.955,10.242c-.614-4.321-7.844.44-9.182,1.6-.191-12-10.78,5.064-4.492,5.064a1.981,1.981,0,0,0,1.427-2.642c1.877.994-1.748,2.906,3.318,3.472,5.236.572,9.5-3.529,8.93-7.5C204.825,9.21,205.31,12.664,204.955,10.242Z",
    transform: "translate(1105.072 13.569)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161734",
    "data-name": "Path 161734",
    d: "M219.673,17.957c.382.22-4.663-4.328-5.687-1.956-2.833-3.258-4.2-5.227-9.019-7.2-8.425-3.447-7.578,3.906-1.031,5.309-3.134,0-12.234-.761-12.8,2.61-1.14,6.869,18.181-.421,13.88-2.434,5.4.642,3.455,4.6,9.155,6.246,1.57.453,9.483-.333,5.5-2.579C218.417,17.265,220.772,18.6,219.673,17.957Z",
    transform: "translate(1115.553 15.277)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161735",
    "data-name": "Path 161735",
    d: "M210.514,16.231c-2.6-3.73-9.326-.189-12.555.925,0-2.56,6.568-2.529,4.724-7.246-3.14-8.02-9.612,1.132-8.841,5.214,1.256,6.6,19.416,5.007,16.672,1.107C210.282,15.9,210.978,16.892,210.514,16.231Z",
    transform: "translate(1131.239 9.077)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161736",
    "data-name": "Path 161736",
    d: "M200.761,12.444c.15.088-7.544-10.328-8.466-5.026-.526,2.944.423,5.9,4.13,7.208,1.051.377,8.425.2,4.335-2.183C200.515,12.293,202.222,13.293,200.761,12.444Z",
    transform: "translate(1121.815 4.794)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161737",
    "data-name": "Path 161737",
    d: "M203.188,7.585c-.928-4.151-7.694,2.447-7.441,4.755-.765.868,9.039,2.5,7.441-4.755C203.045,6.956,203.509,9.082,203.188,7.585Z",
    transform: "translate(1142.457 6.546)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161738",
    "data-name": "Path 161738",
    d: "M195.793,9.373c-2.635-1.679-10.166,3.692-6.083,5.837,3.741,1.981,10.206-5.642,6.083-5.837C195.547,9.2,196.776,9.4,195.793,9.373Z",
    transform: "translate(1100.601 21.407)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161739",
    "data-name": "Path 161739",
    d: "M211.438,13.459c-2.383-2.906-17.3-11.052-13.074-2.264,2.751,5.768,14.194,3.642,13.074,2.264C208.925,10.377,212.161,14.34,211.438,13.459Z",
    transform: "translate(1153.589 11.767)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161740",
    "data-name": "Path 161740",
    d: "M210.088,11.856a12.093,12.093,0,0,0-4.533.057c4.1-4.743-20.14-5.63-3.222.465-8.882,2.044-.908,6.567,4.772,5.183,4.083-1.013,7.564-7.5,2.983-5.705C209.992,11.825,211.795,11.177,210.088,11.856Z",
    transform: "translate(1145.702 16.258)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161741",
    "data-name": "Path 161741",
    d: "M215.246,15.5c-.915-.2,1.215-8.328-5.38-9.341-6.54-1.013-.751,7.957,1.57,9.485-1.126.27-4.076.421-4.888,1.214-1.836-12.983-10.207,3.139-5.209,1.755-1.01,2.327,1.734,5.661,4.233,2.818,2.922,8.624,10.268,3.529,4.772-1.069,2.048,0,10.316-3.768,4.9-4.862C215.041,15.441,216.83,15.812,215.246,15.5Z",
    transform: "translate(1166.146 5.665)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161742",
    "data-name": "Path 161742",
    d: "M226.871,14.669c-2.54-3.623-5.1-1.189-5.434-5.108-.519-6.441-7.435-1.768-7.981,2.246-1.188-1.189-9.763-5.365-8.882-.8.4,2.069,3.741,2.214,5.359,3.491-2.28,1.837-5.093,1.157-6.889,2.931-4.356,4.315,6.854,3.623,9.558.667-1.85,8.661,11.845,7.227,6.506.654,2.26.459,9.927-1.044,7.762-4.082C225.779,13.1,227.335,15.329,226.871,14.669Z",
    transform: "translate(1179.439 7.249)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162530",
    "data-name": "Path 162530",
    d: "M226.871,14.669c-2.54-3.623-5.1-1.189-5.434-5.108-.519-6.441-7.435-1.768-7.981,2.246-1.188-1.189-9.763-5.365-8.882-.8.4,2.069,3.741,2.214,5.359,3.491-2.28,1.837-5.093,1.157-6.889,2.931-4.356,4.315,6.854,3.623,9.558.667-1.85,8.661,11.845,7.227,6.506.654,2.26.459,9.927-1.044,7.762-4.082C225.779,13.1,227.335,15.329,226.871,14.669Z",
    transform: "translate(1197.664 -6.377)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162531",
    "data-name": "Path 162531",
    d: "M226.871,14.669c-2.54-3.623-5.1-1.189-5.434-5.108-.519-6.441-7.435-1.768-7.981,2.246-1.188-1.189-9.763-5.365-8.882-.8.4,2.069,3.741,2.214,5.359,3.491-2.28,1.837-5.093,1.157-6.889,2.931-4.356,4.315,6.854,3.623,9.558.667-1.85,8.661,11.845,7.227,6.506.654,2.26.459,9.927-1.044,7.762-4.082C225.779,13.1,227.335,15.329,226.871,14.669Z",
    transform: "translate(1209.644 7.331)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161743",
    "data-name": "Path 161743",
    d: "M205.111,11.019c.362-1.1.075-3.334-2.321-2.208-2.833-.824-3.045,3.309-3.482,4.63-2.219,6.686,9.032,3.648,5.8-2.422C205.2,10.754,205.473,11.717,205.111,11.019Z",
    transform: "translate(1161.759 18.491)",
    fill: "#5aa445"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161744",
    "data-name": "Path 161744",
    d: "M1585.563,18.747c-24.953-1.7-350.446.006-375.3-3.938-21.949-3.478-44.315-6.535-66.667-6.976-53.873-1.057-115.044,8.938-167.531,19.826-30.579,6.334-62.024,8.051-92.9,14.1-25.233,4.95-49.981,10.058-75.508,13.92-42.547,6.46-86.1,9.3-128.363,15.209-57.512,8.039-109.951,3.441-166.964-1.006-50.09-3.9-101.014-3.076-151.084-6.032C309.64,60.8,257.57,63.256,206.093,60.123,155.088,57.041,11.832,30.572-38.989,27.66V221.042c17.778,2.025,11.984-2.082,22.525,0,22.8,4.472,28.121,21.355,51.442,22.6,29.78,1.579,110.558,14.1,139.492,20.543,22.57,5.038,132.46-6.359,155.9-5.057,48.049,2.7,95.86,7.686,144.38,7.686,27.015,0,52.057-.805,78.116,5.082,22.728,5.114,47,6.013,70.34,6.529,69.268,1.51,138.631,3.692,208.138,3.906,54.767.189,108.838-1.925,163.141-3.9,26-.944,52.132,4.221,78.075,1.61,13.579-1.365,26.441-5.743,40.116-6.982,19.519-1.761,39.1-1.78,58.488-4.686,44.82-6.737,89.114-17.134,135.095-18.864,45.134-1.717,87.906.428,132.7,1.887,22.618.736,43.953,3.95,66.121,7.642,6.527,1.1,313.265-.208,319.512,0V34.309c-32.709-4.529-72.209-6.649-72.209-6.649S1632.268,21.936,1585.563,18.747Z",
    transform: "translate(39.622 57.191)",
    fill: "#5aa400"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_161745",
    "data-name": "Path 161745",
    d: "M317.964,73.163a355.187,355.187,0,0,1-42.123,9.29C246.49,86.969,217.9,87,188.255,85.887c-30.121-1.126-60.413-2.485-90.569-1.208-15.511.642-44.731.541-58.3,10.523,21.744,9.334,47.23,12.926,71.507,14.757,29.643,2.227,59.457,2.208,89.176,1.409,69.364-1.9,138.761-5.108,207.3-14.228,71.739-9.567,140.762-28.8,213.716-32.161,72.825-3.359,145.657,1.931,218.523.346C877,64.52,914.824,63.1,951.841,58.28a552.907,552.907,0,0,0,55.832-9.813c14.2-3.353,27.773-8.064,41.837-11.586,8.3-2.069,19.683-3.529,27.384-7.875-45.469-.377-88.575-5.466-133.675-8.548-24.953-1.7-49.8-1.7-74.661-5.649-21.949-3.478-44.315-6.535-66.667-6.976C748.017,6.777,686.846,16.772,634.359,27.66c-30.579,6.334-62.024,8.051-92.9,14.1-25.233,4.95-49.981,10.058-75.508,13.92-42.547,6.46-86.1,9.3-128.363,15.209C330.99,71.81,324.456,72.546,317.964,73.163Z",
    transform: "translate(381.324 57.191)",
    opacity: 0.3,
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161746",
    "data-name": "Path 161746",
    d: "M504.449,49.085c-90.726-1.717-180.864-11.291-271.549-13.3C160.58,34.209,76.423,34.53,16.658,71.837c16.112,6.108,34.88,7.6,52.439,7.988,23.123.5,46.206-.786,69.247-2.422,55.4-3.938,111.207-2.327,166.8-2.327,48.179,0,96.317,2.2,144.475,2.126,37.774-.038,82.1-.4,115.747-16.449-15.887-8.7-36.129-12.09-55.655-13.725A6.38,6.38,0,0,1,504.449,49.085Z",
    transform: "translate(248.903 203)",
    opacity: 0.5,
    fill: "url(#linear-gradient-3)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161747",
    "data-name": "Path 161747",
    d: "M653.885,55.508A65.211,65.211,0,0,0,638.36,50.64c-17.675-3.73-35.958-5.617-54.119-7.164-30.585-2.585-61.526-2.862-92.05-5.737a8.135,8.135,0,0,1-2.594-.667c-71.992-4.107-143.841-11.379-216.153-10.913-34.757.214-70.108,1.2-104.155,7.171-25.6,4.51-59.02,12.159-71.412,32.639,27.923,7.284,58.59,3.46,87.517,3.573,32.968.113,65.9.673,98.857,1.164,38.983.585,77.815,1.019,116.757-.579,38.7-1.585,77.358-3.573,116.047-5.1,24.072-.925,47.455-.736,71.453-.346,19.014.3,45.988,2.384,63.062-5.806C655.9,56.8,656.992,57.056,653.885,55.508Z",
    transform: "translate(722.182 154.427)",
    opacity: 0.3,
    fill: "url(#linear-gradient-4)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161748",
    "data-name": "Path 161748",
    d: "M1460.375,11.25c13.955,3.063,27.322,7.586,39,14.876a4.539,4.539,0,0,1,1.058,6.51c-13.565,14.889-35.03,18.449-56.262,21.946,15.757,3.611,33.036,5.642,43.953,14.945,15.2,12.964.526,29.507-15.648,36.262-22.973,9.592-49.927,12.014-75.351,14.2-9.162.786-18.658,1.22-28.175,1.837,10.5.824,21,1.73,31.4,3.12,22.3,3.013,46.5,7.554,62.816,21.04,1.9,1.579,2.867,4.6,1.045,6.51-40.737,42.6-115.14,59.064-178.406,66.568-64.823,7.693-138.208,10.1-200.881-8.045-4.376-1.252-7.1-6.12-2.97-8.97,24.2-16.662,55.8-21.191,86.438-24.789,26.387-3.114,56.856-5.051,79.754-17.172-38.682-6.5-79.509-1.717-118.191,2.447-36.525,3.95-73.173,7.234-109.725,11.108-74.286,7.856-158.061,17.851-229.794-5.152-5.482-1.749-6.65-7.007-1.611-9.813,61.4-34.08,140.133-38.948,212.235-44.9,44.636-3.68,89.51-8.668,134.5-8.014,24.9.377,56.03,4.869,81.386-1.208-44.6-7.592-95.334.189-132.569-24.431a4.639,4.639,0,0,1,0-7.6c30.906-21.72,75.323-24.556,114.709-24.544,16.419.019,32.9.786,49.421,1.541-60.338-4.265-121.973-.654-181.895,2.132-74.095,3.447-149.487.346-222.933,9.781,34.572,2.661,69.07,4.9,101.6,16.059,3.775,1.3,4.417,6.384,1.331,8.435-35.508,23.55-83.059,27.865-127.592,28.972-42.185,1.025-86-1.805-127.9,4.1,7.428,4.133,13.613,9.5,17.58,16.474a4.918,4.918,0,0,1-2.4,7.359c-57.245,26.286-124.376,16.964-188.06,21.084,58.392,2.5,117.577-.931,174.385,11.624,6.943,1.529,5.81,8.473,0,10.36-8.438,2.742-17.218,4.718-25.888,6.888,59.9,3.221,121.14,2.447,177.949,19.493,4.827,1.422,7.442,7.68,1.6,9.806-60.959,22.191-129.442,23.11-195.269,24.267-31.616.566-63.328.289-94.726-2.931-24.7-2.5-50.132-6.875-71.582-17.461-4.683-2.3-3.919-6.869,0-9.29a85.733,85.733,0,0,1,24.537-9.882c-67.254,3.082-134.344,9.85-201.769,10.3-34.757.214-69.719.692-104.38-2.088-30.865-2.472-63.369-6.517-90.1-19.971-4.219-2.12-4.465-7.2,0-9.278,54.112-25.16,112.654-36.281,172.986-41.458Q231.934,141.71,177.9,139c-27.971-1.4-62.379-3.107-83.182-20.21-2.376-1.962-2.82-5.705,0-7.6C123.3,91.977,168.882,97.066,203.345,97.858c26.189.629,52.753-.711,78.962-1.321,7.967-.182,15.955-.434,23.9-.774-73.166-3.7-148.9-1.679-214.952-28.337-6.22-2.5-2.956-9.875,3.386-10.02,69.828-1.422,139.983,6.3,209.729,3.227C285.25,58.426,266,56.74,248.158,50.041A4.726,4.726,0,0,1,245.6,43c-11.162-.277-22.3-.667-33.419-1.359C161.174,38.562,19.714,17.012-31.107,14.1V192.782c17.778,2.025-10.548,38.055,0,40.137,22.782,4.485,169.172,12.247,192.486,13.48,29.787,1.579,52.139-7.812,81.072-1.365,22.57,5.019,70.565-5.686,94-4.384,48.049,2.7,95.86,7.686,144.38,7.686,27.015,0,52.057-.805,78.116,5.082,22.727,5.114,47,6.013,70.34,6.529,69.268,1.51,138.631,3.692,208.138,3.906,54.767.189,108.838-1.925,163.141-3.9,26-.944,52.132,4.221,78.075,1.61,13.579-1.365,26.441-5.743,40.116-6.982,19.519-1.761,39.1-1.78,58.488-4.686,44.82-6.737,89.114-17.134,135.1-18.864,45.134-1.717,87.906.428,132.7,1.887,22.618.736,43.953,3.95,66.121,7.642,6.527,1.1,312.641-.208,318.887,0V15.829C1807.137,12.659,1484.1,12.25,1460.375,11.25Z",
    transform: "translate(33.535 75.671)",
    opacity: 0.4,
    fill: "url(#linear-gradient-5)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161811",
    "data-name": "Path 161811",
    d: "M200.284,52.767c-11.087.912-21.471,4.177-32.463,5.2-1.208.113-2.444.195-3.68.277-3.427,1.245-6.779,2.648-9.968,4.177-4.4,2.126-16.9,8-15.143,13.165,2.314,6.844,17.826,9.662,25.588,11.291a392.879,392.879,0,0,0,45.755,6.309A848.928,848.928,0,0,0,328.3,95.074c30.92-1.591,63.042-3.692,93.074-9.674a374.94,374.94,0,0,0,44.253-11.366c9.674-3.2,20-6.246,28.107-11.372,8.684-5.447,17.874-12.492,22.823-20.487-17.559-2.68-34.511-5-52.48-5.535-36.225-1.088-70.784-2.68-107.288-1.4-37.16,1.3-73,9.014-109.227,14.021C231.88,51.439,216.048,51.452,200.284,52.767Z",
    transform: "translate(961.002 200.068)",
    opacity: 0.6,
    fill: "url(#linear-gradient-6)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161812",
    "data-name": "Path 161812",
    d: "M257.748,28.852c-15.668-2.352-31.207-2.573-47.244-2.5-3.393-.384-6.827-.717-10.411-.912-12.541-.692-25.1-1.157-37.693-1.6-26.489-.962-53.047-1.585-79.618-1.22a475.868,475.868,0,0,0-53.9,3.787C-.085,29.626-11.091,38.6-5.329,39.665c19.02,3.51,38.7,3.636,58.584,3.636,24.175-.025,48.37.988,72.449,1.988,45.53,1.893,91.879,4.9,134.522-6.051C268.685,37.073,265.872,30.085,257.748,28.852Z",
    transform: "translate(112.166 135.254)",
    opacity: 0.2,
    fill: "url(#linear-gradient-7)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161813",
    "data-name": "Path 161813",
    d: "M149.067,27.426c-8.8-1.768-17.559-1.925-26.571-1.868-1.9-.277-3.837-.528-5.864-.66-7.046-.509-14.1-.855-21.178-1.2C80.53,23,65.62,22.519,50.661,22.8a206.751,206.751,0,0,0-30.319,2.8C4.032,27.979-2.146,34.609,1.1,35.408c10.7,2.579,21.772,2.673,32.961,2.673,13.606-.019,27.2.723,40.744,1.472,25.615,1.4,51.674,3.611,75.651-4.472C155.219,33.483,153.628,28.319,149.067,27.426Z",
    transform: "translate(153.367 136.329)",
    opacity: 0.3,
    fill: "url(#linear-gradient-8)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161814",
    "data-name": "Path 161814",
    d: "M515.643,44.362c-1.5-.591-3.045-1.12-4.622-1.635a4.508,4.508,0,0,0-2.574-1.308c-1.277-.233-2.581-.459-3.871-.692A168.644,168.644,0,0,0,471.9,35c-22.652-3.227-45.421-3.73-66.435,6.189a7.085,7.085,0,0,0-4.144,5.076c-1.679-.138-3.386-.245-5.093-.315-16.692-5.032-38.409-5.208-52.152,1.17-6.452-1.491-13.108-2.434-19.553-3.453q-26.226-4.123-52.753-6.718c-13.19-1.283-53.47-7.7-67.008,3.711-6.138.591-12.262,1.283-18.406,1.963H186.1c-.075-1.063-.806-2.032-2.5-2.252-45.912-6.4-101.567-13.046-145.24,4.051-5.469,2.139-4.178,8.429,0,10.832,22.728,13.134,53.77,9.108,79.454,6.705,3.844-.359,7.715-.635,11.586-.868a9.19,9.19,0,0,0,2.458,4.982C145.5,80.222,171.1,79.889,190.631,78.486c15.484-1.107,30.667-3.887,45.755-6.995,9.708,1.522,19.014,2.145,24.407,2.579a424.606,424.606,0,0,0,53.156.434c11.674-.541,24.885-.855,36.054-4.189,25.725,10.278,60.9,7.4,85.428-2.032a173.842,173.842,0,0,0,21.635,1.868c19.375.635,46.131-1.227,60.413-13.813C521.173,53.08,521.146,46.476,515.643,44.362Z",
    transform: "translate(354.186 190.306)",
    opacity: 0.2,
    fill: "url(#linear-gradient-9)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161815",
    "data-name": "Path 161815",
    d: "M462.077,38.269c-8.8-1.742-17.552-1.912-26.6-1.843-1.884-.289-3.83-.547-5.844-.692-7.046-.5-14.112-.849-21.185-1.189-14.9-.7-29.841-1.164-44.8-.887a202.79,202.79,0,0,0-30.319,2.8c-10.391,1.516-16.665,4.768-18.993,7.114-9.408-.094-18.788-.038-28.182.365-5.1.233-9.667.648-13.654,1.12-8.063-1.346-16.03-1.333-24.25-1.082-1.918-.277-3.864-.5-5.871-.623-7.08-.409-14.146-.635-21.239-.868-10.309-.333-20.6-.491-30.906-.359A5.868,5.868,0,0,0,186.89,40.2c-8.793-1.749-17.539-1.906-26.564-1.856-1.918-.277-3.844-.522-5.871-.679-7.032-.5-14.112-.83-21.178-1.176-14.917-.717-29.834-1.17-44.8-.912a206,206,0,0,0-30.319,2.812c-7.735,1.113-21.574,2.466-19.252,9.995.061-.208-3.53,8.4,73.719,3.95,5.236-.3,10.937-.516,16.781-.7a5.682,5.682,0,0,0-2.1,6.6c.055-.252-3.2,9.68,73.842,2.8,10.828-.962,23.622-1.554,35.795-2.233a7.1,7.1,0,0,0,.191.887c.048-.245-3.2,9.674,73.849,2.8,6.766-.61,14.337-1.057,22.017-1.491.328,1.673,4.253,8.5,46.472,3.082,16.023-2.051,38.99-1.856,47.346-6.2,1.966-1.006,2.082-4,1.14-6.221,12.118-.377,24.072-1.868,35.5-5.73C468.215,44.332,466.645,39.168,462.077,38.269Z",
    transform: "translate(377.03 193.783)",
    opacity: 0.3,
    fill: "url(#linear-gradient-10)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161816",
    "data-name": "Path 161816",
    d: "M328.677,20.442c-3.85.057-7.721.12-11.572.208a2.613,2.613,0,0,0-.451-.208c-11.64-3.453-25.035-2.12-37.187-1.34-15.211.95-30.3,2.68-45.544,3.535-29.336,1.629-58.809-1.422-88.186-.944-27.22.421-53.743,5.384-79.577,11.926-13.19,3.34-26.735,6.718-40.1,10.448C18.685,48.918,11.141,53.6,3.74,58.422c10.7-1.094,21.342-2.434,32.122-3.063,15.668-.918,31.391-.5,47.025-1.289,3.536-.17,7.025-.428,10.486-.7,6.26-7.737,29.828-10,38.874-11.454,25.39-4.076,51.19-6.554,76.928-8.649,25.486-2.082,51.046-3.359,76.621-4.5,14.467-.667,29.52-.837,43.7-3.522C332.862,24.607,332.118,20.386,328.677,20.442Z",
    transform: "translate(173.628 112.358)",
    opacity: 0.7,
    fill: "url(#linear-gradient-11)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161817",
    "data-name": "Path 161817",
    d: "M419.147,88.878a36.951,36.951,0,0,0-6.616-2.22,24.377,24.377,0,0,0-3.741-1.805,14.555,14.555,0,0,0,2.137-4.9c.908-4.12-2.874-7.013-7.94-6.353a46.723,46.723,0,0,0-7.039,1.5,14.387,14.387,0,0,0-.362-4.806c-.546-2.157-4.185-4.013-6.841-3.1-4.854,1.629-8.2,4.252-9.6,8.4a7.623,7.623,0,0,0-.376,2.516c-.109.013-.184.013-.266.025a11.575,11.575,0,0,0-2.765-7.617c-1.837-2.327-6.3-3.151-8.773-.912-.184.164-.375.3-.56.453a98.44,98.44,0,0,0-4.963-11.492c-2.007-3.831-8.937-1.573-9.087,1.975-.177,4.007,1.311,8.146,2.785,12.039A55.178,55.178,0,0,0,343.387,76a16.024,16.024,0,0,0,1.877-9.02,5.02,5.02,0,0,0-1.843-3.183,6.806,6.806,0,0,0-2.942-7.542A21.4,21.4,0,0,0,334.4,53.5c1.352-.6,2.669-1.227,3.973-1.937,4.253-2.308,3.3-6.9-1.365-8.3a27.723,27.723,0,0,0-3.277-.767c.4-1.9-1.079-4.1-3.393-5.089a30.559,30.559,0,0,0-5.148-12.058c-2.54-3.447-9.148-2.73-10.5,1.094a22.613,22.613,0,0,0-1.277,6.265,60.25,60.25,0,0,0-20.495-3.749c-6.377-.132-14.76,1.887-19.553,5.894-.874-6.057-5.223-11.222-13.572-9.938-6.977,1.044-11.756,6.542-14.938,12.756a22.768,22.768,0,0,0-1.065-2.308c-3.065-5.586-9.77-7.479-16.351-4.258a3.912,3.912,0,0,0-1.9,5.806c.84,1.522,1.85,3.4,3.065,5.233-.1.038-.2.075-.294.1a41.1,41.1,0,0,0-6.274,3.522,9.647,9.647,0,0,0-.307-1.038c-.881-2.485-5.5-3.944-7.8-1.661a32.884,32.884,0,0,0-3.311,3.812c-.089-.22-.143-.44-.225-.654-1.823-4.7-5.182-7.995-11.647-8.215-6.274-.22-10.166,5.145-8.124,9.643a18.574,18.574,0,0,0,5.066,6.41,35.778,35.778,0,0,0-5.55,1.3,8.465,8.465,0,0,0-1.086-4.422,4.641,4.641,0,0,0-1.707-1.8c.9-3.095-.635-6.586-4.485-7.926a16.294,16.294,0,0,0-9.339-.3,19.492,19.492,0,0,0-.335-4.516c-.471-2.3-4.178-3.12-6.445-2.1a33.958,33.958,0,0,0-9.776,6.743c-.3-1.239-.649-2.409-1.01-3.453-1.195-3.453-6.581-3.629-8.923-.931a18.929,18.929,0,0,0-3.987,8.6,25.181,25.181,0,0,0-8.015-3.843,5.167,5.167,0,0,0-6.4,2.661,4.872,4.872,0,0,0-1.536,1.3,24.026,24.026,0,0,0-4.615,12.354,12.7,12.7,0,0,0-2.082.22,14.894,14.894,0,0,0-7.421,4.736c-2.246-7.642-6.336-15.92-14.392-13.863-6.629,1.7-7.667,7.391-5.68,12.744a15.451,15.451,0,0,0-10.889.755c-2.7,1.17-3.236,4.453-.976,6.127a26.572,26.572,0,0,0,6.67,3.5c-.533.327-1.058.635-1.5.95a21.716,21.716,0,0,0-4.622,4.271c-2.144-1.371-4.595-2.39-6.67-3.824C71.572,71.071,65.6,73.166,67.086,77a19.594,19.594,0,0,0,4.8,6.976,8.85,8.85,0,0,0-4.308.635A30.965,30.965,0,0,0,60.293,80.7c-4.6-1.667-11.142-2.17-14.2,1.648-3.42,4.258,1.809,8.2,7.762,9.234-3.332,1.1-6.54,2.566-9.483,3.837a3.434,3.434,0,0,0,1.072,6.623c5.509.761,12.036.2,16.447-2.692a4.119,4.119,0,0,0,2.792,1.661,29.217,29.217,0,0,0,15.73-1.849,4.921,4.921,0,0,0,2.69,1.472,33.029,33.029,0,0,0,16.317-1.547,4.112,4.112,0,0,0,2.56,3.063c7.442,2.881,15.416.075,21.376-4.674a13.722,13.722,0,0,0,4.97,1.956c5.134,1.063,12.753.516,19.1-1.321.86,5.447,8.029,9.649,17.061,8.649,4.574-.5,8.889-2.95,12.61-5.428.471,2.327,2.26,4.208,6.219,4.881,8.042,1.365,16.235-1.824,23.362-5.057,10.48,5.409,31.452.151,44.485-5.384,8.2,4.516,15.238,9.737,25.909,11.14,14.467,1.925,30.285-.981,45.093-3.321-.348,3.252,3.257,6.963,7.769,5.573.771-.226,1.536-.44,2.308-.635a39.88,39.88,0,0,0,3.024,4.636c2.26,3.151,7.831,2.956,10.152,0a22.147,22.147,0,0,0,3.939-7.9,29.613,29.613,0,0,0,11.49,3.919c3.646.34,5.455-.95,6.192-2.875a29.2,29.2,0,0,0,11.306,4.1c3.618.434,6.445-1.126,6.772-4.126a11.512,11.512,0,0,0-.533-4.831,39.764,39.764,0,0,0,10.459,1.1c3.052-.082,5.96-2.5,4.84-5.045a12.475,12.475,0,0,0,2.669-1.264c3.277,1.289,7.011,1.289,11.524.352a5.012,5.012,0,0,0,1.878-.8C420.779,96.653,423.612,90.86,419.147,88.878Z",
    transform: "translate(397.718 138.5)",
    fill: "#2c592b"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_87750",
    "data-name": "Group 87750",
    transform: "translate(453.968 170.714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161818",
    "data-name": "Path 161818",
    d: "M72.78,38.165c-.5-2.29-6.179-4.674-8.677-5.384-2.253-.623-8.766-.277-7.6,3.013-5.421-1.1-1.966-.214-6.213-2.082-2.779-1.22-7.448.346-5.626,3.535,3.011,5.24,12.125-.44,14.665,1.139-7.2,1.3-12.535,8.177-1.516,7.718,2.806-.113,23.212-2.837,14.965-7.938C72.725,37.92,73.961,38.889,72.78,38.165Z",
    transform: "translate(-44.255 17.512)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161819",
    "data-name": "Path 161819",
    d: "M150.149,42.339a11.187,11.187,0,0,0-10.7.673,6.552,6.552,0,0,0-4.738-4.063,25.142,25.142,0,0,0,4.233-6.315c1.748-3.812,1.133-7.869-5.366-5.869-9.831,3.032-3.27,11.316-9.524,15.014,2.355-13.694-8.131-7.988-14.31-.5C104,29.564,97.328,34.018,98.816,44.547c-2.745-.239-4.069-6.026-9.626-6.259-10.937-.472-1.584,8.165,2.779,9.894-5.12.233-9.927,7.586-10.118,11.108-6.165-3.095-2.185-10.517-11.108-14.53-15.074-6.8-8.35,10.07.894,13.492-4.97,1.956-9.073,5.491-8.507,10.53-3.612-.893-3.175-13.253-8.684-11.448-9.176,2.994-4.936,7.108-5.421,12.524-.478,5.259,10.07,7.422,14.665,5.837,6.09-2.1,16.856,6.265,12.951-6.793a13.47,13.47,0,0,0,4.916.069c-9.025,9.265-.546,14.889,10.7,7.907,2.287,9.127,9.954,1.1,13.217-3.076.553,3,5.114,5.63,7.824,7.542,7.093,5.007,5.264-9.064,4.383-11.033,1.7.315,5.96,5.957,9.264,6.925,6.889,2.032,8.193-2.327,4.438-6.315,6.93-.925,23.82-6.944,9.442-11.052,14.078-9.24,2.936-6.919-5.748-10,3.83-2.529,5.264.352,10.077-1.157,1.3-.409,6.7-5.623,4.991-6.372C146.422,40.691,151.665,43.019,150.149,42.339ZM89.511,55.2c.021,2.3.41,4.7-2.71,4.642a7.6,7.6,0,0,1,2.71-4.642C89.517,55.568,88.009,56.555,89.511,55.2Z",
    transform: "translate(-19.743 -15.76)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161820",
    "data-name": "Path 161820",
    d: "M72.26,33.2c-2.355.849-12.883,9.479-5.537,9.259,7.844-.233,8.957-10.473,5.537-9.259C71.83,33.344,73.373,32.8,72.26,33.2Z",
    transform: "translate(71.725 20.289)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161821",
    "data-name": "Path 161821",
    d: "M119.213,47.449c-4.055-2.774-9.244-3.636-14.439-3.378,2.792-2.5,10.753-13.36,5.373-15.964-4.888-2.365-13.484,9.932-14.03,13.115C92.082,39.26,95.065,35.2,93.6,31.189c-2.13-5.913-10.541,1.673-11.422,4.284-.6-2.126-9.073-11.762-10.978-5.542-2.171,7.12,3.5,8.108,8.534,11.8-3.673.226-7.585-1.723-11.92-2.1-7.08-.6-1.912,9.674,3.857,10.435-2.54,1.7-9.483,7.315-7.878,10.442,2.6,5.038,14.665-.39,17.553-2.5,6.9-5.038,2.185,5.334,7.919,6.366,6.773,1.2,11.347-5.529,7.892-9.819,3.536.837,28.933-2.409,22.052-7.1C114.973,44.55,120.947,48.619,119.213,47.449Z",
    transform: "translate(68.234 -7.453)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161822",
    "data-name": "Path 161822",
    d: "M127.089,32.833c5.038-6.573-15.538-1.038-17.122-.327,1.359-6.208-4.328-6.189-9.66-3.516-2.983-8.68-11.155,1.283-11.8,5.7-6.7-11.253-21.942,1.409-6.711,5.5-2.806.824-16.836,14.209-9.442,15.851,4.875,1.082,8.042-5.9,11.538-4.516a11.1,11.1,0,0,0,6.1.7c4.677-.824,3.748.931,7.223,3.636,6.615,5.139,21.314,7.171,23.117-2.61a11.651,11.651,0,0,0-.177-4.736c-.881-3.919,1.529-2.566,4.656-5.271,2.123-1.849,8.493-9.184,2.287-10.4C128.543,30.934,128.864,33.173,127.089,32.833Z",
    transform: "translate(107.055 -19.388)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161823",
    "data-name": "Path 161823",
    d: "M125.126,79.645c-.847-1.83-11.026-13.561-12.234-7.252-.69-3.076-5.687-3.881-6.26-6.083,14.719,2.176,13.361-9.366.143-7.705,7.776-4.724,8.937-12.335-2.765-7.68.246-1.742-1.3-1.906-1.686-3.258,6.076-.9,15.259-12.366,5.626-10.158,4.451-4.554-7.073-2.667-9.456-.862-.1-.415,7.824-14.612.785-11.674-2.458,1.013-3.871,3-2.465,5.082-1.9,1.837-2.977,3.088-4.683,5.013-.089-7.051-14.316-10-10.227-.6-2.71,4.906,2.581,16.373,11.463,13.681a8.583,8.583,0,0,0-1.236,4.277c-11.06-11.1-15.661,6.252-.683,7.353-1.6,5.2-8.937,5.057-11,11.115C79,75.223,92.424,75.286,93.5,73.348c3.673,6.548,16.378,9.165,19.232,1.472.389,5.963,12.835,5.737,12.4,4.824C125.023,79.393,125.774,80.972,125.126,79.645Z",
    transform: "translate(166.018 -24.571)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161824",
    "data-name": "Path 161824",
    d: "M136.847,53.338a23.766,23.766,0,0,0-6.991-4.2c8.459-7.41-1.031-7.894-8.152-3.359.71-4.145-.15-8.051-6.493-6.164,3.236-1.837,2.54-9.542-2.56-9.1-4.472.428-5.666,10.114,1.475,9.448a8.444,8.444,0,0,0-5.523,7.586c-5.673-9.825-13.163.252-6.82,5.743-10.828-9.391-27.213,4.126-8.37,5-8.35,5.913.922,9.712,7.489,4.441.539,11.92,9.667,2.535,9.032-4.9a3.921,3.921,0,0,0,3.243,1.013c.246,2.742,1.939,4.447,5.161,5.233,8.985,2.208,7.442-6.466,2.437-9.5-2.164.962,24.407,5.3,16.071-1.239Z",
    transform: "translate(192.017 6.786)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161825",
    "data-name": "Path 161825",
    d: "M101.8,41.567c1.427-2.145,1.031-13.228-4.472-9.108-3.373,2.541-6.7,7.97-3.5,11.58,1.27,1.39-3,7.913,5.639,6.083,3.837-.805,7.141-6.875,2.335-8.555C103.525,38.976,105.081,42.706,101.8,41.567Z",
    transform: "translate(237.075 12.342)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161826",
    "data-name": "Path 161826",
    d: "M104.21,34.44c-1.6-.862-11.879-4.969-9.654.39,3.523,8.4,16.037,3.107,9.654-.39C103.827,34.251,105.7,35.27,104.21,34.44Z",
    transform: "translate(247.026 15.381)",
    fill: "#9aad3a"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_87752",
    "data-name": "Group 87752",
    transform: "translate(472.197 177.207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161827",
    "data-name": "Path 161827",
    d: "M65.378,35.767C63.739,32.9,48.1,26.476,50.188,32.8c2.069,6.259,18.235,8.3,15.19,2.969C64.49,34.219,66.382,37.553,65.378,35.767Z",
    transform: "translate(-29.03 -1.78)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161828",
    "data-name": "Path 161828",
    d: "M58.427,37.107c-.874-1.321-6.39-8.2-8.445-4.428-4.5,8.234,10.719,7.85,8.445,4.428C58.263,36.83,59.212,38.264,58.427,37.107Z",
    transform: "translate(-33.985 5.92)",
    fill: "#d0d028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161829",
    "data-name": "Path 161829",
    d: "M59.87,32.908c-3.482-.962-17.73,1.975-11.3,4.208,4.718,1.654,15.491-3.07,11.3-4.208C56.272,31.927,60.826,33.166,59.87,32.908Z",
    transform: "translate(-46.925 11.005)",
    fill: "#d0d028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161830",
    "data-name": "Path 161830",
    d: "M65.11,28.08C62.366,21.7,57.9,34.527,57.84,35.81c-.157,3.051,9.968-1.491,7.271-7.731C64.66,26.991,65.95,30,65.11,28.08Z",
    transform: "translate(16.666 -21.876)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161831",
    "data-name": "Path 161831",
    d: "M127.441,35.574a19.13,19.13,0,0,0-10.172.516c7.865-11.844-6.841-11.228-7.483-1.466-.43,6.85.7,4.321-6.11,7.825,4.656-10.058-8.056-6.969-11.517-.359C89.031,29.1,78.1,36.128,83.59,45.173,78.88,42.053,72.776,43.877,76,49.3c-2.424-.132-6.656-.063-8.425,1.635.621-14.115-15.2-2.774-8.582,4.548-6.875.509-11.586,8.378-1.638,8.045,9.114-.3,9.305-4.24,9.961-9.6,2.13,3.013,7.319,3.132,10.766,1.755-3.461,3.252-3.625,7.353,3.311,7.089,5.824-.208,7.885-7.265,10.862-7.265,1.359,2.032,14.4,10.114,14.4,3.831.02-5.686-7.175-8.731-13.463-8.825,2.355-2.459,3.673-1.365,6.622-3.46.669,3.824,7.448,1.346,9.435.025,1.5,7.963,11.272,6.447,9.933-1.9-.451-2.9.99-1.359,4.54-2.6,2.014-.711,9.2-5.636,3.721-6.995C124.034,34.725,129.134,36,127.441,35.574ZM90.062,50.8c-1.659.5-2.328.258-1.98-.755a4.061,4.061,0,0,0,1.994-.5c.143.824.758.994-.014,1.252C89.441,50.627,90.206,50.752,90.062,50.8Z",
    transform: "translate(-19.394 -16.885)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161832",
    "data-name": "Path 161832",
    d: "M69.823,36.473c-.7-1.566-7.592-7.1-9.053-2.868-1.038,3,10.637,6.561,9.053,2.868C69.235,35.152,70.328,37.643,69.823,36.473Z",
    transform: "translate(33.37 8.453)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161833",
    "data-name": "Path 161833",
    d: "M73.861,36.342c1.447-4.592-6.636-12.989-7.442-5.057-.546,5.617,8.664,6.68,7.442,5.057C74.154,35.411,74.516,37.192,73.861,36.342Z",
    transform: "translate(66.533 -12.866)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161834",
    "data-name": "Path 161834",
    d: "M77.571,33c-1.577-4.441-15.061-9.523-12.425-3.082C66.736,33.791,78,34.263,77.571,33,76.881,31.061,78,34.288,77.571,33Z",
    transform: "translate(57.266 -18.932)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161835",
    "data-name": "Path 161835",
    d: "M76.747,29.361c-6.11-3.409-16.924,3.315-10.65,4.837,2.867.7,15.436-2.176,10.65-4.837C73.347,27.461,77.955,30.034,76.747,29.361Z",
    transform: "translate(53.754 -10.766)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161836",
    "data-name": "Path 161836",
    d: "M94.124,39.908c-.553-.088-1.12-.208-1.679-.289,1.918-1.925,7.53-8.278,4.41-10.794-2.942-2.365-8.07,1.371-9.305,3.321-1.488,2.315.164,9.4-2.874,9.253-1.85-.075-2.2,1.591-3.857,2.032-.43-1.554-6.984-3.227-8.234-3.409-11.483-1.6-9.613,6.686,1.092,7.164-1.6,1.466-5.68,10.423,1.024,7.46,5.619-2.491,5.1-7.026,8.507-9.228,7.646,7.913,23.745-1.378,10.917-5.51C93.6,39.763,97.394,40.958,94.124,39.908Z",
    transform: "translate(57.077 -12.582)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161837",
    "data-name": "Path 161837",
    d: "M79.262,31.87c-1-1.9-1.8-4.548-4.663-5.284-2.1-.516-5.68.321-4.281,2.686.635,1.107,10.48,5.567,8.943,2.6C78.58,30.58,79.863,33.04,79.262,31.87Z",
    transform: "translate(87.552 -21.181)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161838",
    "data-name": "Path 161838",
    d: "M76.864,26.952c-4.2-4.692-5.066,4.315-5.236,5.045-1.147,4.479,10.6.962,5.236-5.045C75.717,25.681,78.728,29.027,76.864,26.952Z",
    transform: "translate(96.559 -25.604)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161839",
    "data-name": "Path 161839",
    d: "M88.737,26.483C86.2,27.558,80.073,38.541,83.555,37.6c9.353.428,9.237-12.851,5.182-11.121C86.566,27.389,90.321,25.791,88.737,26.483Z",
    transform: "translate(160.44 -21.902)",
    fill: "#d0d028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161840",
    "data-name": "Path 161840",
    d: "M87.845,28.441c-1.338-4.258-8.711-2.994-5.987,2.648,2.97,6.183,7.121.994,5.987-2.648C87.387,27.026,88.145,29.441,87.845,28.441Z",
    transform: "translate(153.14 -23.992)",
    fill: "#d0d028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161841",
    "data-name": "Path 161841",
    d: "M96.434,29.335c-3.065-1.189-17.675.453-12.8,4.692,5.25,4.6,16.993-3.051,12.8-4.692C93.041,28.014,97.813,29.869,96.434,29.335Z",
    transform: "translate(161.229 -8.431)",
    fill: "#d0d028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161842",
    "data-name": "Path 161842",
    d: "M100.545,35.621c-2.069-2.2-15.47-8.152-16.965-3.812-3.482,10.045,20.5,7.586,16.965,3.812C97.965,32.891,101.351,36.508,100.545,35.621Z",
    transform: "translate(164.648 -0.948)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161843",
    "data-name": "Path 161843",
    d: "M101.083,38.766c-1.434-3.522-12.173-9.2-15.593-4.095-3.571,5.3,11.852,3.428,12.535,4.12-3.837,1.176-15.743,7.781-3.7,6.982,5.905-.377,11.5-8.41,6.759-7.007C99.056,33.784,102.886,38.219,101.083,38.766Z",
    transform: "translate(174.678 11.582)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87751",
    "data-name": "Group 87751",
    transform: "translate(278.292 40.145)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161844",
    "data-name": "Path 161844",
    d: "M101.584,40.717a21.666,21.666,0,0,0-7.1-.547c.573-1.4,3.052-10.221-2.881-7.749-4.95,2.057-2.492,5.34-3.6,8.743-.225,2.749-1.5,4.736,3.475,6.221,5.216,1.535,16.952-4.963,10.111-6.667C99.426,40.182,103.693,41.245,101.584,40.717Z",
    transform: "translate(-87.688 -31.986)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161845",
    "data-name": "Path 161845",
    d: "M87.75,33.6c.027-.057,0-.12.027-.182C87.709,33.68,87.729,33.712,87.75,33.6Z",
    transform: "translate(-87.44 -24.421)",
    fill: "#d0d028"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_161846",
    "data-name": "Path 161846",
    d: "M93.165,31.7c-4.089,1.969-3.482,10.146-.676,7.976,5.585,2.327,6.022-10.58.676-7.976C91.534,32.475,94.756,30.909,93.165,31.7Z",
    transform: "translate(205.488 4.776)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161847",
    "data-name": "Path 161847",
    d: "M100.416,33.826c-3.127-5.133-9.025,3.208-8.739,6.586.423,5.328,11.743-1.679,8.739-6.586C100.375,33.757,102.027,36.462,100.416,33.826Z",
    transform: "translate(213.796 9.281)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161848",
    "data-name": "Path 161848",
    d: "M105.37,32.744c-5.018-1.258-18.7,4.082-8.868,5.793,3.509.61,16.03-4,8.868-5.793C102.482,32.021,107.671,33.316,105.37,32.744Z",
    transform: "translate(221.759 10.974)",
    fill: "#5aa445"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_87974",
    "data-name": "Group 87974",
    transform: "matrix(0.996, 0.087, -0.087, 0.996, 1342.199, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161749-2",
    "data-name": "Path 161749",
    d: "M529.689,48.1c5.829-5.008,7.238-12.728,6.423-20.6-.488-5.042-4.305-7.363-8.564-5.374a32.809,32.809,0,0,0-9.784,7.468c-1.63-1.871-4.177-2.6-7.969-.943a20.061,20.061,0,0,0-4.236,2.651A40.056,40.056,0,0,0,504,24.953c-1.242-3.653-5.328-6.513-8.787-3.86-5.949,4.553-7.663,11.278-8.047,18.9-.072,1.427-.125,3.138-.111,4.883-4.547-2.419-9.494-3.15-14.534-3.408a85.848,85.848,0,0,0,8-11.169c2.288-4.073-.714-10.422-4.979-10.384A39.2,39.2,0,0,0,476.1,2.839,6.314,6.314,0,0,0,466.6-1.326C459.613,2.925,455.52,9.409,452.525,16.71A94.175,94.175,0,0,0,446.874.374C444.618-4.5,438.267-3.805,435.8.449c-5.141,8.82-4.835,20.946.1,29.6a43.7,43.7,0,0,0-6.966,6.434c-.942-10.025-2.9-19.647-10-27.076-2.187-2.3-6.6-2.895-8.713.06-.179.25-.311.509-.483.751-.668-.924-1.372-1.8-2.1-2.624-4.432-4.99-13.415-5.272-16.9,1.4-2.8,5.288-2.389,11.216-.407,17.117-.232.019-.485.02-.724.057-4.617.7-8.2,6.666-4.181,10.859,2.965,3.083,6.006,6.191,9.2,9.169a36.769,36.769,0,0,0-18.773,9.73c-.967-8.589-2.392-16.986-8.611-22.994-2.3-2.211-6.487-2.956-8.733.06a34.04,34.04,0,0,0-3.115,5.179c-4.151-5.163-9.267-8.059-14.744-4.541-6.149,3.953-6.386,13.831-4.065,20.081a28.933,28.933,0,0,0,3.108,5.927c-3.346,1.3-5.533,6.364-3.491,9.857q1.961,3.339,4.025,6.531a34.743,34.743,0,0,0-11.595,4.1,44,44,0,0,0-2.764-16.459c-1.473-3.772-5.886-3.9-8.756-2.467-7.834,3.853-12.746,10.333-15.758,18.021A90.483,90.483,0,0,0,292,64.188c-3.15-3.95-9.58-.743-9.454,4.328A64.689,64.689,0,0,0,285.482,86.2c-3.465,1.76-6.444,5-8.944,8.184a36.039,36.039,0,0,0-7.922-14.627c-2.6-2.776-6.476-2.56-9.129.062-5.4,5.366-6.5,12.207-5.942,19.3-3.106-3.417-6.329-6.73-10.317-9.067-3.831-2.295-7.764-.033-9.289,4.181a17.114,17.114,0,0,0,12.591,22.615,32.8,32.8,0,0,0-2.632,3.43,5.78,5.78,0,0,0-7.191-.888,21.358,21.358,0,0,0-5.1,3.654c-3.749-8.725-7.849-17.12-14.87-23.553-4.913-4.513-11.236-.112-10.358,6.629a75.148,75.148,0,0,0,2.535,11.509c-4.4-3.185-9.33-5.033-15.706-3.623-5.275-11.843-20.231-1.684-31.68,9.526a14.12,14.12,0,0,0-2.073-2.865c-2.87-3.023-6.286-3.318-9.76-2.3-.637-3.356-2.838-6.419-6.437-5.964-1,.127-1.995.323-2.944.51a35.026,35.026,0,0,0,.421-7.137c-.2-4.649-4.609-7.825-8.537-5.331a42.831,42.831,0,0,0-6.038,4.649,83.484,83.484,0,0,0-4.38-22.138c-1.509-4.382-5.074-5.785-8.963-3.953-9.708,4.553-11.492,14.158-10.178,24.618a14.331,14.331,0,0,0-10.73.623c-3.97,1.755-6.166,6.179-3.994,10.54a56.138,56.138,0,0,0,11.08,15.628,49.753,49.753,0,0,0-5.407,3.226c-.716-2.754-2.862-5.026-5.668-4.826-3.543.23-8.91,2.631-13.514,6.178-.392-6.9-1.957-13.989-4.729-19.187a6.174,6.174,0,0,0-10.115-1.358,29.7,29.7,0,0,0-5.617,8.479c-4.065-10.313-11.11-18.955-21.984-18.287-3.208.194-5.041,2.613-5.441,5.951-1.787,15.536,7.551,25.133,19.233,30.409a10.949,10.949,0,0,0,.329,1.674c-9.52-2.471-18.924-1.22-25.656,8.685-2.194,3.281-.413,7.851,2.288,9.8a25.789,25.789,0,0,0,2.466,1.479,14.211,14.211,0,0,0,.167,3.3,12.963,12.963,0,0,0,1.115,3.259,11.878,11.878,0,0,0-1.981,2.145,20.147,20.147,0,0,0-1.837,2.961,17.494,17.494,0,0,0-3.7-1.909c-5.757-2.084-12.412.154-16.757,4.662a12.284,12.284,0,0,0,1.33,18.446,11.789,11.789,0,0,0,3.3,1.851c-.194.466-.47.889-.693,1.38-1.9,4.405-.417,9.277,3.952,10.778A17.738,17.738,0,0,0,26,207.352c12.432,9.938,48.178,1.407,59.029-1.744a1079.649,1079.649,0,0,1,186.431-36.1c39-4.152,77.352-5.875,116.427-3.409,36.028,2.264,73.411,2.025,108.622,10.355C566.086,192.908,532.694,95.507,529.689,48.1ZM364.758,65.436c.15,1.9.3,3.72.533,5.455-.694-1.181-1.45-2.3-2.219-3.406A5.6,5.6,0,0,0,364.758,65.436Z",
    fill: "#2c592b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87747-2",
    "data-name": "Group 87747",
    transform: "translate(5.302 13.319)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161750-2",
    "data-name": "Path 161750",
    d: "M49.409,29.925c6.4-5.82,1.882-18.253-6.5-16.8C44.051,9.04,42.445.988,36.931,5.771,31.17,10.8,32.124,17.4,28.207,22.987a1.611,1.611,0,0,0-.369-.788C35.809,20.967,15.245,1.724,13.118.6,7.79-2.3,7.423,4.924,8.811,8.215,11.124,13.64,15.76,20.622,21.7,21.347c-5.074,4.315-15.557-4.475-20.56,4.971C-5.92,39.6,16.3,38.5,21.826,34.334c.358,7.828,7.851,35.223,16.408,17.552C42.523,43.011,47.371,54.47,54,47.824c4.592-4.6-1.365-14.672-4.589-17.9C52.163,27.43,52.863,33.374,49.409,29.925Z",
    transform: "translate(32.699 113.258)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161751-2",
    "data-name": "Path 161751",
    d: "M25.991,1.88C22.486,6.2,13.073,3.24,7.074,9.006,1.542,14.3-5.9,25.847,6.916,26.568c9.1.522,16.832-7.473,22.465-14.422C33.63,6.908,31.487-4.982,25.991,1.88,25.3,2.753,29.786-2.831,25.991,1.88Zm-8.009,9.106a26.172,26.172,0,0,1-5.172,3.783A15.015,15.015,0,0,1,17.982,10.986Z",
    transform: "translate(22.313 151.04)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161752-2",
    "data-name": "Path 161752",
    d: "M21.855,2.494C18.152-3.292-4.676,1.24.786,9.875c3.183,4.981,12.762,3.162,17.045,1.542,1.252-.481,11.406-7.1,4.023-8.924C21.592,2.04,24.381,3.112,21.855,2.494Z",
    transform: "translate(-1.191 160.793)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161753-2",
    "data-name": "Path 161753",
    d: "M20.4.57C14.71-.353,8.687-.5,3.105,1.436c-6.649,2.315-1.2,8.8,2.257,10.239C14.708,15.523,22.417.875,20.4.57,14.765-.345,22.322.875,20.4.57Z",
    transform: "translate(7.357 139.906)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161754-2",
    "data-name": "Path 161754",
    d: "M52.674,42.877c-2.181-5.847-6.933-10-12.1-12.45A22.5,22.5,0,0,0,47.034,8.49C44.557-1.567,31.053,9.8,28.28,13.836,26.423,10.273,18.52-6.8,13.611,2.753,8.682,12.371,21.347,20.459,23.1,27.306c-7.346-2.159-15.849,1.819-21.225,7.331C-7,43.758,14.13,45.057,17.7,44.3c-5.234,21.267,11.733,16.87,15.093-.189a30.683,30.683,0,0,0,7.691,3.48,4.374,4.374,0,0,0-.9,2.894c-2.864-3.848-8.351,11.077,1.259,15.18,7.42,3.181,7.316-13.236,5.659-16.981,2.789.256,7.848-1.223,6.176-5.81C50.554,37.15,53.711,45.681,52.674,42.877Z",
    transform: "translate(90.075 93.634)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161755-2",
    "data-name": "Path 161755",
    d: "M16.351,6.254C11.47,4.834,9.72-.242,3.748-.021-1.09.132-.527,7.022,1.252,10,8.511,22.029,20.429,7.429,16.351,6.254Z",
    transform: "translate(84.52 100.837)",
    fill: "#9aad3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161756-2",
    "data-name": "Path 161756",
    d: "M10.978.7C8.192,2.851-6.111,13.229,2.772,17.062,13.558,21.733,17.668-4.426,10.978.7,9.969,1.48,13.715-1.4,10.978.7Z",
    transform: "translate(90.053 139.276)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161757-2",
    "data-name": "Path 161757",
    d: "M15.179-.067C9.054-.283-6.691,13.337,2.944,18.669,15.066,25.342,24.367.291,15.179-.067,12.157-.167,17.321.021,15.179-.067Z",
    transform: "translate(139.278 108.038)",
    fill: "#9aad3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161758-2",
    "data-name": "Path 161758",
    d: "M25.206,21.4c.891-4.209-3.677-6.439-6.066-8.245-1.18-5.631-5.2-9.4-9.847-11.657C-3.862-4.911,1.9,10.6,7.521,15.942.444,19.824-5.053,34.276,6.334,35.247c5.312.445,23.449-3.667,18.872-13.847C25.567,19.618,25.776,22.685,25.206,21.4Z",
    transform: "translate(244.083 82.159)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161759-2",
    "data-name": "Path 161759",
    d: "M54.312,19.795c-.6-6.915-8.938-4.52-12.882-3.582-8.455,2.035-4.354-1.646-8.73-7.814A6.542,6.542,0,0,0,26.392,5.27,5.787,5.787,0,0,0,23.85.3C16.712-3.113,13.612,13.79,14.623,18.184,11.963,18.967-2.88,14,.283,23.611c2.562,7.761,15.62,5.1,19.719.7,5.648,3.864,9.716.871,15.052,3.5C40.3,30.4,55.147,29.657,54.312,19.795,54.086,17.252,54.8,25.722,54.312,19.795Z",
    transform: "translate(206.423 110.107)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161760-2",
    "data-name": "Path 161760",
    d: "M16.953,7.875C15.136-4.74,2.772-.925.314,9.519-3.392,25.343,19.4,24.774,16.953,7.875,16.751,6.57,17.271,10.108,16.953,7.875Z",
    transform: "translate(268.981 106.993)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161761-2",
    "data-name": "Path 161761",
    d: "M18.58,2.078C16.714-6.728-6.676,12.9,1.616,28.2c3.062,5.669,11.3-2.888,13.121-5.711A27.94,27.94,0,0,0,18.58,2.078C18.092-.188,20.649,11.932,18.58,2.078Z",
    transform: "translate(271.899 73.959)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161762-2",
    "data-name": "Path 161762",
    d: "M6.191.757C2.4-2.277.3,4.278.026,6.747-.64,12.966,2.557,18.755,6.684,22.621,8.5,24.37,14.235,7.217,6.191.757,4.705-.411,10.545,4.251,6.191.757Z",
    transform: "translate(258.951 71.276)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161763-2",
    "data-name": "Path 161763",
    d: "M26.643,3.776c-5.8-5.47-33.326-6.769-25.2,7.264,8.414,14.538,31.632-1.248,25.2-7.264C20.646-1.864,27.964,5.014,26.643,3.776Z",
    transform: "translate(284.625 95.232)",
    fill: "#9aad3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161764-2",
    "data-name": "Path 161764",
    d: "M16.154,2.988C15.213-8.232-1.395,14.093-.091,23.195c.9,6.08,5.366,5.026,8.774,1.788,5.441-5.1,8.1-14.436,7.47-22C15.928.333,16.593,8.211,16.154,2.988Z",
    transform: "translate(300.396 58.998)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161765-2",
    "data-name": "Path 161765",
    d: "M28.61,2.358C27.489-1.864,16.631.377,13.222.984,7.244,2.074-1.611,9.252.105,17.053c2.706,12.3,31.766-2.675,28.5-14.7C28.179.745,30.171,8.115,28.61,2.358Z",
    transform: "translate(408.33 62.854)",
    fill: "#9aad3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161766-2",
    "data-name": "Path 161766",
    d: "M14.536,1.384c1-5-20.5,3.467-13.043,14.487C7.019,24.1,21.617,5.17,14.536,1.384,14.826-.113,16.078,2.2,14.536,1.384Z",
    transform: "translate(293.772 121.505)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161767-2",
    "data-name": "Path 161767",
    d: "M13.5.781C9.937-3.132.593,7.393.057,10.775-2.112,24.517,20.21,8.136,13.5.781Z",
    transform: "translate(326.809 119.449)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161768-2",
    "data-name": "Path 161768",
    d: "M17.864,2.293C15.133-7.453-7.023,14.9,2,26.959,10.86,38.838,20.583,11.988,17.864,2.293,17.034-.675,19.945,9.671,17.864,2.293Z",
    transform: "translate(446.268 -3.05)",
    fill: "#9aad3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161769-2",
    "data-name": "Path 161769",
    d: "M202.651,62.156c6.61-10.033-4.2-25.414-14.49-18.674C186.5,35.956,181.527,32.732,174.585,35c-7.195,2.336-1.047,17.912,1.825,21.605a20.518,20.518,0,0,0-6.5.689c.321-6.475-2.2-14.065-8.918-14.629,5.732-9.357,1.027-16.184-8.617-12.963-4.473,1.475-8.858,4.84-10.464,9.862a6.464,6.464,0,0,0-3.814,3.714,26.167,26.167,0,0,0-7.96-3.04c9.169-7.266,2.184-21.263-7.35-24.653-9.4-3.4-4.769,21.143,2.351,24.266-3.324.109-9.292.846-11.094,4.692a18.984,18.984,0,0,0-6.671-6.685c7.53-3.309,14.461-28.112,3.837-24.334,3.53-7.734-3.913-21.677-8.834-9.378-4.428,11.084-2.131,9.547,4.4,11.66a28.522,28.522,0,0,0-9.262,8.814C97.2,19.057,92.069,3.13,84.167,7.894c-7.107,4.269-3.364,19.363,2.761,22.33-4.83-.01-19.028,7.264-11.8,14.2,4.871,4.694,20.125-1.513,21-8.808.865,2.048,3.36,1.43,4.964,2.278-6.95,3.374-5.735,11.566-1.1,16.494-1.788-.907-5.073-.472-6.207,1.581-5.354-3.952-17.925-4.407-19.6,4.879C71.5,75.9,110.625,70.633,102.012,56.26c4.868,4.075,22.837,9.05,17.2-2.37a31.869,31.869,0,0,0,17.765,2.019c-.983,2.8-9.418,5.935-11.819,9.493-4.049,5.916-.811,12.856-3.652,16.881-2-4.069-7.8-.428-9.754,1.545a37.547,37.547,0,0,0-5.127,6.843c-2.272-.964-3.913.525-4.966,2.613-5.987-22.479-21.97-8.17-16.217,10.064-5.573-2.033-7.081-.106-8.5-6.26-1-4.308-3.7-6.748-7.133-8.727,8.628-3.325,16.335-12.1,4.8-18.6-5.891-3.329,1.134-17.689-12.618-11.647.8-2.137,14.886-26.6,2.5-25.537C50.653,33.772,51.635,49.539,50.455,60.549c-3.458-3.793-3.981-7.838-1.749-11.6,1.582-2.632-3.86-12.265-5.085-14.535-1.164-2.141-8.516-10.807-9.606-2.805-.605,4.336-.406,8.779,1.653,12.6,1.582,2.9-2.57,3.37-3.265,6.959C27.63,46.239,7.746,46.607,15.33,55.288a18.119,18.119,0,0,0,10.912,6.045c6.788,1.037,6.778-.476,12.275,3.6-5.4.733-10.86,2.515-15.22,6.267-5.164,4.445-1.869,10.035-6.3,11.054C24.486,75.58,10.035,69.2,4.937,72.06c-10.1,5.6-5.081,15.378,4.822,13.153-15.689,9.674-4.148,20.211,9.608,13.661-3.793,2.656-25.442,15.715-15.8,22.027,4.563,2.969,10.923-3.693,14-6.62,5.05-4.779,7.118-7.69,12.439-9.446C19.953,120.969,33.991,126.091,42,111.449c.255,4.244,2.579,16.623,6.9,18.734,7.967,3.925,12.029-13.01,11.872-18.544A15.492,15.492,0,0,0,71.381,110.1a9.862,9.862,0,0,0,9.815,8.614c-15.413,21.19,11.738,24.452,18.948,6.214,8.183,22.619,32.121,4.663,15.35-9.044a20.979,20.979,0,0,0,5.639-10.551c.352,2.25,2.519,2.63,4.232,2.464,2.342,5.287,7.117,9.123,12.587,9.395-4.32,2.883-12.678,13.943-8.546,19.914,5.455,7.819,15.946-4.776,18.3-9.967,2.976-6.579-4.246-10.672-2.2-11.873,5.736-3.391,13.895-3.275,19.469-10.594-.694,5.239-1.114,14.972,3.246,18.613,2.563,2.088,4.684,3.226,3.644,5.407-7.021,14.832,22.545,15.327,11.43-4.857,9.158-1.189,6.987-10.242,13.052-12.037,8.629-2.526,3.328-21.881,1.131-27.488,9.363-1.276,12.559-16.288,5.179-22.152C205.459,57.891,206.11,64.909,202.651,62.156ZM95.306,32.221c-.813-.725-2.932-1.235-4.171-1.519,1.464-.534,3.1.013,4.354-1.078-.075.869-.129,1.737-.183,2.6C95.272,32.221,95.23,31.336,95.306,32.221ZM48.266,77.875A5.2,5.2,0,0,0,45.659,79.9c-1.874-1.225-.976-2.7,2.741-4.437-.033.8-.073,1.616-.134,2.416C47.3,78.157,48.272,77.059,48.266,77.875Zm1.606-7.79c-.323-5.172-1.442,1.187,1.047-4.15,1.445,1.176,1.079,2.563-1.047,4.15C49.873,70.051,50.365,68.947,49.873,70.085ZM121.76,102.73c-.765,1.071-1.464-3.145-4.062-3.385.667-.718,5.791,2.9,3.317,1.688,1.61.058,1.865.632.745,1.7C121.588,102.972,121.934,102.325,121.76,102.73ZM145.58,64.807c-.406-.5.459,14.506.637,17.118-3.569.067-9.312-3.822-12.1,1.149-.615-6.3,8.731-11.646,11.461-18.267C145.782,65.055,143.1,70.884,145.58,64.807Zm-.153,39.008c-3.307-4.911-8.963-6.738-14.372-5.944a17.246,17.246,0,0,0,3.162-9.666,8.667,8.667,0,0,0,6.932,3.735,27.949,27.949,0,0,0,7.246-.969,5.167,5.167,0,0,0,3.968,3.153,27.287,27.287,0,0,0-6.935,9.692C142.12,98.9,147.135,99.875,145.427,103.815Zm12.338-29.842c-.551-1.071-1.11-2.141-1.7-3.212,2.986.384,5.737-1.784,8.059-.158a27.641,27.641,0,0,0-6.363,3.37C157.268,72.876,159.713,72.584,157.765,73.972Z",
    transform: "translate(315.066 0.818)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161770-2",
    "data-name": "Path 161770",
    d: "M11.887,1.165C7.126-6.247-3.051,21.9.593,28.309c6.95,12.3,16.643-18.835,11.295-27.145C10.336-1.283,14.147,4.639,11.887,1.165Z",
    transform: "translate(467.588 115.269)",
    fill: "#5aa445"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_87748-2",
    "data-name": "Group 87748",
    transform: "translate(12.607 20.139)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161771-2",
    "data-name": "Path 161771",
    d: "M57.966,13.774c-.775-8.625-11.778.313-14.352,2.342,4.041-6.672,3.585-23.49-5.873-13.1-6.067,6.669-4.187,13.524-6.619,20.451a1.117,1.117,0,0,1-.375-.023C34.1,18.02,20.961,13.52,17.817,13.36c-6.574-.359-.471,15.664,8.56,13.213-5.646,5.093-3.807,4.607-11.456,3.731-5.256-.635-3.826,7.143-1.974,9.52-2.224.015-10.041-.267-11.669,1.189-6.078,5.431,6.9,6.795,9.771,5.34a5.687,5.687,0,0,0,4.46-4.3,10.473,10.473,0,0,0,6.972.984c4.68-.892,8.937-6.387,10.956-10.931,10.115,17.878,19.593-7.182,4.8-10.253.045-2.338,1.35-3.6,3.9-3.8-2.857,7.076,16.976,9.116,15.833-4.277C57.725,11.308,58.285,17.571,57.966,13.774Z",
    transform: "translate(-0.872 117.708)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161772-2",
    "data-name": "Path 161772",
    d: "M4.578.314C-4.27-2.6,1.607,14.517,5.846,17,10.818,23.66,16.815,4.347,4.578.314,2.25-.452,10.029,2.116,4.578.314Z",
    transform: "translate(19.861 100.034)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161773-2",
    "data-name": "Path 161773",
    d: "M16.418,7.189C14.3,4.29,7.312-2.324,2.875.766-9.407,9.274,21.484,14.151,16.418,7.189Z",
    transform: "translate(3.33 118.479)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161774-2",
    "data-name": "Path 161774",
    d: "M11.125,2.678C10.133-3.427-2.289,1.884.639,7.15-3.687,12.724,13.38,16.974,11.125,2.678Z",
    transform: "translate(57.511 113.382)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161775-2",
    "data-name": "Path 161775",
    d: "M28.941,16.378C25.122,10.628,21.008,3.29,14.534,2.251,3.894-5.619-7.806,9,7.324,11.239c-17.8,10.024.7,21.08,9.123,6.316-4.086,18.268,21.468,12.351,12.494-1.177C28.273,15.4,29.96,17.927,28.941,16.378Z",
    transform: "translate(79.527 104.068)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161776-2",
    "data-name": "Path 161776",
    d: "M12.917,9.344C10.666-8.175-4.393,2.156,1.159,13.387c4.591,9.278,13.172,6.864,11.758-4.043C12.53,6.339,13.324,12.479,12.917,9.344Z",
    transform: "translate(92.662 81.2)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161777-2",
    "data-name": "Path 161777",
    d: "M13.84,8.938C17.895,5.945,4.762-4.306,1.093,1.959-4.082,8.837,10.006,11.74,13.84,8.938,15.4,7.784,13.642,9.077,13.84,8.938Z",
    transform: "translate(74.973 88.349)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161778-2",
    "data-name": "Path 161778",
    d: "M19.171,10.811C17.8,5.5.617-6.245-.02,4.091c-.646,9.881,21.7,16.261,19.19,6.719C17.983,6.246,20.079,14.311,19.171,10.811Z",
    transform: "translate(58.818 128.445)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161779-2",
    "data-name": "Path 161779",
    d: "M12.135,7.762C11.359,2.954,2.078-4.151.387,3.029-2.987,17.286,14.42,21.654,12.135,7.762,11.795,5.753,12.566,10.372,12.135,7.762Z",
    transform: "translate(57.193 141.987)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161780-2",
    "data-name": "Path 161780",
    d: "M29.335,20.7c-2.213-6.131-7.934-10.226-14.077-9.866C29.728-11.265-6.939,5.618,1.078,13.8c3.325,3.381,3.828.876,5.318,5.087a13.192,13.192,0,0,0,6.79,7.157c3.127,1.56,19.464,3.847,16.148-5.345C27.657,16.048,30.311,23.4,29.335,20.7Z",
    transform: "translate(102.544 96.84)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161781-2",
    "data-name": "Path 161781",
    d: "M11.85.364C9.884,1.469-8.23,15.191,4.266,15.621c10.988.4,13.956-18.885,7.584-15.257C9.192,1.869,14.413-1.089,11.85.364Z",
    transform: "translate(124.57 89.746)",
    fill: "#d0d028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161782-2",
    "data-name": "Path 161782",
    d: "M11.45,5.132C8.224-2.358-1.427-1.871.126,7.711c2,12.149,16.442,9.283,11.324-2.579C10.484,2.861,12.57,7.7,11.45,5.132Z",
    transform: "translate(109.729 128.258)",
    fill: "#d0d028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161783-2",
    "data-name": "Path 161783",
    d: "M23.572,17.086c4.316-2.41,11.315-13.272,3.85-16.848C21.623-2.5,15.7,9.06,16.322,14.007c-4.011-1.907-8.3-8.737-13.592-7.2C-5.578,9.266,6.492,23.039,14.017,20.375,12.242,25.149,15.829,31.8,19.5,34.082c-4.046.93-8.536,4.674-6.594,10.635,3.1,9.451,12.837-3.277,9.627-9.289,12.529,3.37,8.1-14.436,1.036-18.341C28.348,14.4,28.077,19.6,23.572,17.086Z",
    transform: "translate(234.475 66.726)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161784-2",
    "data-name": "Path 161784",
    d: "M20.62,9.24c-.719-1.465-8.7-4.96-10.344-6.333C6.058-.631-.785-2.45.031,6.286,1.313,20.073,24.041,16.231,20.62,9.24,19.41,6.79,22,12.067,20.62,9.24Z",
    transform: "translate(220.956 85.894)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161785-2",
    "data-name": "Path 161785",
    d: "M18.438-.122c-4.046-.007-9.71.2-13.262,2.583C2.57,4.224-4.1,13.08,3.3,14.361a17.552,17.552,0,0,0,13.73-4.048C18.98,8.684,25.26-.066,18.438-.122,17.121-.122,20.3-.1,18.438-.122Z",
    transform: "translate(218.178 107.246)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161786-2",
    "data-name": "Path 161786",
    d: "M51.228,24.306c-3.313-2.2-9.679-2.143-11.827-5.137,3.787-2.9,12.709-10.814,7.216-16.286C37.853-5.79,27.375,12.427,25.942,19.855c-.779-.777.691-3.091-.021-4.564-1.566-3.17-3.652-7.109-5.607-10.285C12.433-7.782,4.284,6.37,10.681,15.868-.6,10.194-5.167,26.781,7.332,24.065c-8.015,10.773,8.545,10.7,14.009,7.082-2.883,6.922,4.45,26.556,10.26,15.8,6.157-11.474-6.775-16.6-5.028-22.134,1.777,1.475,3.423.312,4.594-1.269.808,6.063,9.14,8.636,13.483,9.088C48.2,33.009,58.764,29.292,51.228,24.306Z",
    transform: "translate(267.77 59.046)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161787-2",
    "data-name": "Path 161787",
    d: "M11.721,1.868C7.034-5.466-1.037,10.138-.015,15,2.065,25.168,17.771,11.325,11.721,1.868,11.431,1.406,15.3,7.448,11.721,1.868Z",
    transform: "translate(271.368 98.199)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161788-2",
    "data-name": "Path 161788",
    d: "M48.506,4.858c3.648-9.841-10.362-3.015-12.472-.852A14.715,14.715,0,0,0,31.711,11.9c-1.578.312-3.217.538-4.334,1.989-4.368-3.426-5.117-8.277-11.537-9.282-11.169-1.737-2.023,15.271,3.487,17.4C14.886,24.815-1.283,23.825-.2,34.588c1.215,11.845,18.755,1.883,22.914-2.357C21.292,36.908,18.267,50.08,24.349,52.5c8.266,3.261,12.792-8.21,11.295-15.145C50.6,46.3,50.68,23.642,36.1,20.853c6.2-2.922,9.97-9.42,12.406-16C49.711,1.575,46.731,9.615,48.506,4.858ZM26.655,24.786c.126-4.161.036-3.92,3.461-3.015-1.8,1.207-1.484,2.322-3.461,3.015C26.664,24.579,27.107,24.619,26.655,24.786Z",
    transform: "translate(323.837 37.293)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161789-2",
    "data-name": "Path 161789",
    d: "M17.185,11.5C15.895,6.121.544-6.788-.024,4.407-.6,16.239,19.238,19.868,17.185,11.5,17.04,10.824,17.682,13.475,17.185,11.5Z",
    transform: "translate(325.618 24.723)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161790-2",
    "data-name": "Path 161790",
    d: "M16.5,2.839C12.464-6.623,1.422,9.405.112,14.89-2.816,27.1,22.59,17.16,16.5,2.839,16.427,2.667,19.378,9.635,16.5,2.839Z",
    transform: "translate(320.799 80.08)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161791-2",
    "data-name": "Path 161791",
    d: "M11.468,7.071C10.148,3.849,2.161-4.744.143,3.358c-1.159,4.529,3.727,8.029,3.9,12.566-.632,7.955,12.005,2.213,7.427-8.853C10.021,3.514,12.923,10.569,11.468,7.071Z",
    transform: "translate(361.355 82.618)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161792-2",
    "data-name": "Path 161792",
    d: "M8.3.159C.579-2.126-2.511,15.258,2,19.215c7.545,6.619,15-16.477,6.3-19.056Z",
    transform: "translate(343.329 93.776)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161793-2",
    "data-name": "Path 161793",
    d: "M13.389,6.417C12.816,6.4,6.195,1.266,5.5.841-1.078-3.292-.853,8.611,1.341,11.863c7.68,11.345,19.633-5.094,12.048-5.446C13.286,6.418,15.646,6.513,13.389,6.417Z",
    transform: "translate(377.346 8.369)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161794-2",
    "data-name": "Path 161794",
    d: "M12.768,3.016C12.811-5.571-4.121,5.22.8,17.538,3.824,25.013,12.739,6.884,12.768,3.016Z",
    transform: "translate(398.892 8.12)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161795-2",
    "data-name": "Path 161795",
    d: "M17.035,2.636C15.572-5.3-1.219,5.838-.035,13.643,1.6,24.7,19.012,12.98,17.035,2.636,16.714.833,18.551,10.671,17.035,2.636Z",
    transform: "translate(384.414 31.176)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161796-2",
    "data-name": "Path 161796",
    d: "M14.892.773C9.539,5.022-3.7,4.743.84,17.072c1.866,5.084,15.333,10.76,14.779,1.652-.507-8-4.581-4.232,1.18-10.125C19.281,6.055,19.607-2.946,14.892.773,14.055,1.432,17.075-.952,14.892.773Z",
    transform: "translate(401.664 22.612)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161797-2",
    "data-name": "Path 161797",
    d: "M27.167,5.315c-3.646-6.989-13.426-7.481-17.145-.1C7.08,10.979.867,14.262-.119,23.054c-1.09,9.9,13.18,2.093,14.215-5.134,1.258-8.6,3.193-1.81,7.724-8.408,2.4.946,7.66.283,5.346-4.2C23.46-1.794,28.424,7.782,27.167,5.315Z",
    transform: "translate(395.388 46.403)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161798-2",
    "data-name": "Path 161798",
    d: "M36.6,31.671c-2.728-14.92-23.377-17.135-13.31-.15q-2.445-1.492-4.034,1.111c2.826-9.371-2.888-20.971-8.123-28.069C-1.6-12.714-6.468,24.6,12.8,20.306,8.992,24.648,5.766,30.085,5.229,36.2c-.845,9.977,10.983,3.011,13.088-1.241-9.838,27.556,19.838,19.643,11.031,2,3.508,1.644,8.194-.056,7.251-5.293C35.59,26.116,37.228,35.139,36.6,31.671Z",
    transform: "translate(378.365 57.533)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161799-2",
    "data-name": "Path 161799",
    d: "M13.634.079C7.755,1.615-8.241,13.147,5.056,16,16.16,18.379,21.6-1.961,13.634.079,8.309,1.465,16.7-.707,13.634.079Z",
    transform: "translate(444.29 3.761)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161800-2",
    "data-name": "Path 161800",
    d: "M16.452,21.891c1.045-5.715,5.29-9.474-.508-17.093-10.365-13.6-17,4.852-5.826,12.821-1.865.322-5.309-.772-6.587-.488C-2.988,18.568.226,26.7,4.782,27.876c-3.245,3.331-6.832,15.94,1.841,13.078,4.09-1.36,18.976-19.573,9.83-19.063C16.581,21.09,17.524,21.815,16.452,21.891Z",
    transform: "translate(422.965 -2.89)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161801-2",
    "data-name": "Path 161801",
    d: "M3.787.084c-6.3.267-4.532,22.362,2.849,22.484C16,22.684,13.444-.326,3.787.084Z",
    transform: "translate(441.887 23.592)",
    fill: "#d0d028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161802-2",
    "data-name": "Path 161802",
    d: "M11.167,4.286C9.9-4.077,4.039,1.292,1.407,6.613-5.373,20.163,13.235,18,11.167,4.286,11.075,3.771,11.98,9.713,11.167,4.286Z",
    transform: "translate(377.559 110.403)",
    fill: "#d0d028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161803-2",
    "data-name": "Path 161803",
    d: "M2.733-.019C-.911.006-.957,6.187,2.687,6.162S6.376-.044,2.733-.019Z",
    transform: "translate(418.862 103.996)",
    fill: "#d0d028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161804-2",
    "data-name": "Path 161804",
    d: "M15.768.155C9.9,2.6,4.828,4.226.888,10.236c-3.4,5.232,2.774,8.594,6.517,8.13C18,17.064,18.163-.842,15.768.155,14.707.592,17.677-.623,15.768.155Z",
    transform: "translate(423.69 41.907)",
    fill: "#d0d028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161805-2",
    "data-name": "Path 161805",
    d: "M11.761,3.042C11.017-2.514,3.769.6,1.812,3.119c-3.561,4.623-1.22,9.025.26,13.708,5.42,17.18,10.865-4.982,9.688-13.785C11.535,1.281,12.537,8.779,11.761,3.042Z",
    transform: "translate(473.555 18.576)",
    fill: "#d0d028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161806-2",
    "data-name": "Path 161806",
    d: "M34.655,3.468C33.4-7.372,21.333,8.578,21.223,14.3c-6.957,2.5-6.4,7.307-10.132,11.08C6.671,29.815-3.693,40.88.759,48.706c5.375,9.436,14.491-5.488,14.032-11.683,2.747,2.225.693,17.934,9.544,14.848,12.053-4.243-.512-19.311-5.075-23.225,11.3-1.538,16.715-13.738,15.394-25.178C34.3.367,35.374,9.591,34.655,3.468Z",
    transform: "translate(436.49 30.96)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161807-2",
    "data-name": "Path 161807",
    d: "M17.053,2.538C15-5.794-2.006,7.68.076,14.869,3.341,26.4,19.152,11.231,17.053,2.538,16.7,1.114,17.311,3.645,17.053,2.538Z",
    transform: "translate(418.232 64.961)",
    fill: "#d0d028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161808-2",
    "data-name": "Path 161808",
    d: "M11.022,6.1C7.09-3.723-4.8-.84,2.067,8.448,1.251,22.826,16.917,20.819,11.022,6.1,9.823,3.092,12.282,9.2,11.022,6.1Z",
    transform: "translate(466.909 54.436)",
    fill: "#d0d028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161809-2",
    "data-name": "Path 161809",
    d: "M12.051.1C8.847.72-2.788,6.619.508,12.029,7.66,23.773,21.713-1.843,12.051.1,10.145.462,14.778-.464,12.051.1Z",
    transform: "translate(369.113 45.759)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161810-2",
    "data-name": "Path 161810",
    d: "M7.764,3.069C4.943-7.588-.2,12.4-.107,14.64c.169,2.973,2.712,5.018,5.347,3.943,5.522-2.2,3.7-11.208,2.523-15.515C7.014.168,8.959,7.47,7.764,3.069Z",
    transform: "translate(440.474 87.017)",
    fill: "#5aa445"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_87749",
    "data-name": "Group 87749",
    transform: "translate(1051.283 82.425)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161749-3",
    "data-name": "Path 161749",
    d: "M662.135,48.381c5.8-3.636,7.148-9.278,6.274-15.046-.526-3.692-4.363-5.409-8.609-3.975a33.131,33.131,0,0,0-9.735,5.416c-1.645-1.378-4.2-1.925-7.981-.73a21.849,21.849,0,0,0-4.219,1.918,23.377,23.377,0,0,0-1.6-4.648c-1.27-2.68-5.38-4.793-8.821-2.868-5.919,3.3-7.585,8.215-7.913,13.788-.061,1.044-.1,2.3-.075,3.573a44.844,44.844,0,0,0-14.569-2.566,66.184,66.184,0,0,0,7.92-8.133c2.26-2.969-.792-7.63-5.059-7.624a21.189,21.189,0,0,0,.43-12.492c-.949-3.353-6-4.655-9.531-3.095a28.583,28.583,0,0,0-13.954,13.127,58.668,58.668,0,0,0-5.776-11.983c-2.294-3.579-8.643-3.1-11.08,0a17.408,17.408,0,0,0,.321,21.663,40.758,40.758,0,0,0-6.923,4.674c-1.017-7.341-3.052-14.392-10.207-19.864-2.205-1.692-6.622-2.151-8.718,0-.178.182-.307.371-.478.547-.676-.679-1.386-1.321-2.123-1.931-4.472-3.673-13.463-3.925-16.9.944-2.765,3.856-2.308,8.2-.28,12.524-.232.013-.485.013-.724.038-4.615.491-8.152,4.837-4.1,7.926,2.99,2.271,6.056,4.56,9.278,6.756a42.129,42.129,0,0,0-18.713,7.026c-1.031-6.29-2.519-12.442-8.787-16.87-2.321-1.629-6.513-2.2-8.739,0a24.325,24.325,0,0,0-3.079,3.774c-4.192-3.8-9.333-5.944-14.788-3.4-6.124,2.862-6.288,10.089-3.919,14.675a20.5,20.5,0,0,0,3.154,4.353c-3.339.931-5.489,4.63-3.42,7.2q1.987,2.453,4.076,4.8a43.34,43.34,0,0,0-11.572,2.944A24.8,24.8,0,0,0,458.3,58.76c-1.5-2.768-5.919-2.881-8.78-1.849-7.81,2.78-12.678,7.5-15.634,13.109a68.619,68.619,0,0,0-9.476-11.052c-3.181-2.906-9.592-.591-9.428,3.12a36.3,36.3,0,0,0,3.072,12.958,27.179,27.179,0,0,0-8.889,5.944,25.9,25.9,0,0,0-8.035-10.743,7.782,7.782,0,0,0-9.135,0c-5.366,3.9-6.418,8.9-5.8,14.1A45.076,45.076,0,0,0,375.8,77.655a6.978,6.978,0,0,0-9.264,3.013c-3.878,7.944,3.83,15.36,12.767,16.612a26.1,26.1,0,0,0-2.608,2.5,7.447,7.447,0,0,0-7.2-.686,22.111,22.111,0,0,0-5.079,2.648c-3.816-6.4-7.981-12.568-15.054-17.31-4.95-3.327-11.244-.138-10.316,4.8a43.263,43.263,0,0,0,2.622,8.435,24,24,0,0,0-15.743-2.73c-5.366-8.693-20.256-1.333-31.63,6.812a11.429,11.429,0,0,0-2.1-2.107c-2.895-2.227-6.315-2.459-9.783-1.73a5.9,5.9,0,0,0-6.486-4.4c-1,.088-1.994.226-2.942.359a18.809,18.809,0,0,0,.369-5.221c-.239-3.4-4.67-5.749-8.582-3.944a43.193,43.193,0,0,0-6.008,3.371,47.6,47.6,0,0,0-4.547-16.222c-1.543-3.214-5.12-4.258-9-2.937-9.681,3.283-11.394,10.3-10,17.964a19.212,19.212,0,0,0-10.732.4c-3.96,1.264-6.124,4.491-3.919,7.693a45.078,45.078,0,0,0,11.2,11.492,55.058,55.058,0,0,0-5.387,2.334,5.693,5.693,0,0,0-5.707-3.56c-3.543.151-8.9,1.881-13.477,4.453a28.44,28.44,0,0,0-4.875-14.065c-2.144-2.919-7.148-3.346-10.131-1.044a22.122,22.122,0,0,0-5.557,6.177C182.489,93.2,175.376,86.839,164.5,87.273c-3.209.126-5.025,1.887-5.4,4.328-1.673,11.36,7.742,18.43,19.471,22.349a6.223,6.223,0,0,0,.341,1.227c-9.544-1.856-18.945-.988-25.608,6.227-2.171,2.39-.355,5.743,2.362,7.183.819.409,1.639.767,2.478,1.094a7.676,7.676,0,0,0,.191,2.415,8.073,8.073,0,0,0,1.14,2.39,10.3,10.3,0,0,0-1.966,1.56,14.593,14.593,0,0,0-1.816,2.158,20.788,20.788,0,0,0-3.714-1.415,20.25,20.25,0,0,0-16.733,3.327c-5.387,4.082-4.287,10.165,1.468,13.5a13.69,13.69,0,0,0,3.311,1.371c-.191.34-.464.648-.683,1.006-1.871,3.214-.348,6.787,4.035,7.907a23.255,23.255,0,0,0,15.928-1.5c12.514,7.334,48.22,1.271,59.055-.981a1430.009,1430.009,0,0,1,186.285-25.487c39-2.843,77.358-3.912,116.477-1.912,36.068,1.837,76.968-2.317,115.139-5.435S665.494,83.09,662.135,48.381ZM497.226,60.244c.164,1.39.328,2.724.573,3.994-.7-.868-1.468-1.692-2.246-2.5A4.6,4.6,0,0,0,497.226,60.244Z",
    transform: "translate(-131.746 -10.535)",
    fill: "#2c592b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87747-3",
    "data-name": "Group 87747",
    transform: "translate(5.405 9.773)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161750-3",
    "data-name": "Path 161750",
    d: "M187.116,47.437c6.363-4.227,1.748-13.348-6.629-12.329,1.113-2.981-.553-8.882-6.035-5.409-5.728,3.648-4.724,8.485-8.6,12.555a1.1,1.1,0,0,0-.376-.579c7.967-.862-12.753-15.046-14.89-15.882-5.352-2.145-5.667,3.139-4.253,5.554,2.355,3.982,7.046,9.114,13,9.674-5.045,3.132-15.6-3.353-20.536,3.535-6.97,9.687,15.252,8.989,20.754,5.969.417,5.73,8.117,25.815,16.549,12.926,4.226-6.472,9.162,1.937,15.743-2.893,4.561-3.34-1.475-10.743-4.724-13.121C189.854,45.625,190.6,49.978,187.116,47.437Z",
    transform: "translate(-103.894 57.752)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161751-3",
    "data-name": "Path 161751",
    d: "M161.994,31.184c-3.475,3.145-12.917.931-18.877,5.12-5.5,3.85-12.855,12.259-.027,12.851,9.114.428,16.788-5.384,22.373-10.442,4.212-3.812,1.98-12.524-3.468-7.529C161.312,31.82,165.756,27.756,161.994,31.184Zm-7.947,6.623A26.94,26.94,0,0,1,148.9,40.55,15.418,15.418,0,0,1,154.048,37.808Z",
    transform: "translate(-112.526 80.962)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161752-3",
    "data-name": "Path 161752",
    d: "M154.425,32.729c-3.748-4.252-26.557-1.05-21.028,5.3,3.222,3.661,12.794,2.378,17.068,1.214,1.249-.346,11.36-5.139,3.96-6.51C154.159,32.4,156.958,33.194,154.425,32.729Z",
    transform: "translate(-132.538 86.865)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161753-3",
    "data-name": "Path 161753",
    d: "M154.186,28.891c-5.7-.7-11.729-.843-17.3.547-6.636,1.661-1.14,6.435,2.335,7.5,9.38,2.862,16.986-7.819,14.965-8.051C148.54,28.193,156.111,29.124,154.186,28.891Z",
    transform: "translate(-125.369 74.046)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161754-3",
    "data-name": "Path 161754",
    d: "M198.868,54.694c-2.226-4.29-7.011-7.353-12.2-9.171,5.871-3.856,8.349-10.177,6.3-16.021-2.553-7.372-15.982.881-18.727,3.818-1.884-2.617-9.92-15.153-14.76-8.183-4.861,7.013,7.872,13,9.674,18.015-7.367-1.617-15.846,1.252-21.185,5.258-8.814,6.63,12.343,7.686,15.907,7.152-5.079,15.537,11.866,12.4,15.1-.063a37.538,37.538,0,0,0,7.721,2.585,2.618,2.618,0,0,0-.881,2.113c-2.895-2.831-8.275,8.064,1.372,11.115,7.448,2.365,7.223-9.649,5.537-12.4,2.792.2,7.844-.855,6.137-4.221C196.7,50.492,199.927,56.751,198.868,54.694Z",
    transform: "translate(-55.015 45.916)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161755-3",
    "data-name": "Path 161755",
    d: "M161.444,28.546c-4.9-1.063-6.684-4.787-12.657-4.655-4.84.088-4.226,5.133-2.424,7.322C153.715,40.05,165.533,29.426,161.444,28.546Z",
    transform: "translate(-59.713 50.326)",
    fill: "#9aad3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161756-3",
    "data-name": "Path 161756",
    d: "M156.878,28.931c-2.772,1.56-17.006,9.083-8.09,11.932,10.828,3.472,14.747-15.65,8.09-11.932C155.875,29.5,159.6,27.409,156.878,28.931Z",
    transform: "translate(-54.745 74.006)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161757-3",
    "data-name": "Path 161757",
    d: "M168.258,24.8c-6.131-.189-21.785,9.7-12.1,13.649,12.18,4.944,21.3-13.341,12.1-13.649C165.233,24.707,170.4,24.871,168.258,24.8Z",
    transform: "translate(-12.9 54.988)",
    fill: "#9aad3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161758-3",
    "data-name": "Path 161758",
    d: "M193.783,37.627c.86-3.076-3.728-4.73-6.131-6.064-1.222-4.126-5.277-6.907-9.94-8.58-13.211-4.755-7.332,6.623-1.666,10.561C168.994,36.35,163.6,46.9,175,47.666c5.318.352,23.437-2.566,18.781-10.039C194.131,36.325,194.363,38.571,193.783,37.627Z",
    transform: "translate(76.448 39.502)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161759-3",
    "data-name": "Path 161759",
    d: "M217.407,39.82c-.655-5.064-8.978-3.353-12.917-2.686-8.445,1.447-4.369-1.227-8.793-5.762a7.627,7.627,0,0,0-6.336-2.321,4.119,4.119,0,0,0-2.581-3.648c-7.169-2.535-10.145,9.819-9.1,13.039-2.656.56-17.546-3.151-14.31,3.9,2.622,5.693,15.668,3.812,19.737.61,5.68,2.856,9.729.686,15.088,2.636,5.264,1.925,20.12,1.453,19.212-5.768C217.162,37.958,217.94,44.16,217.407,39.82Z",
    transform: "translate(44.46 56.544)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161760-3",
    "data-name": "Path 161760",
    d: "M189.1,30.6c-1.912-9.24-14.255-6.51-16.638,1.12-3.591,11.561,19.212,11.259,16.638-1.12C188.889,29.642,189.436,32.233,189.1,30.6Z",
    transform: "translate(97.87 54.891)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161761-3",
    "data-name": "Path 161761",
    d: "M191.078,22.523c-1.932-6.454-25.192,7.793-16.781,19.034,3.106,4.164,11.285-2.057,13.087-4.114a15.888,15.888,0,0,0,3.694-14.92C190.573,20.862,193.222,29.744,191.078,22.523Z",
    transform: "translate(100.153 34.572)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161762-3",
    "data-name": "Path 161762",
    d: "M176.77,21.172c-3.816-2.239-5.864,2.547-6.124,4.353-.621,4.548,2.622,8.8,6.779,11.649,1.83,1.289,7.442-11.234-.655-16C175.275,20.31,181.153,23.751,176.77,21.172Z",
    transform: "translate(89.077 32.866)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161763-3",
    "data-name": "Path 161763",
    d: "M201.047,26.291c-5.844-4.032-33.4-5.12-25.165,5.189,8.527,10.681,31.644-.755,25.165-5.189C195,22.133,202.378,27.2,201.047,26.291Z",
    transform: "translate(111.157 47.718)",
    fill: "#9aad3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161764-3",
    "data-name": "Path 161764",
    d: "M192.817,21.459c-1.024-8.215-17.477,8.039-16.105,14.706.942,4.453,5.407,3.7,8.793,1.352a17.618,17.618,0,0,0,7.312-16.059C192.572,19.515,193.3,25.283,192.817,21.459Z",
    transform: "translate(124.397 25.484)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161765-3",
    "data-name": "Path 161765",
    d: "M221.1,21.594c-1.154-3.095-12-1.51-15.409-1.082-5.974.767-14.781,5.976-13.006,11.693,2.8,9.014,31.767-1.8,28.414-10.611C220.658,20.412,222.706,25.815,221.1,21.594Z",
    transform: "translate(216.605 28.311)",
    fill: "#9aad3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161766-3",
    "data-name": "Path 161766",
    d: "M190.283,27.544c.963-3.655-20.488,2.434-12.944,10.536,5.591,6.051,20.058-7.731,12.944-10.536C190.563,26.45,191.833,28.148,190.283,27.544Z",
    transform: "translate(119.135 63.926)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161767-3",
    "data-name": "Path 161767",
    d: "M194.079,26.884C190.488,24,181.217,31.658,180.7,34.13c-2.069,10.045,20.147-1.83,13.374-7.246Z",
    transform: "translate(147.338 62.8)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161768-3",
    "data-name": "Path 161768",
    d: "M215.837,13.857c-2.806-7.146-24.81,9.1-15.7,17.971,8.957,8.737,18.488-10.863,15.7-17.971C214.984,11.68,217.974,19.266,215.837,13.857Z",
    transform: "translate(248.591 -12.089)",
    fill: "#9aad3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161769-3",
    "data-name": "Path 161769",
    d: "M381.961,58.933c6.54-7.309-4.39-18.619-14.638-13.738-1.713-5.516-6.718-7.9-13.647-6.277-7.182,1.673-.915,13.1,1.987,15.82a27.682,27.682,0,0,0-6.5.472c.273-4.736-2.3-10.3-9.032-10.75,5.667-6.818.908-11.838-8.718-9.529-4.465,1.057-8.828,3.5-10.4,7.164a5.88,5.88,0,0,0-3.789,2.7,32.969,32.969,0,0,0-7.988-2.264c9.121-5.271,2.028-15.549-7.537-18.078-9.428-2.535-4.615,15.448,2.533,17.769-3.325.063-9.292.572-11.067,3.378a17.787,17.787,0,0,0-6.725-4.925c7.51-2.384,14.262-20.5,3.659-17.788,3.475-5.642-4.076-15.882-8.909-6.907-4.349,8.089-2.062,6.976,4.492,8.555a26.22,26.22,0,0,0-9.2,6.4c-.355-4.07-5.612-15.75-13.483-12.3-7.08,3.088-3.222,14.153,2.929,16.354-4.834-.031-18.986,5.221-11.7,10.335,4.909,3.46,20.126-1.006,20.953-6.34.881,1.5,3.373,1.063,4.984,1.692-6.93,2.434-5.653,8.435-.983,12.064-1.8-.673-5.079-.371-6.2,1.126-5.387-2.919-17.969-3.315-19.58,3.472-2.574,11,36.539,7.341,27.814-3.221,4.9,3.007,22.919,6.737,17.191-1.648A42.981,42.981,0,0,0,316.2,54.033c-.963,2.044-9.38,4.3-11.756,6.888-4.007,4.309-.717,9.4-3.53,12.335-2.028-2.988-7.81-.352-9.749,1.082a29.55,29.55,0,0,0-5.079,4.982,4.158,4.158,0,0,0-4.95,1.887c-6.158-16.48-22.045-6.089-16.153,7.284-5.591-1.516-7.086-.113-8.554-4.623-1.031-3.158-3.755-4.957-7.2-6.422,8.609-2.39,16.255-8.775,4.67-13.587-5.919-2.466,1-12.939-12.712-8.586.785-1.56,14.7-19.392,2.314-18.675-13.838.805-12.739,12.347-13.838,20.4-3.489-2.793-4.042-5.755-1.836-8.5,1.563-1.918-3.953-8.995-5.2-10.662-1.181-1.573-8.6-7.951-9.633-2.1-.573,3.17-.341,6.422,1.748,9.228,1.6,2.132-2.547,2.453-3.216,5.076-4.813-3.629-24.707-3.46-17.054,2.931a20.943,20.943,0,0,0,10.964,4.479c6.8.793,6.779-.314,12.309,2.692-5.394.51-10.848,1.786-15.184,4.51-5.134,3.227-1.8,7.334-6.226,8.058,7.448-4.843-7.059-9.586-12.139-7.517-10.063,4.051-4.97,11.228,4.922,9.649-15.627,7-4,14.769,9.715,10.045-3.775,1.925-25.342,11.372-15.648,16.04,4.588,2.2,10.9-2.648,13.962-4.774,5.018-3.472,7.066-5.592,12.377-6.85-9.94,11.756,4.144,15.574,12.05,4.9.287,3.107,2.7,12.178,7.046,13.744,8,2.912,11.941-9.46,11.743-13.511a20.5,20.5,0,0,0,10.6-1.076c.935,3.975,5.018,6.221,9.886,6.353-15.265,15.43,11.927,17.952,19.007,4.642,8.356,16.593,32.176,3.573,15.293-6.542a14.411,14.411,0,0,0,5.564-7.693c.369,1.648,2.54,1.937,4.253,1.824a15.664,15.664,0,0,0,12.664,6.938c-4.3,2.088-12.582,10.14-8.4,14.53,5.516,5.749,15.921-3.416,18.235-7.2,2.929-4.8-4.328-7.831-2.294-8.7,5.714-2.453,13.88-2.327,19.4-7.655-.656,3.831-1,10.951,3.386,13.637,2.581,1.541,4.711,2.384,3.687,3.975-6.916,10.819,22.673,11.328,11.4-3.5,9.155-.824,6.916-7.46,12.972-8.743,8.616-1.805,3.168-16,.928-20.109,9.36-.887,12.446-11.857,5.018-16.184C384.739,55.826,385.443,60.965,381.961,58.933ZM274.324,36.49a14.942,14.942,0,0,0-4.185-1.132c1.461-.384,3.106.025,4.349-.767-.068.635-.116,1.271-.164,1.9C274.29,36.49,274.243,35.842,274.324,36.49ZM227.593,69.664A5.191,5.191,0,0,0,225,71.129c-1.884-.906-1-1.981,2.71-3.233-.027.585-.061,1.183-.116,1.768C226.63,69.865,227.593,69.066,227.593,69.664Zm1.55-5.693c-.362-3.787-1.434.862,1.017-3.032,1.454.868,1.1,1.881-1.017,3.032C229.143,63.946,229.627,63.141,229.143,63.971ZM301.319,88.22c-.758.78-1.488-2.308-4.089-2.5.662-.522,5.817,2.151,3.332,1.252,1.611.05,1.871.472.758,1.245C301.148,88.4,301.489,87.924,301.319,88.22Zm23.554-27.632c-.41-.365.567,10.618.765,12.53-3.571.031-9.346-2.843-12.1.78-.662-4.617,8.65-8.479,11.333-13.31C325.077,60.77,322.435,65.022,324.872,60.587Zm.136,28.544c-3.345-3.611-9.019-4.975-14.426-4.422a10.382,10.382,0,0,0,3.092-7.057c1.591,1.786,4.315,2.648,6.964,2.768a37.538,37.538,0,0,0,7.244-.673,5.234,5.234,0,0,0,3.994,2.327,21.054,21.054,0,0,0-6.868,7.057C321.664,85.521,326.688,86.257,325.009,89.132Zm12.125-21.776c-.56-.786-1.126-1.573-1.72-2.359,2.99.3,5.728-1.277,8.063-.075a31.658,31.658,0,0,0-6.342,2.434C336.629,66.55,339.073,66.349,337.134,67.355Z",
    transform: "translate(136.558 -10.26)",
    fill: "#367137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161770-3",
    "data-name": "Path 161770",
    d: "M213.1,26.783c-4.82-5.447-14.794,15.1-11.1,19.807,7.046,9.039,16.515-13.7,11.1-19.807C211.531,24.984,215.388,29.337,213.1,26.783Z",
    transform: "translate(267.548 60.819)",
    fill: "#5aa445"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_87748-3",
    "data-name": "Group 87748",
    transform: "translate(12.764 14.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161771-3",
    "data-name": "Path 161771",
    d: "M191.721,36.951c-.84-6.315-11.784.17-14.344,1.642,3.994-4.862,3.414-17.172-5.974-9.618-6.022,4.85-4.089,9.875-6.472,14.933a1.523,1.523,0,0,1-.376-.019c3.311-3.95-9.865-7.309-13.012-7.441-6.581-.3-.355,11.461,8.664,9.712-5.612,3.7-3.775,3.353-11.435,2.673-5.264-.491-3.775,5.208-1.9,6.957-2.226,0-10.05-.245-11.668.811-6.042,3.944,6.95,5.007,9.817,3.956,2.39-.428,3.864-1.478,4.431-3.126a14.012,14.012,0,0,0,6.984.755c4.677-.629,8.9-4.63,10.882-7.944,10.254,13.134,19.553-5.158,4.724-7.479.027-1.711,1.324-2.629,3.871-2.761-2.806,5.164,17.054,6.756,15.812-3.051C191.462,35.146,192.069,39.731,191.721,36.951Z",
    transform: "translate(-133.616 59.551)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161772-3",
    "data-name": "Path 161772",
    d: "M141.219,24.794c-8.875-2.176-2.867,10.379,1.393,12.215,5.025,4.9,10.882-9.2-1.393-12.215C138.884,24.222,146.687,26.14,141.219,24.794Z",
    transform: "translate(-116.02 48.761)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161773-3",
    "data-name": "Path 161773",
    d: "M150.715,32.018c-2.137-2.132-9.182-7.007-13.6-4.768C124.888,33.414,155.835,37.138,150.715,32.018Z",
    transform: "translate(-130.022 60.043)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161774-3",
    "data-name": "Path 161774",
    d: "M153.32,28.14c-1.038-4.472-13.429-.648-10.459,3.221C138.574,35.417,155.683,38.613,153.32,28.14Z",
    transform: "translate(-83.78 57.134)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161775-3",
    "data-name": "Path 161775",
    d: "M174.467,37.188c-3.864-4.227-8.036-9.618-14.521-10.41-10.705-5.812-22.3,4.831-7.148,6.542-17.737,7.246.86,15.43,9.176,4.667-3.953,13.348,21.574,9.146,12.494-.8C173.791,36.471,175.5,38.327,174.467,37.188Z",
    transform: "translate(-65.035 51.494)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161776-3",
    "data-name": "Path 161776",
    d: "M160.28,29.311c-2.383-12.832-17.375-5.347-11.736,2.9,4.663,6.812,13.231,5.089,11.736-2.9C159.871,27.11,160.71,31.607,160.28,29.311Z",
    transform: "translate(-53.962 37.476)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161777-3",
    "data-name": "Path 161777",
    d: "M158.616,29.836c4.035-2.17-9.182-9.737-12.808-5.17-5.127,5.007,8.991,7.2,12.808,5.17C160.173,29,158.418,29.937,158.616,29.836Z",
    transform: "translate(-69.024 41.801)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161778-3",
    "data-name": "Path 161778",
    d: "M161.64,35.885c-1.413-3.894-18.693-12.574-19.252-5.013-.573,7.227,21.833,12.008,19.252,5.013C160.418,32.539,162.575,38.451,161.64,35.885Z",
    transform: "translate(-82.568 66.41)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161779-3",
    "data-name": "Path 161779",
    d: "M154.353,35.193c-.812-3.522-10.152-8.768-11.79-3.522-3.27,10.416,14.18,13.7,11.79,3.522C154,33.721,154.8,37.106,154.353,35.193Z",
    transform: "translate(-83.87 74.737)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161780-3",
    "data-name": "Path 161780",
    d: "M178.258,39.527C176,35.03,170.243,32,164.1,32.237c14.316-16.1-22.25-3.925-14.166,2.1,3.352,2.491,3.837.66,5.359,3.749,1.2,2.447,3.939,4.2,6.848,5.271,3.14,1.157,19.505,2.912,16.119-3.831C176.544,36.118,179.255,41.509,178.258,39.527Z",
    transform: "translate(-45.423 47.143)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161781-3",
    "data-name": "Path 161781",
    d: "M163.832,23.754c-1.959.8-19.983,10.75-7.476,11.127,11,.346,13.825-13.75,7.476-11.127C161.183,24.842,166.386,22.7,163.832,23.754Z",
    transform: "translate(-26.655 42.87)",
    fill: "#d0d028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161782-3",
    "data-name": "Path 161782",
    d: "M161.334,31.71c-3.284-5.5-12.937-5.189-11.312,1.83,2.1,8.9,16.522,6.875,11.313-1.83C160.351,30.043,162.474,33.6,161.334,31.71Z",
    transform: "translate(-39.088 66.509)",
    fill: "#d0d028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161783-3",
    "data-name": "Path 161783",
    d: "M191.77,33.459c4.3-1.742,11.224-9.655,3.728-12.31-5.824-2.032-11.661,6.4-11.005,10.02-4.028-1.415-8.37-6.435-13.654-5.334-8.295,1.755,3.885,11.895,11.394,9.982-1.741,3.485,1.9,8.372,5.591,10.058-4.042.66-8.507,3.378-6.52,7.749,3.168,6.932,12.821-2.334,9.565-6.749,12.562,2.529,8-10.523.9-13.417C196.528,31.515,196.3,35.321,191.77,33.459Z",
    transform: "translate(67.067 29.164)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161784-3",
    "data-name": "Path 161784",
    d: "M186.8,29.921c-.73-1.076-8.746-3.673-10.4-4.686-4.246-2.61-11.108-3.975-10.227,2.422,1.386,10.1,24.1,7.4,20.625,2.264C185.568,28.123,188.2,32,186.8,29.921Z",
    transform: "translate(55.641 40.904)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161785-3",
    "data-name": "Path 161785",
    d: "M184.159,25.541c-4.048-.025-9.715.094-13.251,1.824-2.594,1.277-9.2,7.724-1.789,8.7a22.071,22.071,0,0,0,13.709-2.893c1.939-1.183,8.158-7.554,1.331-7.63C182.842,25.535,186.023,25.566,184.159,25.541Z",
    transform: "translate(53.403 54.033)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161786-3",
    "data-name": "Path 161786",
    d: "M224.368,38.014c-3.332-1.629-9.7-1.617-11.872-3.818,3.768-2.1,12.637-7.85,7.1-11.882-8.834-6.391-19.184,6.888-20.563,12.316-.785-.572.669-2.258-.055-3.34-1.591-2.327-3.707-5.221-5.687-7.554-7.981-9.4-16.03.918-9.558,7.9-11.326-4.208-15.777,7.907-3.291,5.982-7.94,7.844,8.629,7.875,14.071,5.252-2.833,5.051,4.649,19.455,10.384,11.612,6.076-8.366-6.9-12.184-5.2-16.222,1.789,1.088,3.427.245,4.588-.906.853,4.441,9.21,6.366,13.559,6.718C221.405,44.367,231.946,41.7,224.368,38.014Z",
    transform: "translate(95.455 24.578)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161787-3",
    "data-name": "Path 161787",
    d: "M185.24,25.954c-4.745-5.391-12.705,5.988-11.647,9.548,2.157,7.454,17.771-2.6,11.647-9.548C184.946,25.614,188.858,30.055,185.24,25.954Z",
    transform: "translate(98.775 48.689)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161788-3",
    "data-name": "Path 161788",
    d: "M229.695,21.282c3.578-7.183-10.391-2.258-12.487-.686a10.207,10.207,0,0,0-4.267,5.755c-1.577.22-3.215.377-4.322,1.434-4.4-2.529-5.182-6.083-11.613-6.85-11.19-1.327-1.912,11.165,3.618,12.75-4.424,2.032-20.611,1.227-19.444,9.108,1.3,8.674,18.781,1.472,22.912-1.61-1.393,3.416-4.322,13.039,1.782,14.838,8.3,2.428,12.74-5.944,11.19-11.027,15.033,6.623,14.945-9.957.334-12.071,6.185-2.107,9.906-6.844,12.3-11.643C230.876,18.885,227.954,24.754,229.695,21.282ZM207.978,35.755c.1-3.044.007-2.868,3.441-2.189-1.789.874-1.468,1.692-3.441,2.189C207.985,35.6,208.428,35.636,207.978,35.755Z",
    transform: "translate(143.202 11.426)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161789-3",
    "data-name": "Path 161789",
    d: "M198.65,24.526c-1.331-3.944-16.788-13.467-17.273-5.277-.491,8.655,19.389,11.41,17.273,5.277C198.5,24.029,199.162,25.973,198.65,24.526Z",
    transform: "translate(144.644 3.697)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161790-3",
    "data-name": "Path 161790",
    d: "M197.255,24.619c-4.11-6.944-15.04,4.73-16.31,8.737-2.84,8.919,22.509,1.774,16.31-8.737C197.18,24.494,200.184,29.607,197.255,24.619Z",
    transform: "translate(140.878 37.746)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161791-3",
    "data-name": "Path 161791",
    d: "M198.2,28.019c-1.345-2.365-9.4-8.693-11.36-2.774-1.126,3.309,3.789,5.894,3.994,9.215-.573,5.818,12.029,1.679,7.366-6.441C196.723,25.409,199.679,30.586,198.2,28.019Z",
    transform: "translate(175.533 39.478)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161792-3",
    "data-name": "Path 161792",
    d: "M192.345,24.229c-7.742-1.711-10.7,11-6.158,13.914,7.6,4.881,14.89-11.983,6.158-13.914Z",
    transform: "translate(160.207 46.269)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161793-3",
    "data-name": "Path 161793",
    d: "M202.378,18.925c-.573-.013-7.237-3.805-7.94-4.12-6.609-3.057-6.295,5.655-4.076,8.045,7.769,8.341,19.608-3.629,12.016-3.925C202.275,18.925,204.638,19.006,202.378,18.925Z",
    transform: "translate(188.72 -6.15)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161794-3",
    "data-name": "Path 161794",
    d: "M204.889,16.421c-.02-6.284-16.883,1.528-11.866,10.567,3.079,5.485,11.866-7.737,11.866-10.567Z",
    transform: "translate(207.121 -6.213)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161795-3",
    "data-name": "Path 161795",
    d: "M207.059,18.835c-1.522-5.818-18.242,2.252-17,7.97,1.72,8.1,19.054-.39,17-7.97C206.724,17.514,208.636,24.723,207.059,18.835Z",
    transform: "translate(194.901 7.915)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161796-3",
    "data-name": "Path 161796",
    d: "M207.42,16.479c-5.325,3.082-18.577,2.812-13.941,11.857,1.9,3.73,15.422,7.951,14.8,1.283-.567-5.856-4.615-3.12,1.106-7.4,2.465-1.849,2.724-8.435-1.966-5.737C206.587,16.957,209.591,15.227,207.42,16.479Z",
    transform: "translate(209.58 2.718)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161797-3",
    "data-name": "Path 161797",
    d: "M218.842,22.626c-3.7-5.133-13.49-5.542-17.157-.157-2.9,4.2-9.094,6.573-10.015,13-1.017,7.24,13.2,1.6,14.187-3.686,1.195-6.29,3.181-1.308,7.667-6.114,2.41.7,7.667.245,5.318-3.044C215.08,17.406,220.119,24.438,218.842,22.626Z",
    transform: "translate(204.37 17.333)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161798-3",
    "data-name": "Path 161798",
    d: "M225.993,43.241c-2.84-10.932-23.519-12.656-13.32-.176a3.093,3.093,0,0,0-4.028.793c2.758-6.844-3.045-15.36-8.336-20.581-12.869-12.706-17.464,14.574,1.789,11.53-3.782,3.158-6.971,7.12-7.462,11.593-.771,7.3,11.012,2.258,13.088-.843-9.64,20.116,20,14.473,11.053,1.522,3.523,1.22,8.2,0,7.216-3.837C224.942,39.172,226.648,45.783,225.993,43.241Z",
    transform: "translate(189.901 24.112)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161799-3",
    "data-name": "Path 161799",
    d: "M212.383,13.8c-5.871,1.094-21.792,9.454-8.466,11.605,11.128,1.8,16.419-13.058,8.466-11.605C207.065,14.792,215.442,13.245,212.383,13.8Z",
    transform: "translate(245.866 -8.705)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161800-3",
    "data-name": "Path 161800",
    d: "M212.232,28.99c1-4.177,5.223-6.907-.635-12.511-10.473-10.008-16.972,3.466-5.735,9.353-1.864.226-5.318-.591-6.595-.39-6.513,1.019-3.236,6.988,1.331,7.869-3.222,2.422-6.718,11.63,1.939,9.58,4.083-.975,18.843-14.228,9.695-13.9C212.355,28.4,213.3,28.939,212.232,28.99Z",
    transform: "translate(227.611 -12.888)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161801-3",
    "data-name": "Path 161801",
    d: "M202.2,16.065c-6.3.164-4.369,16.342,3.018,16.467,9.367.132,6.643-16.719-3.018-16.467Z",
    transform: "translate(243.939 3.49)",
    fill: "#d0d028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161802-3",
    "data-name": "Path 161802",
    d: "M200.281,29.225c-1.331-6.127-7.155-2.227-9.749,1.654-6.684,9.882,11.92,8.391,9.749-1.654C200.185,28.847,201.134,33.2,200.281,29.225Z",
    transform: "translate(189.547 56.646)",
    fill: "#d0d028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161803-3",
    "data-name": "Path 161803",
    d: "M197.856,25.32c-3.646,0-3.646,4.523,0,4.523S201.5,25.32,197.856,25.32Z",
    transform: "translate(224.784 52.877)",
    fill: "#d0d028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161804-3",
    "data-name": "Path 161804",
    d: "M211.541,18.292c-5.858,1.761-10.917,2.925-14.815,7.3-3.359,3.812,2.84,6.3,6.581,5.982,10.6-.9,10.623-14,8.233-13.285C210.483,18.607,213.446,17.733,211.541,18.292Z",
    transform: "translate(228.514 14.685)",
    fill: "#d0d028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161805-3",
    "data-name": "Path 161805",
    d: "M214.836,17.711c-.785-4.07-8.015-1.824-9.954.006-3.53,3.365-1.154,6.6.362,10.033,5.55,12.6,10.835-3.592,9.592-10.039C214.6,16.421,215.655,21.912,214.836,17.711Z",
    transform: "translate(270.954 0.536)",
    fill: "#d0d028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161806-3",
    "data-name": "Path 161806",
    d: "M232.329,19.548C231,11.61,219.036,23.221,218.968,27.41c-6.943,1.793-6.349,5.315-10.056,8.058-4.39,3.221-14.678,11.266-10.166,17.015,5.448,6.932,14.46-3.944,13.955-8.479,2.765,1.642.826,13.127,9.66,10.913,12.03-3.044-.655-14.134-5.25-17.021,11.292-1.069,16.624-9.97,15.218-18.348C231.953,17.277,233.093,24.033,232.329,19.548Z",
    transform: "translate(239.377 8.002)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161807-3",
    "data-name": "Path 161807",
    d: "M212.07,22.721c-2.116-6.108-19.034,3.667-16.9,8.938,3.352,8.454,19.061-2.566,16.9-8.938C211.708,21.677,212.336,23.532,212.07,22.721Z",
    transform: "translate(223.998 28.85)",
    fill: "#d0d028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161808-3",
    "data-name": "Path 161808",
    d: "M213.184,24.112c-4.007-7.208-15.88-5.158-8.943,1.673-.71,10.517,14.951,9.127,8.943-1.673C211.962,21.9,214.468,26.389,213.184,24.112Z",
    transform: "translate(265.505 22.578)",
    fill: "#d0d028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161809-3",
    "data-name": "Path 161809",
    d: "M199.826,18.636c-3.2.44-14.8,4.7-11.463,8.674,7.244,8.63,21.116-10.045,11.463-8.674C197.922,18.894,202.551,18.24,199.826,18.636Z",
    transform: "translate(181.925 16.826)",
    fill: "#5aa445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161810-3",
    "data-name": "Path 161810",
    d: "M206.062,25.646c-2.9-7.812-7.9,6.787-7.79,8.429.191,2.176,2.751,3.686,5.38,2.912,5.509-1.585,3.618-8.183,2.41-11.341C205.291,23.52,207.291,28.873,206.062,25.646Z",
    transform: "translate(243.134 42.518)",
    fill: "#5aa445"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87758",
    "data-name": "Group 87758",
    transform: "translate(0.945 229.013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87757",
    "data-name": "Group 87757"
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_87754",
    "data-name": "Group 87754",
    transform: "translate(0.602 3.61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161849",
    "data-name": "Path 161849",
    d: "M574.55,85.848C446.774,102.491,253.213,110.41-92.9,82.036V115.3c3.721.239,98.582.013,102.309,0-.464.138-.949.264-1.42.4-2.383.56-1.761,2.975.553,3.158,9.667.761,19.321,1.579,28.92,2.774-1.4.5-2.813,1.006-4.26,1.453-1.7.535-2.232,2.749,0,3.082,5.578.868,11.217,1.378,16.822,2.069a47.468,47.468,0,0,0-16.112,4.246,1.513,1.513,0,0,0,.485,2.938c11.142,1.384,22.325,2.3,33.555,3.07-1.557.415-3.127.843-4.7,1.2a1.772,1.772,0,0,0-1.441,1.183,91.073,91.073,0,0,0-17.8,2.5c-1.877.484-2.205,2.8,0,3.158,20.44,3.3,42.082,2.981,61.635,8.819-17.634,1.887-35.767.17-52.576,5.661a1.542,1.542,0,0,0,0,2.95,59.582,59.582,0,0,0,12.4,2.642c-1.161.239-2.308.453-3.455.736-2.178.51-2.034,2.686,0,3.258a59.869,59.869,0,0,0,6.056,1.321,45.233,45.233,0,0,0-6.554,2.988c-1.488.83-1.427,2.617.5,3.044a83.872,83.872,0,0,0,16.262,1.793c-1.167.541-2.342,1.082-3.516,1.679-1.782.906-1.045,2.881,1.058,3a98.583,98.583,0,0,1,12.132,1.969c-2.014,1.076-3.939,2.239-5.981,3.353a1.526,1.526,0,0,0-.915,1.692,263.033,263.033,0,0,0-27.452,3.579c-2.465.484-1.9,3.346.573,3.365h6.042c-2.212.4-4.424.811-6.615,1.271-1.625.333-1.9,1.692-1.181,2.579-10.3,1.176-20.372,3.032-29.425,6.793-1.666.692-1.365,2.843.546,3.17,12.35,2.082,24.817,1.113,37.228.069-.86.893-.273,2.334,1.229,2.692,6.779,1.629,13.763,1.679,20.754,1.422a43.434,43.434,0,0,0-7.319,4,1.61,1.61,0,0,0,1,2.875c4.533.541,9.107.786,13.688,1.132a74.684,74.684,0,0,1-8.9,2.944c-2.232.535-1.994,2.717,0,3.309,14.514,4.359,30.169,3.22,45.312,4.743-.471.063-.963.151-1.441.176-2.389.214-3.257,2.906-.608,3.422,25.752,4.975,52.214,1.793,78.423,1.768a62.26,62.26,0,0,1-8,3.434c-2.219.736-.751,2.912,1.085,3.082,40.676,3.636,81.618,2.025,122.164-1.78-.143.126-.321.239-.471.371-.819.667-.178,1.541.881,1.642,10.384,1.05,20.509-.2,30.749-1.05-1.4.522-1.126,2.019.5,2.151,16.119,1.208,30.988-4.7,46.349-7.869a86.95,86.95,0,0,1-13.108,4.648c-1.55.421-1.434,2.529.41,2.359a3.041,3.041,0,0,1,.41-.05h0l.048-.019c11.074-1.126,21.628-4.265,32.709-5.2-.232.138-.423.289-.655.415-.9.547-.444,1.956.7,2.076,8.752.918,17.259-.327,25.527-2.346a1.076,1.076,0,0,0,.976,1.252c13.006,2.063,25.588-.931,38.43-2.132-1.3.629-2.615,1.271-3.994,1.906s-.751,2.189.785,2.252c16,.629,31.828-1.1,47.708-2.233-1.775.862-3.509,1.786-5.271,2.711-1.345.7-.853,2.3.826,2.346,15.313.453,30.176-2.378,45.2-4.214a66.057,66.057,0,0,0-10.022,4.585c-1.331.761-.949,2.409.867,2.453,14.119.421,27.855-1.78,41.536-4.164-.526.252-1.079.459-1.584.711-1.447.761-.99,2.636.908,2.6,17.2-.2,34.115-2.761,51.081-4.743-.41.83.533,1.969,1.8,2.032,10.76.453,21.349-.774,31.965-1.981a4.9,4.9,0,0,0-.471.189c-1.871.742-.785,2.585.956,2.736,17.088,1.51,34.067-.723,51.108-1.547-.519.2-1.051.447-1.618.635a1.413,1.413,0,0,0,.471,2.743c15.832,1.874,31.562.535,47.339-.7-1.127.736-.751,2.277.71,2.56,22.461,4.3,45.626.849,68.469-1.686-.546.245-1.113.491-1.638.774-1.359.717-1.249,2.378.471,2.755,27.527,6.02,56.474,2.183,84.69,1.2-1.953.837-3.857,1.686-5.83,2.51-1.468.6-1.195,2.472.457,2.755,29.507,4.994,59.608-.585,89.367-2.258a8.238,8.238,0,0,0-1.386,2.34c-.362.793.533,1.4,1.482,1.5,13.8,1.3,27.718-.352,41.563-1.554a1.772,1.772,0,0,0,1.7.887c16.911.126,33.733,1.918,50.644,2.573-1.031.34-2.062.667-3.106.981-1.8.528-1.946,2.434,0,2.931,17.273,4.328,35.924,2.673,53.948,2.107-.928.509-1.857,1.013-2.786,1.522-1.434.761-1.338,2.5.492,2.9,10.309,2.233,21.505,1.2,32.088-.73-1.5,1.019-3,2.013-4.52,3.019-.7.409-.86,1.547.294,1.679,58.153,6.466,116.894,7.793,175.422,11.259,31.4,1.856,62.8,4.321,93.778,8.825,1.727.258,312.88,5.107,314.607,5.353V42.276C1392.541,24.192,708.574,68.386,574.55,85.848Z",
    transform: "translate(92.901 -38.011)",
    fill: "#5aa400"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87755",
    "data-name": "Group 87755",
    transform: "translate(0 0)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161850",
    "data-name": "Path 161850",
    d: "M1235.091,134.73c3.591-8.309,10.821-8.309,18.03-11.077-32.449,0-61.294,2.768-93.743,5.548,7.209-5.548,14.419-8.328,25.24-8.328-32.442,0-68.5,5.548-100.953,2.78,7.216-2.78,14.419-8.316,21.635-11.089-14.419,0-28.852,5.542-43.27,2.774-3.6-2.774,0-5.542,7.216-5.542-25.233-2.768-54.084,11.077-72.094,0-4.54-1.736.908-5.667,7.346-10.41l-.014-.12c-34.9,5.523-69.78,13.127-104.68,7.762,25.24-13.863,54.071-19.386,79.311-27.708-61.287,13.844-126.186,11.089-191.084,19.4,0-8.309,7.2-11.077,10.835-16.618C766.4,90.41,737.572,95.939,705.109,98.719c0-5.554,7.223-5.554,10.821-11.077-25.233,0-50.466,8.3-79.311,8.3,0-2.774,3.6-5.529,7.2-5.529-18.03,0-36.04,8.309-54.071,0,36.04-13.857,75.713-24.934,115.358-30.482C611.379,73.785,517.65,82.1,423.906,82.1c9.456-4.85,18.877-11.788,30.722-13.473-84.615,6.3-165.892,32.746-250.637,27.312,18.024-2.774,36.054-11.071,54.078-13.838-50.48,2.768-104.55,11.064-155.017,11.064,7.209-5.523,18.01-8.3,28.838-8.3-25.247-2.768-54.078,8.3-79.317,0C59.782,79.32,70.6,82.1,77.813,73.785c-24.817,1.9-47.92,5.12-71.671,6.038-1.086.61-2.164,1.258-3.222,1.975a1.61,1.61,0,0,0,1,2.875c4.533.541,9.107.786,13.688,1.132a74.684,74.684,0,0,1-8.9,2.944c-2.232.535-1.994,2.717,0,3.309,14.514,4.359,30.169,3.22,45.312,4.743-.471.063-.963.151-1.441.176-2.389.214-3.257,2.906-.608,3.422,25.752,4.975,52.214,1.793,78.423,1.767a62.258,62.258,0,0,1-8,3.434c-2.219.736-.751,2.912,1.086,3.082,40.676,3.636,81.618,2.025,122.164-1.78-.143.126-.321.239-.471.371-.819.667-.178,1.541.881,1.642,10.384,1.05,20.509-.2,30.749-1.05-1.4.522-1.126,2.019.5,2.151,16.119,1.208,30.988-4.7,46.349-7.869a86.949,86.949,0,0,1-13.108,4.648c-1.55.421-1.434,2.529.41,2.359a3.04,3.04,0,0,1,.41-.05h0l.048-.019c11.074-1.126,21.628-4.265,32.709-5.2-.232.138-.423.289-.655.415-.9.547-.444,1.956.7,2.076,8.752.918,17.259-.327,25.527-2.346a1.076,1.076,0,0,0,.976,1.252c13.006,2.063,25.588-.931,38.43-2.132-1.3.629-2.615,1.271-3.994,1.906s-.751,2.189.785,2.252c16,.629,31.828-1.1,47.708-2.233-1.775.862-3.509,1.786-5.271,2.711-1.345.7-.853,2.3.826,2.346,15.313.453,30.176-2.378,45.2-4.214a66.06,66.06,0,0,0-10.022,4.585c-1.331.761-.949,2.409.867,2.453,14.119.421,27.855-1.78,41.536-4.164-.526.252-1.079.459-1.584.711-1.447.761-.99,2.636.908,2.6,17.2-.2,34.115-2.761,51.081-4.743-.41.83.533,1.969,1.8,2.032,10.76.453,21.348-.774,31.965-1.981a4.915,4.915,0,0,0-.471.189c-1.871.742-.785,2.585.956,2.736,17.088,1.51,34.067-.723,51.108-1.547-.519.2-1.051.447-1.618.635a1.413,1.413,0,0,0,.471,2.743c15.832,1.874,31.562.535,47.339-.7-1.126.736-.751,2.277.71,2.56,22.461,4.3,45.626.849,68.469-1.686-.546.245-1.113.491-1.639.774-1.359.717-1.249,2.378.471,2.755,27.527,6.02,56.474,2.183,84.69,1.2-1.953.837-3.857,1.686-5.83,2.51-1.468.6-1.195,2.472.457,2.755,29.507,4.994,59.607-.585,89.367-2.258a8.235,8.235,0,0,0-1.386,2.34c-.362.793.533,1.4,1.481,1.5,13.8,1.3,27.718-.352,41.564-1.554a1.772,1.772,0,0,0,1.7.887c16.911.126,33.733,1.918,50.644,2.573-1.031.34-2.062.667-3.106.981-1.8.528-1.946,2.434,0,2.931,17.273,4.328,35.924,2.673,53.948,2.107-.929.51-1.857,1.013-2.786,1.522-1.434.761-1.338,2.5.492,2.9,10.309,2.233,21.505,1.2,32.088-.73-1.5,1.019-3,2.013-4.519,3.019-.7.409-.86,1.547.293,1.679,58.154,6.466,116.894,7.793,175.423,11.259,31.4,1.856,62.8,4.321,93.777,8.825,1.727.258,312.849,5.149,314.576,5.394v-15.24C1648.927,148.252,1288.684,133.012,1235.091,134.73Z",
    transform: "translate(166.031 104.168)",
    fill: "url(#linear-gradient-12)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161851",
    "data-name": "Path 161851",
    d: "M319.453,36.3c76.027,2.12,154.129-3.114,225.691,20.915-27.95,2.768-55.894,2.768-80.342,13.857,38.43-5.548,73.364-11.089,111.78-2.78-11.278,8.945-24.018,10.964-37.3,12.008,15.8-.906,30.961-.918,47.79-.918-132.76,49.861-289.968,27.7-433.208,55.4,80.355-2.774,157.215-8.315,237.577-11.083-83.864,24.934-174.706,11.083-258.543,33.237,125.762-8.3,251.532-22.154,377.308-19.386-20.959,16.625-52.405,13.851-73.371,27.7,41.946-5.542,80.355-13.851,122.294-5.542-17.484,11.071-41.939,13.844-62.885,22.166,31.439-5.548,62.885-5.548,94.3-5.548-10.452,8.322-27.943,11.077-41.918,19.392,24.475,2.768,45.414-8.315,69.876-5.542-10.459,2.774-17.45,8.309-24.462,13.857h17.5c0,8.309-10.486,11.077-17.5,13.844,7.012,0,17.5-5.535,20.98-2.768,0,5.548-10.493,8.315-13.968,11.089,8.855,0,329.08.315,338.393,0V39.429C834.081,34.246,418.651,32.825,319.453,36.3Z",
    transform: "translate(927.143 -34.397)",
    opacity: 0.8,
    fill: "url(#linear-gradient-13)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161852",
    "data-name": "Path 161852",
    d: "M811.666,37.426C703.681,47.949,617.612,59.5,566.954,66.316,443.138,82.96,206.825,88.2-128.571,59.825V93.087c3.6.239,144.263,2.692,147.888,2.68-.471.138-.915.264-1.393.4-2.294.56-1.7,2.975.533,3.158,9.387.761,18.734,1.579,28.032,2.774-1.359.5-2.717,1.006-4.117,1.453-1.645.535-2.164,2.749,0,3.082,5.407.868,10.869,1.378,16.3,2.069a44.859,44.859,0,0,0-15.62,4.246,1.522,1.522,0,0,0,.485,2.937c10.787,1.384,21.621,2.3,32.5,3.07-1.509.415-3.011.843-4.547,1.2a1.737,1.737,0,0,0-1.393,1.183,85.681,85.681,0,0,0-17.252,2.5c-1.816.484-2.123,2.8,0,3.158,19.805,3.3,40.778,2.981,59.73,8.819-17.1,1.887-34.661.17-50.964,5.661a1.56,1.56,0,0,0,0,2.95,56.467,56.467,0,0,0,12.036,2.642c-1.12.239-2.232.453-3.352.736-2.1.51-1.973,2.686,0,3.258a56.714,56.714,0,0,0,5.878,1.321,42.829,42.829,0,0,0-6.363,2.988c-1.441.83-1.379,2.617.492,3.044a78.868,78.868,0,0,0,15.75,1.793c-1.12.541-2.267,1.082-3.386,1.679-1.748.906-1.024,2.881,1.017,3a92.276,92.276,0,0,1,11.743,1.969c-1.946,1.076-3.823,2.239-5.789,3.353a1.545,1.545,0,0,0-.888,1.692,247.979,247.979,0,0,0-26.605,3.579c-2.389.484-1.843,3.346.56,3.365h5.851c-2.151.4-4.287.811-6.411,1.271A1.578,1.578,0,0,0,61,182.689c-9.981,1.176-19.737,3.032-28.5,6.793a1.64,1.64,0,0,0,.512,3.17c1.6.264,3.2.484,4.806.667,22.523-14.09,63.438-10.769,90.111-17.122H99.98c17.477-5.542,38.423-5.542,55.9-11.071-13.982,0-27.95,0-38.423-5.548,13.955-2.774,24.441-2.774,38.423-5.548-10.493,0-24.468,0-34.934-5.523,52.4-19.4,111.787-16.631,167.695-24.953-62.891-2.768-122.274-8.3-185.165-2.768,13.982-2.761,24.455-2.761,38.423-8.3-17.471-5.542-38.423-2.768-55.9-2.768,10.48-8.315,24.455-5.542,34.948-8.315C106.957,90.313,86,109.718,72.036,93.087c10.48-2.774,24.441-5.535,34.921-5.535C93,79.243,72.036,93.087,61.55,79.243c58.461,0,114.2,12.863,172,8.385,45.148,5.315,90.3-5.56,135.443,5.46-13.975,11.089-31.446,11.089-48.9,13.857,27.93,5.542,52.391-5.542,80.348-2.768,0,2.768-3.509,5.542-6.977,5.542h6.977c-20.966,13.838-48.916,11.071-69.869,19.392h34.928q-73.364,24.928-157.215,33.243c94.337-5.548,188.647-13.844,275.993-44.326H431.88c29.479-18.694,68.879-27.507,107.759-29.815a48.179,48.179,0,0,1-16.924-3.434c55.9-8.3,115.283-22.154,174.679-16.625-24.448,13.87-52.4,19.4-80.355,27.708,62.885-5.548,122.274-13.838,181.676-27.708-13.968-8.3-31.453-5.529-45.428-11.071A354.564,354.564,0,0,1,811.666,37.426Z",
    transform: "translate(128.571 -14.869)",
    opacity: 0.5,
    fill: "url(#linear-gradient-14)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87756",
    "data-name": "Group 87756",
    transform: "translate(212.95 12.225)",
    opacity: 0.7,
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161853",
    "data-name": "Path 161853",
    d: "M81.785,64.418c7.5-1.862,17.027-1.076,24.817-.591,1.9.126,8.814,3.535,3.468,3.975-3.564,2.51-13.354,1.73-17.791,2.145-3.12.283-9.121,1.56-12.036.157s-1.229-5.013,1.543-5.686C86.96,63.135,77.921,65.368,81.785,64.418Z",
    transform: "translate(398.49 109.468)",
    fill: "#d3dd25"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161854",
    "data-name": "Path 161854",
    d: "M86.181,66.467c4.083-3.007,12.63-2.8,17.8-3.057,1.563-.069,14.173-.541,9.094,3.736C110.274,69.5,99.33,69.26,95.3,69.99c-1.973.377-14.59.522-9.114-3.522C88.967,64.417,84.659,67.587,86.181,66.467Z",
    transform: "translate(433.984 110.104)",
    fill: "#d3dd25"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161855",
    "data-name": "Path 161855",
    d: "M82.333,68.8a52.381,52.381,0,0,1,10.855-1.975c5.66-.465,2.526-1.874,7.735-3.642,7.926-2.7,16.918-2.988,25.376-2.176,3.707.371,16.4,2.994,5.339,3.34-8.78.283-17.163.7-25.731,2.3,4.042.126,15.4-.73,18.508,1.466,6.609,4.711-10.8,4.378-12.507,4.4-7.189.082-14.269.5-21.451.918-2.212.12-6.575.925-8.548-.264-1.789-1.063-1.877-3.655.423-4.365C86.88,67.4,79.377,69.7,82.333,68.8Z",
    transform: "translate(409.336 95.527)",
    fill: "#d3dd25"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161856",
    "data-name": "Path 161856",
    d: "M78.872,62.856c2.062-.7,25.438-4.913,19.416.95-2.56,2.466-11.333,2.837-15.033,3.044-2.021.107-9.974-2.107-4.383-3.994C84.088,61.095,76.428,63.674,78.872,62.856Z",
    transform: "translate(387.946 96.217)",
    fill: "#d3dd25"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161857",
    "data-name": "Path 161857",
    d: "M82.008,60.161c2.075-.314,2.7,2.227.635,2.547C80.554,63.029,79.946,60.475,82.008,60.161Z",
    transform: "translate(410.207 93.031)",
    fill: "#d3dd25"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161858",
    "data-name": "Path 161858",
    d: "M60.069,67.465c5.161-3.611,12.357-4.46,18.986-4.51,3.216-.031,20.154-.6,21.71,1.818C102.438,67.4,81.445,66.918,78.8,67.15c-4.69.4-9.278,1.334-13.941,1.956.662-.1-8.411.868-4.793-1.642C69.893,60.615,58.908,68.283,60.069,67.465Z",
    transform: "translate(284.803 107.528)",
    fill: "#d3dd25"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161859",
    "data-name": "Path 161859",
    d: "M57.46,69.557c6.807-3.214,14.863-4.139,22.6-4.762,3.373-.283,6.738-.5,10.1-.843.191-.025,9.278.711,4.342,2.2-7.114,2.132-14.692,2.591-22.058,3.9-4.574.805-9.06,1.824-13.511,2.963a1.879,1.879,0,0,1-1.468-3.46C68,64.575,55.371,70.532,57.46,69.557Z",
    transform: "translate(268.071 113.23)",
    fill: "#d3dd25"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161860",
    "data-name": "Path 161860",
    d: "M46.359,66.479C53.213,64.485,60.88,64.806,68.021,64c3.352-.377,6.7-.855,10.029-1.352,3.386-.535-4.062,3.384-4.5,3.529A73.281,73.281,0,0,1,55.923,69.5c-2.908.239-5.844.346-8.759.327-2.137,0-2.888-2.755-.806-3.353C51.151,65.082,44.283,67.076,46.359,66.479Z",
    transform: "translate(202.715 106.067)",
    fill: "#d3dd25"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161861",
    "data-name": "Path 161861",
    d: "M60.1,63.985c3.379-1.484,31.616-4.032,28.141,0-1.809,2.082-15.853,2.787-19.184,3.277-2.294.34-6.936,1.635-9.176.453-1.775-.931-1.632-2.919.218-3.73C64.226,62.18,57.276,65.237,60.1,63.985Z",
    transform: "translate(281.404 101.931)",
    fill: "#d3dd25"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161862",
    "data-name": "Path 161862",
    d: "M118.471,68.451c5.4-3.051,12.029-3.938,18.515-3.768,1.557.031,15.47.491,13.818,2.68-.949,1.252-13.907.1-16.167.264a53.776,53.776,0,0,0-10.7,2.183c.28-.063-10.179,1.321-5.468-1.359C127.647,63.261,116.662,69.476,118.471,68.451Z",
    transform: "translate(622.988 116.99)",
    fill: "#d3dd25"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161863",
    "data-name": "Path 161863",
    d: "M89.007,64.8c5.414-2.032,11.668-2.352,17.58-2.29,1.809.025,17.43.2,15.873,2.29-1.454,1.906-17.5,1.585-20.727,2.044a84.059,84.059,0,0,1-8.964,1.069c-1.14.044-8.4-1.359-3.762-3.114C98.265,61.331,87.144,65.495,89.007,64.8Z",
    transform: "translate(449.489 105.548)",
    fill: "#d3dd25"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161864",
    "data-name": "Path 161864",
    d: "M79.409,62.065a118.31,118.31,0,0,1,16.3-2.755c1.877-.189,6.39-1.233,8.131-.17,1.324.824.669,2.308-.778,2.68A125.5,125.5,0,0,1,86.83,64.9c-1.966.245-6.493,1.359-8.322.245-1.5-.944-.792-2.673.9-3.082C86.776,60.259,76.665,62.725,79.409,62.065Z",
    transform: "translate(392.447 85.284)",
    fill: "#d3dd25"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161865",
    "data-name": "Path 161865",
    d: "M80.815,60.1c7.223-2.025,15.067-2.478,22.686-2.252,2.1.063,19.942.541,17.532,3.692-1.748,2.29-20.632,1.352-24.291,1.554-5.032.27-10.043.516-15.074.572-2.273.013-3.065-2.95-.853-3.567C92.639,56.818,78.61,60.718,80.815,60.1Z",
    transform: "translate(403.037 80.667)",
    fill: "#d3dd25"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161866",
    "data-name": "Path 161866",
    d: "M104.946,67.536a119.267,119.267,0,0,1,16.289-2.755c1.9-.189,6.418-1.227,8.145-.17,1.338.818.662,2.3-.785,2.686a126.379,126.379,0,0,1-16.2,3.076c-1.987.226-6.506,1.365-8.343.226-1.509-.925-.792-2.654.894-3.063C112.333,65.718,102.222,68.2,104.946,67.536Z",
    transform: "translate(541.275 114.244)",
    fill: "#d3dd25"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161867",
    "data-name": "Path 161867",
    d: "M106.35,65.563c7.223-2.013,15.088-2.466,22.7-2.239,2.123.069,19.949.541,17.532,3.686-1.748,2.29-20.638,1.365-24.291,1.56-5.018.264-10.049.51-15.074.56-2.28.038-3.072-2.944-.867-3.567C118.181,62.273,104.158,66.186,106.35,65.563Z",
    transform: "translate(551.867 109.625)",
    fill: "#d3dd25"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161868",
    "data-name": "Path 161868",
    d: "M44.886,67.358c2.608-1.654,18.536-5.271,18-.415-.335,3.095-9.278,3.371-12.1,3.749-1.673.226-10.179-.591-5.892-3.334C46.8,66.157,43.521,68.233,44.886,67.358Z",
    transform: "translate(194.357 116.152)",
    fill: "#d3dd25"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161869",
    "data-name": "Path 161869",
    d: "M95.08,63.7c2.963.491,6.022.157,8.971.793,2.738.61.99,3.56-1.406,3.145-2.806-.484-5.7.113-8.479-.5-2.4-.51-1.611-3.862.915-3.434C98.043,64.189,92.6,63.283,95.08,63.7Z",
    transform: "translate(480.064 111.295)",
    fill: "#d3dd25"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161870",
    "data-name": "Path 161870",
    d: "M124.126,68.117c7.646-7.227,26.517-5.365,35.324-.591,1.768.969.9,3.78-1.536,3.39-3.885-.635-7.783-1.289-11.743-1.554-1.946-.12-26.626,3.1-22.045-1.245C131.274,61.355,122.9,69.3,124.126,68.117Z",
    transform: "translate(659.757 109.826)",
    fill: "#d3dd25"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161871",
    "data-name": "Path 161871",
    d: "M123.919,65.143c3.482-1.233,32.32-4.447,29.043-.6-1.836,2.151-14.535,2.277-17.805,2.843a51.227,51.227,0,0,1-10.411,1.076c-2.185-.082-2.806-2.617-.826-3.315C131.968,62.281,121.939,65.842,123.919,65.143Z",
    transform: "translate(654.885 106.661)",
    fill: "#d3dd25"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161872",
    "data-name": "Path 161872",
    d: "M125.737,62.262a32.074,32.074,0,0,1,11.852-.5,43.6,43.6,0,0,1,5.8,1.088,1.415,1.415,0,1,1-.737,2.73,62.848,62.848,0,0,0-13.32-.2c-1.8.088-9.026-1.736-3.591-3.114C131.376,60.834,123.716,62.772,125.737,62.262Z",
    transform: "translate(660.85 99.943)",
    fill: "#d3dd25"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161873",
    "data-name": "Path 161873",
    d: "M129.405,66.22c5.025-1.189,10.384-1.044,15.545-.541,2.048.22,4.151.459,6.206.717,1.645.2,1.577,2.29-.232,2.151-5.769-.428-11.524.3-17.279.742-1.755.145-10.015-1.711-4.24-3.07C136.505,64.515,126.729,66.855,129.405,66.22Z",
    transform: "translate(682.039 120.391)",
    fill: "#d3dd25"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161874",
    "data-name": "Path 161874",
    d: "M73.259,64.817A39.324,39.324,0,0,1,88.5,62.709c1.891.075,16.235.717,13.1,4.133-1.6,1.736-14.33-.031-17.211.176a72.13,72.13,0,0,1-10.486.415c-1.686-.12-2.205-2.019-.642-2.617C81.329,61.728,71.7,65.414,73.259,64.817Z",
    transform: "translate(361.192 106.484)",
    fill: "#d3dd25"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161875",
    "data-name": "Path 161875",
    d: "M183.549,71.421c7.51-1.843,17.034-1.063,24.81-.572,1.925.107,8.821,3.529,3.482,3.963-3.557,2.5-13.361,1.73-17.791,2.145-3.12.277-9.141,1.56-12.043.164s-1.243-5.007,1.543-5.7Z",
    transform: "translate(991.46 146.59)",
    fill: "#d3dd25"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161876",
    "data-name": "Path 161876",
    d: "M187.935,73.489c4.1-3.013,12.63-2.812,17.812-3.051,1.564-.094,14.18-.541,9.094,3.724-2.8,2.346-13.75,2.107-17.8,2.843-1.966.371-14.562.51-9.107-3.516C190.714,71.432,186.419,74.608,187.935,73.489Z",
    transform: "translate(1026.958 147.227)",
    fill: "#d3dd25"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161877",
    "data-name": "Path 161877",
    d: "M184.1,75.805a53.565,53.565,0,0,1,10.855-1.969c5.653-.472,2.512-1.862,7.721-3.636,7.92-2.7,16.911-2.994,25.383-2.176,3.714.352,16.406,3,5.318,3.334a168.317,168.317,0,0,0-25.7,2.283c4.021.145,15.4-.723,18.495,1.478,6.622,4.711-10.793,4.378-12.507,4.4-7.209.1-14.275.5-21.458.918-2.178.132-6.568.912-8.527-.258-1.8-1.076-1.891-3.655.423-4.372C188.628,74.428,181.131,76.723,184.1,75.805Z",
    transform: "translate(1002.309 132.651)",
    fill: "#d3dd25"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161878",
    "data-name": "Path 161878",
    d: "M180.643,69.865c2.069-.692,25.431-4.9,19.4.95-2.56,2.478-11.34,2.837-15.033,3.038-2.007.12-9.981-2.088-4.369-3.988C185.852,68.1,178.206,70.683,180.643,69.865Z",
    transform: "translate(980.923 133.345)",
    fill: "#d3dd25"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161879",
    "data-name": "Path 161879",
    d: "M183.791,67.177c2.055-.321,2.676,2.233.6,2.554S181.7,67.492,183.791,67.177Z",
    transform: "translate(1003.172 130.146)",
    fill: "#d3dd25"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161880",
    "data-name": "Path 161880",
    d: "M190.768,71.807c5.414-2.032,11.681-2.346,17.573-2.283,1.83.025,17.437.208,15.873,2.271-1.447,1.925-17.484,1.6-20.727,2.076a87.991,87.991,0,0,1-8.95,1.05c-1.154.05-8.4-1.365-3.768-3.114C200.019,68.335,188.9,72.518,190.768,71.807Z",
    transform: "translate(1042.456 142.669)",
    fill: "#d3dd25"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161881",
    "data-name": "Path 161881",
    d: "M181.159,69.077a120.625,120.625,0,0,1,16.3-2.761c1.9-.176,6.4-1.22,8.145-.157,1.338.824.676,2.308-.785,2.692a127.181,127.181,0,0,1-16.228,3.057c-1.959.233-6.493,1.371-8.329.233-1.5-.918-.792-2.661.894-3.063C188.546,67.271,178.435,69.743,181.159,69.077Z",
    transform: "translate(985.411 122.409)",
    fill: "#d3dd25"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161882",
    "data-name": "Path 161882",
    d: "M182.579,67.115c7.23-2.019,15.067-2.472,22.666-2.252,2.11.069,19.956.541,17.559,3.7-1.768,2.29-20.638,1.346-24.3,1.547-5.032.27-10.043.516-15.088.566-2.26.044-3.059-2.956-.84-3.566C194.417,63.813,180.36,67.726,182.579,67.115Z",
    transform: "translate(996.007 117.785)",
    fill: "#d3dd25"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161883",
    "data-name": "Path 161883",
    d: "M194.511,68.494a117.3,117.3,0,0,1,16.31-2.742c1.884-.195,6.411-1.239,8.131-.176,1.338.818.676,2.315-.771,2.692a130.614,130.614,0,0,1-16.242,3.076c-1.959.226-6.492,1.359-8.322.226-1.495-.918-.792-2.654.894-3.076C201.9,66.683,191.787,69.18,194.511,68.494Z",
    transform: "translate(1063.215 119.331)",
    fill: "#d3dd25"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161884",
    "data-name": "Path 161884",
    d: "M196.828,70.717c2.984.491,6.035.157,8.984.8,2.738.6.976,3.554-1.393,3.132-2.833-.466-5.707.126-8.5-.478-2.39-.535-1.6-3.881.908-3.453C199.811,71.208,194.35,70.3,196.828,70.717Z",
    transform: "translate(1073.037 148.413)",
    fill: "#d3dd25"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161885",
    "data-name": "Path 161885",
    d: "M175.019,71.835a39.272,39.272,0,0,1,15.225-2.107c1.891.069,16.255.7,13.1,4.12-1.6,1.723-14.323-.019-17.191.182a70.4,70.4,0,0,1-10.486.4c-1.7-.107-2.205-2.019-.649-2.6C183.075,68.727,173.448,72.432,175.019,71.835Z",
    transform: "translate(954.166 143.61)",
    fill: "#d3dd25"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161886",
    "data-name": "Path 161886",
    d: "M135.316,59.141c6.595-.906,13.34-.673,20.01-.39,1.8.088,6.622-.447,7.967.818a1.591,1.591,0,0,1-1.147,2.768A154.963,154.963,0,0,1,142.129,63c-1.891-.05-6.581.421-8.022-.918-1.1-1.006-.546-2.7,1.208-2.944C143.877,57.964,132.783,59.505,135.316,59.141Z",
    transform: "translate(717.917 84.377)",
    fill: "#d3dd25"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161887",
    "data-name": "Path 161887",
    d: "M137.639,61.817c2.424-.811,24.359-3.516,24.482-1.623.068,1.057-11.121,1.837-12.61,2.044-2.847.44-5.639,1.151-8.52,1.472.382-.057-7.4-.491-3.352-1.893C141.141,60.622,136.431,62.232,137.639,61.817Z",
    transform: "translate(734.976 89.865)",
    fill: "#d3dd25"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161888",
    "data-name": "Path 161888",
    d: "M132.487,62.521c4.663-2.56,10.343-3.548,15.866-4.12,1.372-.157,14.972-2.428,12.1,1.459-1.632,2.189-12.548,2.755-15.573,3.321-3.571.667-7.141,1.371-10.664,2.151C132.31,65.76,130.794,63.446,132.487,62.521Z",
    transform: "translate(707.501 79.625)",
    fill: "#d3dd25"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161889",
    "data-name": "Path 161889",
    d: "M170.753,67.2c6.616-.906,13.381-.679,20.038-.377,1.789.063,6.609-.472,7.967.8a1.6,1.6,0,0,1-1.127,2.774,155.6,155.6,0,0,1-20.038.66c-1.9-.057-6.574.415-8.022-.918-1.1-1-.567-2.7,1.181-2.937C179.341,66.028,168.24,67.55,170.753,67.2Z",
    transform: "translate(924.536 126.999)",
    fill: "#d3dd25"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161890",
    "data-name": "Path 161890",
    d: "M173.095,69.881c2.43-.824,24.359-3.522,24.5-1.629.055,1.057-11.135,1.824-12.623,2.051-2.84.421-5.626,1.151-8.52,1.453.389-.05-7.408-.491-3.359-1.874C176.611,68.692,171.893,70.3,173.095,69.881Z",
    transform: "translate(941.589 132.486)",
    fill: "#d3dd25"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161891",
    "data-name": "Path 161891",
    d: "M167.945,70.585c4.663-2.579,10.329-3.56,15.866-4.151,1.372-.132,14.972-2.4,12.1,1.478-1.632,2.189-12.548,2.755-15.573,3.315-3.584.679-7.134,1.39-10.664,2.17C167.76,73.824,166.258,71.5,167.945,70.585Z",
    transform: "translate(914.126 122.247)",
    fill: "#d3dd25"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161892",
    "data-name": "Path 161892",
    d: "M129.382,61.89a34.778,34.778,0,0,1,15.006-3.032,56.749,56.749,0,0,1,9.319.786c2.123.346,2.116,2.893-.3,2.843a70.3,70.3,0,0,0-15.675,1.4c-2.076.409-5.974,2.164-8.138,1.447-1.959-.654-1.884-2.6-.212-3.441C136.475,58.418,126.685,63.217,129.382,61.89Z",
    transform: "translate(686.357 86.282)",
    fill: "#d3dd25"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161893",
    "data-name": "Path 161893",
    d: "M50.438,67.856C47.544,66.133,23.423,60.6,24.4,66.441c.389,2.29,12.412,1.711,15.061,2.088.737.126,16.16,2.409,10.978-.673C43.741,63.868,51.9,68.712,50.438,67.856Z",
    transform: "translate(81.769 112.571)",
    fill: "#d3dd25"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161894",
    "data-name": "Path 161894",
    d: "M46.626,63.356a64.807,64.807,0,0,0-13.572-.2c-2.287.164-4.561.321-6.854.484,1.529-.1-8.029,1.673-3.325,1.874,5.7.245,11.374.95,17.088.925a46.954,46.954,0,0,0,6.663-.447,1.321,1.321,0,0,0,0-2.636C39.1,62.237,48.271,63.6,46.626,63.356Z",
    transform: "translate(65.394 107.662)",
    fill: "#d3dd25"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161895",
    "data-name": "Path 161895",
    d: "M46.414,63.2c-2.574-.956-23.158-1.2-20.72,2.013.915,1.183,11.115.321,13.053.547a37.767,37.767,0,0,0,6.629.459c1.789-.107,3.079-2.258,1.038-3.019C40.666,61.049,48.421,63.942,46.414,63.2Z",
    transform: "translate(88.313 104.962)",
    fill: "#d3dd25"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161896",
    "data-name": "Path 161896",
    d: "M57.541,64.834c-4.772-1.006-9.872-.6-14.726-.138-1.707.157-5.885-.088-7.2,1.094-1.126,1.032-.157,2.478,1.447,2.617,4.916.4,9.817,1.1,14.794.994,1.925-.044,12.589-3.095,5.687-4.567C51.232,63.5,60.033,65.363,57.541,64.834Z",
    transform: "translate(144.433 114.6)",
    fill: "#d3dd25"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161897",
    "data-name": "Path 161897",
    d: "M66.772,64.24c-6.349-1.315-12.978-1-19.471-1.013a78.978,78.978,0,0,1-9.763-.528c-1.727-.22-2.7,1.83-.771,2.246A105.412,105.412,0,0,0,56.415,67.2c3.284.094,6.568.088,9.851-.038,2.028-.063,2.622-2.491.505-2.919C57.384,62.3,68.881,64.668,66.772,64.24Z",
    transform: "translate(147.832 106.514)",
    fill: "#d3dd25"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161898",
    "data-name": "Path 161898",
    d: "M58.44,63.774c-4.492-.711-9.107.252-13.525.78-.56.069-8.793,2.812-3.291,2.988a92.9,92.9,0,0,0,13.559-.277c.635-.075,8.493-2.642,3.257-3.491C53.115,62.918,60.365,64.088,58.44,63.774Z",
    transform: "translate(171.32 110.597)",
    fill: "#d3dd25"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161899",
    "data-name": "Path 161899",
    d: "M57.434,62.355a68.26,68.26,0,0,0-17.191,1.214c-1.816.352-6.889.755-7.824,2.384-.683,1.183.546,2.6,2.246,2.214A114.129,114.129,0,0,1,50.86,65.915c1.871-.145,6.554.22,7.947-1.063,1.079-.981.191-2.384-1.372-2.5C49.406,61.814,59.906,62.531,57.434,62.355Z",
    transform: "translate(127.553 103.694)",
    fill: "#d3dd25"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161900",
    "data-name": "Path 161900",
    d: "M52.064,62.011c-4.424-.855-9.025-.031-13.456.189-2.6.138-2.6,3.164,0,3.283,4.431.233,9.032,1.069,13.456.208a1.846,1.846,0,0,0,0-3.68C47.845,61.187,54.351,62.464,52.064,62.011Z",
    transform: "translate(153.364 100.949)",
    fill: "#d3dd25"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161901",
    "data-name": "Path 161901",
    d: "M29.027,55.025c-3.414.484-6.807.975-10.248,1.283-.341.031-8.6,2.522-3.42,2.68a40.426,40.426,0,0,0,11.79-1.359c.212-.063,5.892-3.189,1.877-2.6C24.515,55.667,30.243,54.843,29.027,55.025Z",
    transform: "translate(19.35 65.621)",
    fill: "#d3dd25"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161902",
    "data-name": "Path 161902",
    d: "M21.743,62.6c-1.768-.585-13.511.094-11.811,1.635.928.824,5.291-.082,6.575-.126.321-.019,8.111-.56,5.236-1.51C20.132,62.061,22.46,62.834,21.743,62.6Z",
    transform: "translate(-3.344 104.95)",
    fill: "#d3dd25"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161903",
    "data-name": "Path 161903",
    d: "M23.544,62.032c-1.365-.478-13.306-2.812-12.473-.648.505,1.283,5.912,1.761,7.3,1.994a40.387,40.387,0,0,0,4.533.5c1.188.069,1.823-1.466.642-1.849C19.973,60.818,24.7,62.416,23.544,62.032Z",
    transform: "translate(4.025 94.858)",
    fill: "#d3dd25"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161904",
    "data-name": "Path 161904",
    d: "M19.5,61.807a17.089,17.089,0,0,0-5.905.2c-1.3.239-3.6,2.283-1.386,1.824a35.36,35.36,0,0,1,5.475-.352c.294,0,4.52-1.2,1.816-1.667C17.031,61.392,20.431,61.97,19.5,61.807Z",
    transform: "translate(5.506 100.958)",
    fill: "#d3dd25"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161905",
    "data-name": "Path 161905",
    d: "M45.342,58.155c-3.045.5-6.117.824-9.217,1.044-.492.038-7.906,2.227-3.086,2.491,4.383.245,9.1.761,13.306-.616,2.171-.7,1.42-3.3-1-2.919C41.246,58.822,47.807,57.765,45.342,58.155Z",
    transform: "translate(122.837 82.092)",
    fill: "#d3dd25"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161906",
    "data-name": "Path 161906",
    d: "M57.713,61.328c-3.571-1.063-7.769-.371-11.231.591a34.688,34.688,0,0,0-5.052,1.849c-1.154.522-.423,2.214.976,1.8A32.4,32.4,0,0,1,52.7,64.592c1.447.063,10.288-1.692,5.018-3.265C52.846,59.881,59.5,61.856,57.713,61.328Z",
    transform: "translate(177.85 96.487)",
    fill: "#d3dd25"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161907",
    "data-name": "Path 161907",
    d: "M30.1,56.477c-4.383-.044-8.746.264-13.088.61-1.816.145-9.094,3.17-3.236,3.655a53.861,53.861,0,0,0,13.613-.252c1.468-.252,8.165-3.963,2.71-4.013C24.695,56.426,32.56,56.489,30.1,56.477Z",
    transform: "translate(6.956 73.58)",
    fill: "#d3dd25"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161908",
    "data-name": "Path 161908",
    d: "M22.11,53.331c-1.864.195-16.276,1.082-12.726,4.3,1.994,1.8,8.882-.069,11.087-.736,1.12-.34,6.7-4.114,1.639-3.56C18.389,53.733,23.9,53.129,22.11,53.331Z",
    transform: "translate(-8.824 56.749)",
    fill: "#d3dd25"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161909",
    "data-name": "Path 161909",
    d: "M188.343,61.519c-4.431-1.742-9.736-1.308-14.351-.434-1.236.233-13.722,2.661-8.78,5.17,2.294,1.176,10.282-1.289,13.074-1.466.512-.025,16.569-.717,10.056-3.271C181.693,58.9,189.933,62.135,188.343,61.519Z",
    transform: "translate(895.756 94.019)",
    fill: "#d3dd25",
    opacity: 0.6
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161910",
    "data-name": "Path 161910",
    d: "M186.246,61.078c-2.594-.233-22.209,1.692-17.757,5.114,1.9,1.453,10.992.113,13.443-.17,2.26-.264,11.313-4.34,4.315-4.944C183.665,60.846,188.458,61.28,186.246,61.078Z",
    transform: "translate(917.747 97.655)",
    fill: "#d3dd25",
    opacity: 0.6
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161911",
    "data-name": "Path 161911",
    d: "M167.7,62.163c-1.973,0-1.973,2.434,0,2.434S169.672,62.163,167.7,62.163Z",
    transform: "translate(908.337 103.766)",
    fill: "#d3dd25",
    opacity: 0.6
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161912",
    "data-name": "Path 161912",
    d: "M179.949,63.81c-2.444-1.868-17.122-2.963-18,.629-.84,3.434,21.1,1.749,18-.629C176.133,60.922,180.912,64.558,179.949,63.81Z",
    transform: "translate(883.34 103.29)",
    fill: "#d3dd25",
    opacity: 0.6
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161913",
    "data-name": "Path 161913",
    d: "M169.339,62.018c-3.093.3-6.2.4-9.312.554-2.779.151-2.779,3.371,0,3.5a24.992,24.992,0,0,0,7.756-.623c1.133-.308,5.721-3.818,1.557-3.434C166.246,62.313,171.114,61.861,169.339,62.018Z",
    transform: "translate(860.109 102.817)",
    fill: "#d3dd25",
    opacity: 0.6
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161914",
    "data-name": "Path 161914",
    d: "M174.82,61.126c-3.086.189-6.185.459-9.285.352-.055,0-9.094.906-3.953,2.2,3.625.918,7.646,1.566,11.408.8C174.253,64.215,178.971,60.875,174.82,61.126Z",
    transform: "translate(872.105 98.211)",
    fill: "#d3dd25",
    opacity: 0.6
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161915",
    "data-name": "Path 161915",
    d: "M179.844,59.086c-1.577-.4-12.828-.736-9.053,2.692,3.359,3.063,14.016-1.447,9.053-2.692C177.482,58.507,181.79,59.583,179.844,59.086Z",
    transform: "translate(930.492 86.193)",
    fill: "#d3dd25",
    opacity: 0.6
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161916",
    "data-name": "Path 161916",
    d: "M186.6,62.04c-1.522-.2-18.092.491-12.978,3.3,1.707.931,8.015-.459,10.07-.6.41-.031,7.353-2.132,2.908-2.692C182.465,61.505,188.118,62.229,186.6,62.04Z",
    transform: "translate(945.758 102.052)",
    fill: "#d3dd25",
    opacity: 0.6
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161917",
    "data-name": "Path 161917",
    d: "M185.655,42.424c-3.079-1.214-6.779-.906-10-.3-.86.164-9.565,1.856-6.131,3.6,1.6.824,7.182-.9,9.135-1.019.348-.019,11.545-.5,7-2.29C181.019,40.587,186.768,42.851,185.655,42.424Z",
    transform: "translate(922.933 -5.058)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161918",
    "data-name": "Path 161918",
    d: "M184.22,42.121c-1.8-.157-15.5,1.189-12.412,3.566,1.324,1.013,7.694.082,9.387-.12,1.584-.176,7.926-3.032,3.024-3.447C182.431,41.963,185.763,42.253,184.22,42.121Z",
    transform: "translate(938.268 -2.515)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161919",
    "data-name": "Path 161919",
    d: "M171.251,42.879c-1.359,0-1.359,1.692,0,1.692C172.637,44.571,172.637,42.879,171.251,42.879Z",
    transform: "translate(931.718 1.752)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161920",
    "data-name": "Path 161920",
    d: "M179.817,44.026c-1.686-1.3-11.941-2.069-12.569.434-.573,2.4,14.747,1.233,12.569-.434C177.168,42,180.5,44.554,179.817,44.026Z",
    transform: "translate(914.242 1.416)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161921",
    "data-name": "Path 161921",
    d: "M172.419,42.785c-2.157.189-4.342.27-6.5.371-1.959.107-1.959,2.365,0,2.447a17.487,17.487,0,0,0,5.387-.428c.812-.22,4.021-2.667,1.113-2.39C170.248,42.973,173.668,42.659,172.419,42.785Z",
    transform: "translate(898.026 1.091)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161922",
    "data-name": "Path 161922",
    d: "M176.234,42.153c-2.157.126-4.315.315-6.472.258-.055,0-6.349.623-2.779,1.535a18.428,18.428,0,0,0,7.96.554C175.852,44.323,179.142,41.984,176.234,42.153Z",
    transform: "translate(906.404 -2.133)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161923",
    "data-name": "Path 161923",
    d: "M179.764,40.733c-1.126-.283-8.964-.522-6.349,1.874,2.362,2.126,9.8-1.013,6.349-1.874C178.105,40.311,181.109,41.06,179.764,40.733Z",
    transform: "translate(947.175 -10.519)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161924",
    "data-name": "Path 161924",
    d: "M184.471,42.794c-1.085-.138-12.623.34-9.087,2.3,1.2.648,5.625-.308,7.052-.421.287-.019,5.134-1.491,2.035-1.874C181.569,42.417,185.543,42.926,184.471,42.794Z",
    transform: "translate(957.829 0.553)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161925",
    "data-name": "Path 161925",
    d: "M200.5,46.844c-3.1-1.22-6.793-.918-10.022-.308-.874.17-9.578,1.862-6.144,3.617,1.611.811,7.189-.9,9.135-1.019.362-.031,11.572-.5,7.032-2.29C195.853,45.013,201.588,47.278,200.5,46.844Z",
    transform: "translate(1009.215 18.28)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161926",
    "data-name": "Path 161926",
    d: "M199.008,46.534c-1.789-.157-15.511,1.17-12.378,3.56,1.311,1.013,7.674.076,9.36-.119,1.577-.182,7.912-3.019,3.018-3.441C197.219,46.377,200.565,46.66,199.008,46.534Z",
    transform: "translate(1024.576 20.829)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161927",
    "data-name": "Path 161927",
    d: "M186.065,47.291c-1.365,0-1.365,1.7,0,1.7S187.43,47.291,186.065,47.291Z",
    transform: "translate(1018.014 25.092)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161928",
    "data-name": "Path 161928",
    d: "M194.615,48.452c-1.693-1.315-11.941-2.082-12.555.428-.587,2.4,14.733,1.214,12.555-.428C191.973,46.42,195.3,48.961,194.615,48.452Z",
    transform: "translate(1000.547 24.762)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161929",
    "data-name": "Path 161929",
    d: "M187.231,47.186c-2.157.2-4.342.283-6.492.4-1.973.1-1.973,2.353,0,2.459a17.821,17.821,0,0,0,5.393-.447c.812-.214,4.014-2.667,1.1-2.409C185.073,47.387,188.473,47.085,187.231,47.186Z",
    transform: "translate(984.317 24.423)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161930",
    "data-name": "Path 161930",
    d: "M191.047,46.569c-2.157.126-4.322.314-6.479.245-.034,0-6.363.629-2.765,1.529a18.159,18.159,0,0,0,7.947.572C190.644,48.72,193.928,46.386,191.047,46.569Z",
    transform: "translate(992.701 21.216)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161931",
    "data-name": "Path 161931",
    d: "M194.558,45.146c-1.106-.277-8.957-.535-6.329,1.874,2.348,2.139,9.8-1.019,6.329-1.874Z",
    transform: "translate(1033.471 12.827)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161932",
    "data-name": "Path 161932",
    d: "M199.266,47.206c-1.065-.138-12.61.346-9.073,2.3,1.2.667,5.626-.308,7.046-.409.287-.025,5.148-1.484,2.028-1.887C196.378,46.829,200.331,47.339,199.266,47.206Z",
    transform: "translate(1044.123 23.893)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161933",
    "data-name": "Path 161933",
    d: "M196.635,37.115a9.367,9.367,0,0,0-5.018-.151c-.423.082-4.772.931-3.059,1.8.8.421,3.591-.434,4.554-.5.184-.013,5.8-.245,3.523-1.145C194.307,36.19,197.174,37.329,196.635,37.115Z",
    transform: "translate(1036.193 -30.948)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161934",
    "data-name": "Path 161934",
    d: "M195.874,36.962c-.881-.075-7.721.585-6.165,1.786.649.509,3.83.031,4.67-.063.8-.082,3.96-1.516,1.5-1.723C194.993,36.886,196.679,37.024,195.874,36.962Z",
    transform: "translate(1043.877 -29.675)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161935",
    "data-name": "Path 161935",
    d: "M189.441,37.341c-.7,0-.7.849,0,.849A.431.431,0,1,0,189.441,37.341Z",
    transform: "translate(1040.581 -27.544)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161936",
    "data-name": "Path 161936",
    d: "M193.7,37.923c-.853-.654-5.967-1.05-6.281.214-.28,1.208,7.38.6,6.281-.214C192.392,36.9,194.051,38.175,193.7,37.923Z",
    transform: "translate(1031.847 -27.712)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161937",
    "data-name": "Path 161937",
    d: "M190.012,37.3c-1.085.094-2.178.138-3.25.189-.983.05-.983,1.164,0,1.22a8.737,8.737,0,0,0,2.683-.214c.4-.1,2.021-1.334.567-1.2C188.92,37.39,190.62,37.227,190.012,37.3Z",
    transform: "translate(1023.747 -27.877)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161938",
    "data-name": "Path 161938",
    d: "M191.916,36.979a31.109,31.109,0,0,1-3.25.126c-.02,0-3.161.315-1.372.78a9.539,9.539,0,0,0,3.973.27C191.7,38.055,193.37,36.891,191.916,36.979Z",
    transform: "translate(1027.933 -29.485)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161939",
    "data-name": "Path 161939",
    d: "M193.688,36.278c-.553-.157-4.492-.27-3.182.925,1.167,1.076,4.916-.5,3.182-.925C192.841,36.058,194.343,36.435,193.688,36.278Z",
    transform: "translate(1048.315 -33.677)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161940",
    "data-name": "Path 161940",
    d: "M196.048,37.3c-.553-.069-6.336.164-4.554,1.145.594.34,2.806-.157,3.537-.2.13-.013,2.546-.755,1.017-.944C194.6,37.111,196.553,37.363,196.048,37.3Z",
    transform: "translate(1053.636 -28.139)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161941",
    "data-name": "Path 161941",
    d: "M172.372,36.71a9.276,9.276,0,0,0-5.011-.132c-.43.075-4.772.925-3.065,1.786.806.428,3.584-.434,4.561-.5.191-.013,5.789-.239,3.516-1.157C170.037,35.811,172.918,36.943,172.372,36.71Z",
    transform: "translate(894.823 -33.053)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161942",
    "data-name": "Path 161942",
    d: "M171.628,36.563c-.894-.075-7.749.6-6.179,1.8.655.5,3.85.038,4.67-.063s3.96-1.528,1.509-1.736C170.734,36.488,172.42,36.626,171.628,36.563Z",
    transform: "translate(902.496 -31.78)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161943",
    "data-name": "Path 161943",
    d: "M165.166,36.944a.435.435,0,1,0,0,.855A.435.435,0,1,0,165.166,36.944Z",
    transform: "translate(899.216 -29.645)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161944",
    "data-name": "Path 161944",
    d: "M169.445,37.528c-.86-.654-5.974-1.05-6.281.208-.307,1.2,7.373.61,6.281-.208C168.113,36.509,169.793,37.78,169.445,37.528Z",
    transform: "translate(890.48 -29.807)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161945",
    "data-name": "Path 161945",
    d: "M165.749,36.892c-1.079.113-2.171.145-3.25.2-.969.05-1,1.176,0,1.22a9.072,9.072,0,0,0,2.7-.214c.4-.1,2.007-1.334.546-1.208C164.67,37.005,166.37,36.835,165.749,36.892Z",
    transform: "translate(882.364 -29.983)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161946",
    "data-name": "Path 161946",
    d: "M167.637,36.581a28.667,28.667,0,0,1-3.215.126c-.034,0-3.182.321-1.386.774a9.24,9.24,0,0,0,3.98.277C167.452,37.669,169.1,36.493,167.637,36.581Z",
    transform: "translate(886.559 -31.59)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161947",
    "data-name": "Path 161947",
    d: "M169.4,35.868c-.533-.138-4.458-.258-3.154.937,1.167,1.076,4.9-.509,3.154-.937C168.579,35.673,170.081,36.044,169.4,35.868Z",
    transform: "translate(906.945 -35.784)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161948",
    "data-name": "Path 161948",
    d: "M171.782,36.9c-.546-.063-6.322.182-4.554,1.151.594.321,2.813-.157,3.536-.214.13-.006,2.546-.742,1.017-.937C170.334,36.709,172.308,36.967,171.782,36.9Z",
    transform: "translate(912.262 -30.247)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161949",
    "data-name": "Path 161949",
    d: "M72.233,46.713a9.256,9.256,0,0,0-5-.151c-.444.082-4.793.918-3.072,1.8.806.4,3.6-.44,4.567-.5.177-.025,5.783-.258,3.509-1.145C69.9,45.795,72.786,46.921,72.233,46.713Z",
    transform: "translate(311.267 19.814)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161950",
    "data-name": "Path 161950",
    d: "M71.506,46.565c-.9-.094-7.762.579-6.206,1.768.669.516,3.85.038,4.7-.038.778-.1,3.953-1.535,1.5-1.73C70.619,46.47,72.278,46.621,71.506,46.565Z",
    transform: "translate(318.937 21.082)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161951",
    "data-name": "Path 161951",
    d: "M65.021,46.936c-.683,0-.683.849,0,.849S65.711,46.936,65.021,46.936Z",
    transform: "translate(315.659 23.214)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161952",
    "data-name": "Path 161952",
    d: "M69.294,47.514c-.847-.654-5.96-1.038-6.274.214-.3,1.208,7.36.61,6.274-.214C67.97,46.5,69.629,47.772,69.294,47.514Z",
    transform: "translate(306.935 23.051)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161953",
    "data-name": "Path 161953",
    d: "M65.6,46.883c-1.079.113-2.164.145-3.257.189-.969.057-.969,1.183,0,1.245a9.543,9.543,0,0,0,2.717-.226c.4-.113,1.994-1.34.539-1.208C64.523,47,66.23,46.833,65.6,46.883Z",
    transform: "translate(298.816 22.883)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161954",
    "data-name": "Path 161954",
    d: "M67.5,46.572a32.157,32.157,0,0,1-3.216.138s-3.188.314-1.406.761a9.135,9.135,0,0,0,3.994.283C67.317,47.666,68.955,46.5,67.5,46.572Z",
    transform: "translate(303.007 21.27)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161955",
    "data-name": "Path 161955",
    d: "M69.267,45.86c-.56-.138-4.479-.258-3.161.95,1.167,1.076,4.9-.516,3.161-.95C68.447,45.671,69.943,46.042,69.267,45.86Z",
    transform: "translate(323.395 17.075)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161956",
    "data-name": "Path 161956",
    d: "M71.616,46.889c-.526-.069-6.3.176-4.526,1.157.594.314,2.792-.157,3.516-.214.157-.013,2.56-.736,1.01-.944C70.182,46.713,72.162,46.958,71.616,46.889Z",
    transform: "translate(328.727 22.62)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161957",
    "data-name": "Path 161957",
    d: "M52.285,46.713a9.258,9.258,0,0,0-5-.151c-.444.082-4.813.918-3.079,1.8.806.4,3.584-.44,4.574-.5.171-.025,5.776-.258,3.509-1.145C49.957,45.795,52.831,46.921,52.285,46.713Z",
    transform: "translate(194.966 19.814)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161958",
    "data-name": "Path 161958",
    d: "M51.545,46.565c-.9-.094-7.762.579-6.2,1.768.662.516,3.837.038,4.683-.038.806-.1,3.953-1.535,1.516-1.73C50.644,46.47,52.316,46.621,51.545,46.565Z",
    transform: "translate(202.649 21.082)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161959",
    "data-name": "Path 161959",
    d: "M45.063,46.936c-.683,0-.683.849,0,.849C45.766,47.785,45.766,46.936,45.063,46.936Z",
    transform: "translate(199.362 23.214)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161960",
    "data-name": "Path 161960",
    d: "M49.336,47.514c-.84-.654-5.974-1.038-6.274.214-.28,1.208,7.36.61,6.274-.214C48,46.5,49.677,47.772,49.336,47.514Z",
    transform: "translate(190.638 23.051)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161961",
    "data-name": "Path 161961",
    d: "M45.64,46.883c-1.079.113-2.164.145-3.236.189-.99.057-.99,1.183,0,1.245a9.5,9.5,0,0,0,2.7-.226c.4-.113,2-1.34.539-1.208C44.561,47,46.254,46.833,45.64,46.883Z",
    transform: "translate(182.523 22.883)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161962",
    "data-name": "Path 161962",
    d: "M47.558,46.572c-1.079.082-2.157.164-3.25.138,0,0-3.175.314-1.372.761a8.991,8.991,0,0,0,3.967.283C47.339,47.666,49,46.5,47.558,46.572Z",
    transform: "translate(186.722 21.27)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161963",
    "data-name": "Path 161963",
    d: "M49.318,45.86c-.567-.138-4.479-.258-3.175.95,1.167,1.076,4.9-.516,3.175-.95C48.492,45.671,49.981,46.042,49.318,45.86Z",
    transform: "translate(207.102 17.075)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161964",
    "data-name": "Path 161964",
    d: "M51.663,46.889c-.526-.069-6.308.176-4.533,1.157.608.314,2.806-.157,3.523-.214.143-.013,2.574-.736,1.01-.944C50.223,46.713,52.209,46.958,51.663,46.889Z",
    transform: "translate(212.424 22.62)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161965",
    "data-name": "Path 161965",
    d: "M22.152,49.071a9.377,9.377,0,0,0-5-.151c-.444.088-4.793.925-3.079,1.8.812.409,3.591-.44,4.574-.5.184-.013,5.789-.245,3.509-1.145C19.838,48.147,22.7,49.279,22.152,49.071Z",
    transform: "translate(19.419 32.313)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161966",
    "data-name": "Path 161966",
    d: "M21.411,48.923c-.894-.082-7.749.585-6.192,1.774.669.51,3.85.038,4.683-.057.806-.088,3.967-1.516,1.509-1.717C20.516,48.841,22.182,48.986,21.411,48.923Z",
    transform: "translate(27.103 33.587)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161967",
    "data-name": "Path 161967",
    d: "M14.937,49.3c-.683,0-.683.849,0,.849S15.633,49.3,14.937,49.3Z",
    transform: "translate(23.814 35.714)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161968",
    "data-name": "Path 161968",
    d: "M19.228,49.878c-.853-.654-5.967-1.038-6.295.208-.273,1.208,7.38.61,6.295-.208C17.9,48.859,19.555,50.13,19.228,49.878Z",
    transform: "translate(15.079 35.55)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161969",
    "data-name": "Path 161969",
    d: "M15.514,49.247c-1.072.1-2.164.145-3.257.2-.963.044-.963,1.176,0,1.227a9.339,9.339,0,0,0,2.717-.214c.389-.113,1.987-1.334.539-1.208C14.442,49.348,16.142,49.2,15.514,49.247Z",
    transform: "translate(6.975 35.383)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161970",
    "data-name": "Path 161970",
    d: "M17.423,48.936c-1.072.069-2.157.157-3.229.12-.027,0-3.168.327-1.4.774a9.2,9.2,0,0,0,3.987.277C17.219,50.012,18.871,48.855,17.423,48.936Z",
    transform: "translate(11.169 33.775)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161971",
    "data-name": "Path 161971",
    d: "M19.178,48.214c-.546-.12-4.465-.252-3.161.944,1.161,1.082,4.9-.5,3.161-.944C18.346,48.025,19.861,48.4,19.178,48.214Z",
    transform: "translate(31.554 29.578)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161972",
    "data-name": "Path 161972",
    d: "M21.537,49.26c-.539-.075-6.315.17-4.526,1.139.58.34,2.792-.157,3.516-.2.137-.006,2.56-.749,1.01-.937C20.089,49.065,22.076,49.323,21.537,49.26Z",
    transform: "translate(36.883 35.118)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161973",
    "data-name": "Path 161973",
    d: "M32.215,45.772a9.292,9.292,0,0,0-5.032-.157c-.43.088-4.786.931-3.052,1.812.792.4,3.584-.453,4.561-.522.164-.006,5.783-.233,3.523-1.132C29.88,44.853,32.741,45.973,32.215,45.772Z",
    transform: "translate(78.009 14.805)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161974",
    "data-name": "Path 161974",
    d: "M31.468,45.611c-.894-.075-7.762.591-6.192,1.786.662.491,3.844.031,4.69-.057.785-.107,3.953-1.522,1.5-1.73C30.58,45.536,32.239,45.674,31.468,45.611Z",
    transform: "translate(85.686 16.085)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161975",
    "data-name": "Path 161975",
    d: "M25,45.991c-.7,0-.7.855,0,.855A.435.435,0,1,0,25,45.991Z",
    transform: "translate(82.397 18.215)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161976",
    "data-name": "Path 161976",
    d: "M29.283,46.57c-.86-.66-5.981-1.038-6.295.214-.287,1.2,7.373.616,6.295-.214C27.945,45.551,29.6,46.822,29.283,46.57Z",
    transform: "translate(73.67 18.044)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161977",
    "data-name": "Path 161977",
    d: "M25.579,45.944c-1.079.088-2.178.126-3.263.2-.969.044-.969,1.164,0,1.227a8.494,8.494,0,0,0,2.71-.239c.4-.094,2-1.327.553-1.183C24.493,46.032,26.18,45.881,25.579,45.944Z",
    transform: "translate(65.557 17.884)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161978",
    "data-name": "Path 161978",
    d: "M27.479,45.63c-1.072.063-2.137.157-3.236.126-.034,0-3.181.308-1.379.767a8.939,8.939,0,0,0,3.973.27C27.288,46.711,28.934,45.535,27.479,45.63Z",
    transform: "translate(69.746 16.274)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161979",
    "data-name": "Path 161979",
    d: "M29.24,44.92c-.567-.138-4.472-.27-3.168.925,1.161,1.069,4.9-.5,3.168-.925C28.407,44.712,29.9,45.064,29.24,44.92Z",
    transform: "translate(90.139 12.084)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161980",
    "data-name": "Path 161980",
    d: "M31.6,45.947c-.546-.075-6.329.17-4.54,1.151.6.321,2.8-.157,3.53-.195.123-.019,2.56-.761,1.01-.956Z",
    transform: "translate(95.458 17.611)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161981",
    "data-name": "Path 161981",
    d: "M155.719,38.348c-3.106-1.2-6.8-.893-10.022-.289-.874.164-9.585,1.849-6.138,3.611,1.6.818,7.182-.893,9.128-1.019.348-.019,11.558-.5,7.032-2.3C151.056,36.524,156.818,38.8,155.719,38.348Z",
    transform: "translate(748.301 -26.564)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161982",
    "data-name": "Path 161982",
    d: "M154.231,38.063c-1.8-.17-15.5,1.17-12.378,3.554,1.311,1,7.66.069,9.387-.113,1.563-.182,7.885-3.032,2.99-3.441C152.435,37.893,155.78,38.183,154.231,38.063Z",
    transform: "translate(763.662 -24.015)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161983",
    "data-name": "Path 161983",
    d: "M141.293,38.815c-1.372,0-1.372,1.686,0,1.686S142.659,38.815,141.293,38.815Z",
    transform: "translate(757.094 -19.747)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161984",
    "data-name": "Path 161984",
    d: "M149.833,39.961c-1.693-1.289-11.934-2.069-12.548.428-.594,2.4,14.726,1.227,12.548-.428C147.177,37.936,150.515,40.464,149.833,39.961Z",
    transform: "translate(739.632 -20.081)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161985",
    "data-name": "Path 161985",
    d: "M142.463,38.71c-2.178.214-4.335.277-6.513.4-1.959.094-1.959,2.346,0,2.441a17.639,17.639,0,0,0,5.407-.434c.819-.214,4.007-2.661,1.106-2.4C140.285,38.924,143.7,38.6,142.463,38.71Z",
    transform: "translate(723.393 -20.422)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161986",
    "data-name": "Path 161986",
    d: "M146.269,38.091c-2.157.132-4.3.314-6.479.239-.048,0-6.356.635-2.765,1.541a18.426,18.426,0,0,0,7.967.566C145.866,40.242,149.164,37.908,146.269,38.091Z",
    transform: "translate(731.781 -23.633)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161987",
    "data-name": "Path 161987",
    d: "M149.785,36.664c-1.106-.277-8.957-.522-6.336,1.881,2.349,2.132,9.8-1,6.336-1.881C148.119,36.249,151.144,37,149.785,36.664Z",
    transform: "translate(772.552 -32.026)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161988",
    "data-name": "Path 161988",
    d: "M154.5,38.721c-1.065-.138-12.623.352-9.08,2.3,1.195.66,5.626-.315,7.052-.415.28-.019,5.141-1.491,2.028-1.887C151.61,38.356,155.55,38.866,154.5,38.721Z",
    transform: "translate(783.207 -20.955)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161989",
    "data-name": "Path 161989",
    d: "M150.73,42.205c-3.086-1.208-6.8-.9-10.036-.283-.84.157-9.572,1.856-6.131,3.6,1.632.824,7.2-.887,9.135-1.013.369-.025,11.565-.5,7.032-2.3C146.074,40.381,151.829,42.658,150.73,42.205Z",
    transform: "translate(719.216 -6.179)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161990",
    "data-name": "Path 161990",
    d: "M149.254,41.911c-1.789-.164-15.5,1.183-12.4,3.573,1.324,1,7.687.075,9.394-.12,1.577-.182,7.892-3.038,3-3.453C147.472,41.748,150.811,42.037,149.254,41.911Z",
    transform: "translate(734.578 -3.64)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161991",
    "data-name": "Path 161991",
    d: "M136.3,42.667c-1.365,0-1.365,1.7,0,1.7C137.684,44.365,137.684,42.667,136.3,42.667Z",
    transform: "translate(728.016 0.631)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161992",
    "data-name": "Path 161992",
    d: "M144.861,43.824c-1.707-1.308-11.961-2.082-12.569.434-.58,2.4,14.74,1.214,12.569-.434C142.192,41.8,145.537,44.333,144.861,43.824Z",
    transform: "translate(710.549 0.298)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161993",
    "data-name": "Path 161993",
    d: "M137.46,42.566c-2.164.208-4.356.27-6.506.39-1.946.1-1.946,2.34,0,2.447a17.107,17.107,0,0,0,5.407-.447c.792-.2,4-2.661,1.1-2.39C135.3,42.774,138.689,42.453,137.46,42.566Z",
    transform: "translate(694.336 -0.036)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161994",
    "data-name": "Path 161994",
    d: "M141.271,41.941c-2.137.138-4.294.327-6.465.258-.055,0-6.356.616-2.772,1.528a18.2,18.2,0,0,0,7.954.56C140.868,44.105,144.165,41.772,141.271,41.941Z",
    transform: "translate(702.712 -3.255)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161995",
    "data-name": "Path 161995",
    d: "M144.8,40.521c-1.106-.277-8.95-.535-6.342,1.874,2.355,2.139,9.8-1.013,6.342-1.874C143.153,40.112,146.136,40.86,144.8,40.521Z",
    transform: "translate(743.479 -11.64)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161996",
    "data-name": "Path 161996",
    d: "M149.513,42.581c-1.085-.145-12.637.346-9.08,2.29,1.195.66,5.612-.314,7.052-.409.287-.019,5.12-1.484,2.028-1.881C146.626,42.2,150.565,42.725,149.513,42.581Z",
    transform: "translate(754.131 -0.566)",
    fill: "#d3dd25",
    opacity: 0.4
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161997",
    "data-name": "Path 161997",
    d: "M164.619,53c-2.171-.761-20.4-1.484-16.317,2.214,1.7,1.535,8.288,1.076,10.548,1.006.58-.019,10.22-1.591,5.769-3.221C160.317,51.466,165.7,53.4,164.619,53Z",
    transform: "translate(800.47 52.046)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161998",
    "data-name": "Path 161998",
    d: "M163.54,54.511c-2.69-1.51-21.007-2.063-17.368,1.264,1.441,1.34,7.414.7,9.455.855.512.025,12.931.723,7.913-2.12C159.491,52.228,164.584,55.109,163.54,54.511Z",
    transform: "translate(788.741 56.983)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161999",
    "data-name": "Path 161999",
    d: "M154.892,54.076c-2.321-.66-15.8,1.573-12.139,4.284,2.567,1.918,17.293-2.837,12.139-4.284C151.143,53.02,156.742,54.586,154.892,54.076Z",
    transform: "translate(767.937 59.003)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162000",
    "data-name": "Path 162000",
    d: "M163.17,52.495c-4.41-.78-8.93.874-13.279,1.208-2.526.2-10.787,2.623-3.646,3.6,3.3.447,7.209-.421,10.459-.811.574-.063,12.617-2.912,6.465-4C159.839,51.91,165.089,52.835,163.17,52.495Z",
    transform: "translate(775.388 51.527)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162001",
    "data-name": "Path 162001",
    d: "M152.418,54.627c-2.089-.182-16.6,3.353-12.978,5.284,1.591.855,5.926-1.346,7.394-1.774.137-.038,10.288-3.12,5.585-3.51C148.11,54.25,153.537,54.721,152.418,54.627Z",
    transform: "translate(748.926 63.114)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162002",
    "data-name": "Path 162002",
    d: "M162.367,55.646c-2.751-1.214-20.993.038-18.972,2.642,1.017,1.308,7.7-.176,9.223-.365.58-.05,12.924-.874,9.749-2.277C157.294,53.407,163.124,55.986,162.367,55.646Z",
    transform: "translate(774.423 64.403)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162003",
    "data-name": "Path 162003",
    d: "M161.106,53.328c-3.243-.283-6.377.572-9.592.635-2.041.031-2.1,2.554,0,2.554a95.5,95.5,0,0,0,10.009-.811c1.959-.233,1-2.246-.417-2.378C157.911,53.045,162.67,53.473,161.106,53.328Z",
    transform: "translate(813.608 56.506)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162004",
    "data-name": "Path 162004",
    d: "M152.825,54.151c-1.72,0-1.72,2.113,0,2.113S154.553,54.151,152.825,54.151Z",
    transform: "translate(822.77 61.382)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162005",
    "data-name": "Path 162005",
    d: "M168.222,51.789c-3.475-.283-6.984-.038-10.473-.057,1.195.006-8.889.843-3.83,1.868a35.873,35.873,0,0,0,9.025.881c.778-.025,9.2-2.371,5.277-2.692C163.587,51.4,169.144,51.864,168.222,51.789Z",
    transform: "translate(828.333 48.05)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162006",
    "data-name": "Path 162006",
    d: "M167.644,53.3c-1.973-.635-15.5-1.22-13.8,1.478.853,1.4,6.226.755,7.694.774.376,0,10.507-.881,6.11-2.252C165.958,52.751,168.819,53.663,167.644,53.3Z",
    transform: "translate(835.348 54.045)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162007",
    "data-name": "Path 162007",
    d: "M130.13,51.608c-2.144-.767-20.386-1.5-16.29,2.208,1.7,1.522,8.281,1.069,10.562,1.006.567-.019,10.207-1.61,5.728-3.214C125.85,50.054,131.236,52,130.13,51.608Z",
    transform: "translate(599.641 44.627)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162008",
    "data-name": "Path 162008",
    d: "M129.1,53.113c-2.7-1.516-21.021-2.063-17.4,1.252,1.461,1.34,7.414.7,9.476.849.505.031,12.917.73,7.919-2.1C125.029,50.824,130.129,53.7,129.1,53.113Z",
    transform: "translate(587.907 49.569)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162009",
    "data-name": "Path 162009",
    d: "M120.417,52.673c-2.308-.66-15.812,1.566-12.125,4.284,2.581,1.918,17.286-2.831,12.125-4.284C116.689,51.617,122.267,53.183,120.417,52.673Z",
    transform: "translate(567.095 51.581)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162010",
    "data-name": "Path 162010",
    d: "M128.715,51.089c-4.417-.774-8.937.881-13.286,1.214-2.512.189-10.794,2.623-3.653,3.592,3.3.447,7.237-.409,10.473-.805.58-.063,12.582-2.906,6.465-4C125.383,50.511,130.62,51.429,128.715,51.089Z",
    transform: "translate(574.554 44.108)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162011",
    "data-name": "Path 162011",
    d: "M117.949,53.222c-2.1-.182-16.61,3.365-12.965,5.3,1.563.855,5.926-1.346,7.373-1.767.15-.057,10.3-3.12,5.591-3.529C113.627,52.851,119.048,53.31,117.949,53.222Z",
    transform: "translate(548.105 55.688)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162012",
    "data-name": "Path 162012",
    d: "M127.9,54.243c-2.751-1.208-20.987.044-18.973,2.648,1,1.3,7.7-.164,9.223-.365.6-.069,12.917-.887,9.749-2.283C122.822,52,128.666,54.583,127.9,54.243Z",
    transform: "translate(573.599 56.981)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162013",
    "data-name": "Path 162013",
    d: "M126.645,51.925c-3.243-.289-6.383.572-9.606.629-2.034.044-2.075,2.566,0,2.547a84.329,84.329,0,0,0,10.009-.8c1.966-.226,1.017-2.246-.4-2.378C123.464,51.648,128.2,52.057,126.645,51.925Z",
    transform: "translate(612.78 49.084)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162014",
    "data-name": "Path 162014",
    d: "M118.361,52.747c-1.72,0-1.72,2.12,0,2.12S120.075,52.747,118.361,52.747Z",
    transform: "translate(621.944 53.955)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162015",
    "data-name": "Path 162015",
    d: "M133.764,50.383c-3.482-.289-6.964-.031-10.473-.057,1.208.006-8.889.849-3.851,1.881a37.369,37.369,0,0,0,9.06.874c.771-.038,9.2-2.378,5.264-2.7C129.142,50,134.713,50.459,133.764,50.383Z",
    transform: "translate(627.487 40.631)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162016",
    "data-name": "Path 162016",
    d: "M133.208,51.89c-1.987-.629-15.518-1.214-13.839,1.491.874,1.4,6.26.749,7.715.761.389.006,10.514-.862,6.124-2.252C131.5,51.349,134.355,52.261,133.208,51.89Z",
    transform: "translate(634.501 46.622)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162017",
    "data-name": "Path 162017",
    d: "M133.826,39.41c-2.151-.767-20.379-1.5-16.3,2.208,1.679,1.528,8.295,1.076,10.527,1,.6-.006,10.234-1.6,5.769-3.208C129.532,37.862,134.919,39.8,133.826,39.41Z",
    transform: "translate(621.158 -19.901)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162018",
    "data-name": "Path 162018",
    d: "M132.766,40.919c-2.683-1.528-21.007-2.063-17.368,1.258,1.454,1.333,7.421.692,9.469.843.5.044,12.91.723,7.9-2.1C128.717,38.63,133.817,41.51,132.766,40.919Z",
    transform: "translate(609.417 -14.963)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162019",
    "data-name": "Path 162019",
    d: "M124.118,40.467c-2.308-.642-15.8,1.585-12.145,4.3,2.594,1.912,17.307-2.843,12.145-4.3C120.376,39.423,125.954,41,124.118,40.467Z",
    transform: "translate(588.6 -12.945)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162020",
    "data-name": "Path 162020",
    d: "M132.394,38.9c-4.41-.78-8.93.868-13.265,1.2-2.526.2-10.794,2.636-3.666,3.617,3.311.44,7.23-.421,10.466-.805.587-.063,12.61-2.912,6.465-4.007C129.055,38.292,134.312,39.235,132.394,38.9Z",
    transform: "translate(596.067 -20.419)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162021",
    "data-name": "Path 162021",
    d: "M121.636,41.017c-2.069-.182-16.583,3.365-12.971,5.284,1.591.868,5.933-1.34,7.394-1.755.13-.044,10.288-3.126,5.578-3.529C117.335,40.659,122.769,41.118,121.636,41.017Z",
    transform: "translate(569.61 -8.834)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162022",
    "data-name": "Path 162022",
    d: "M131.6,42.045c-2.751-1.214-20.987.031-18.979,2.642,1.024,1.315,7.708-.164,9.223-.346.587-.082,12.937-.906,9.756-2.3C126.5,39.812,132.356,42.378,131.6,42.045Z",
    transform: "translate(595.102 -7.541)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162023",
    "data-name": "Path 162023",
    d: "M130.337,39.727c-3.243-.283-6.37.566-9.6.635-2.041.038-2.089,2.573,0,2.547a89.131,89.131,0,0,0,10.015-.8c1.953-.226,1-2.252-.416-2.384C127.142,39.444,131.887,39.872,130.337,39.727Z",
    transform: "translate(634.287 -15.445)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162024",
    "data-name": "Path 162024",
    d: "M122.057,40.55c-1.727,0-1.727,2.12,0,2.12S123.791,40.55,122.057,40.55Z",
    transform: "translate(643.448 -10.569)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162025",
    "data-name": "Path 162025",
    d: "M137.463,38.182c-3.489-.277-7-.038-10.473-.069,1.195.013-8.9.862-3.857,1.906a37.5,37.5,0,0,0,9.053.874c.778-.044,9.2-2.4,5.277-2.711C132.835,37.8,138.4,38.264,137.463,38.182Z",
    transform: "translate(649 -23.894)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162026",
    "data-name": "Path 162026",
    d: "M136.874,39.686c-1.98-.616-15.484-1.208-13.811,1.5.867,1.39,6.233.742,7.7.742.376.013,10.527-.855,6.11-2.239C135.181,39.152,138.021,40.057,136.874,39.686Z",
    transform: "translate(656.027 -17.895)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162027",
    "data-name": "Path 162027",
    d: "M99.785,48.607c-2.164-.767-20.393-1.5-16.3,2.208,1.679,1.535,8.274,1.082,10.541,1.019.573-.019,10.213-1.61,5.762-3.227C95.484,47.072,100.856,49.01,99.785,48.607Z",
    transform: "translate(422.743 28.764)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162028",
    "data-name": "Path 162028",
    d: "M98.727,50.117c-2.7-1.516-21.014-2.069-17.382,1.252,1.447,1.34,7.428.7,9.476.843.492.05,12.924.736,7.906-2.095C94.672,47.821,99.771,50.715,98.727,50.117Z",
    transform: "translate(411 33.707)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162029",
    "data-name": "Path 162029",
    d: "M90.057,49.673c-2.3-.66-15.791,1.579-12.132,4.29,2.587,1.925,17.3-2.837,12.132-4.29C86.322,48.616,91.914,50.195,90.057,49.673Z",
    transform: "translate(390.19 35.718)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162030",
    "data-name": "Path 162030",
    d: "M98.353,48.1c-4.41-.786-8.93.862-13.286,1.189-2.5.2-10.794,2.629-3.652,3.611,3.3.44,7.23-.415,10.452-.805.6-.069,12.623-2.906,6.486-3.994C95.014,47.5,100.264,48.439,98.353,48.1Z",
    transform: "translate(397.644 28.253)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162031",
    "data-name": "Path 162031",
    d: "M87.615,50.22c-2.11-.182-16.624,3.353-13,5.29,1.6.855,5.94-1.346,7.407-1.774.123-.038,10.288-3.114,5.591-3.516C83.286,49.856,88.721,50.321,87.615,50.22Z",
    transform: "translate(371.182 39.838)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162032",
    "data-name": "Path 162032",
    d: "M97.549,51.247c-2.772-1.214-20.993.031-18.979,2.636,1.024,1.315,7.708-.164,9.251-.352.56-.069,12.9-.893,9.729-2.283C92.456,49.008,98.32,51.58,97.549,51.247Z",
    transform: "translate(396.687 41.126)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162033",
    "data-name": "Path 162033",
    d: "M96.284,48.933c-3.236-.3-6.383.566-9.6.623-2.034.044-2.089,2.573,0,2.554a90.352,90.352,0,0,0,10.022-.8c1.953-.233.99-2.252-.423-2.378C93.1,48.637,97.854,49.078,96.284,48.933Z",
    transform: "translate(435.87 33.225)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162034",
    "data-name": "Path 162034",
    d: "M88.006,49.749c-1.727,0-1.727,2.126,0,2.126S89.726,49.749,88.006,49.749Z",
    transform: "translate(445.029 38.095)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162035",
    "data-name": "Path 162035",
    d: "M103.4,47.378c-3.475-.283-6.971-.025-10.473-.057,1.208.013-8.889.862-3.83,1.887a36.652,36.652,0,0,0,9.025.874c.8-.031,9.23-2.365,5.277-2.7C98.774,47.007,104.338,47.466,103.4,47.378Z",
    transform: "translate(450.591 24.773)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162036",
    "data-name": "Path 162036",
    d: "M102.831,48.9c-1.973-.629-15.5-1.227-13.818,1.484.867,1.409,6.247.755,7.694.767.389,0,10.527-.874,6.124-2.252C101.138,48.357,104.005,49.262,102.831,48.9Z",
    transform: "translate(457.601 30.769)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162037",
    "data-name": "Path 162037",
    d: "M73.183,54.169c-2.157-.78-20.386-1.5-16.29,2.208,1.686,1.516,8.281,1.069,10.548,1.006.573-.019,10.213-1.61,5.742-3.214C68.9,52.622,74.275,54.565,73.183,54.169Z",
    transform: "translate(267.798 58.15)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162038",
    "data-name": "Path 162038",
    d: "M72.149,55.664c-2.7-1.5-21.021-2.069-17.4,1.271,1.468,1.327,7.414.692,9.483.837.485.038,12.917.736,7.913-2.107C68.08,53.387,73.187,56.268,72.149,55.664Z",
    transform: "translate(256.058 63.089)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162039",
    "data-name": "Path 162039",
    d: "M63.482,55.225c-2.328-.648-15.812,1.573-12.145,4.3,2.594,1.918,17.286-2.849,12.145-4.3C59.721,54.175,65.333,55.741,63.482,55.225Z",
    transform: "translate(235.245 65.101)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162040",
    "data-name": "Path 162040",
    d: "M71.742,53.649c-4.4-.78-8.916.868-13.265,1.208-2.506.182-10.787,2.636-3.652,3.592,3.311.453,7.223-.4,10.466-.805.58-.05,12.61-2.906,6.452-3.994C68.417,53.064,73.66,53.983,71.742,53.649Z",
    transform: "translate(242.709 57.631)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162041",
    "data-name": "Path 162041",
    d: "M61.007,55.775c-2.1-.182-16.6,3.359-12.978,5.284,1.6.855,5.919-1.333,7.387-1.761.15-.044,10.309-3.126,5.591-3.522C56.685,55.411,62.106,55.87,61.007,55.775Z",
    transform: "translate(216.25 69.218)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162042",
    "data-name": "Path 162042",
    d: "M70.959,56.8c-2.765-1.214-20.987.038-18.979,2.636,1.01,1.315,7.694-.157,9.237-.346.58-.069,12.9-.9,9.742-2.29C65.859,54.563,71.717,57.129,70.959,56.8Z",
    transform: "translate(241.751 70.506)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162043",
    "data-name": "Path 162043",
    d: "M69.7,54.483c-3.243-.289-6.39.566-9.606.629-2.041.031-2.089,2.566,0,2.554a91.5,91.5,0,0,0,10.015-.805c1.946-.214,1-2.252-.41-2.378Z",
    transform: "translate(280.925 62.61)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162044",
    "data-name": "Path 162044",
    d: "M61.407,55.3c-1.714,0-1.714,2.12,0,2.12S63.134,55.3,61.407,55.3Z",
    transform: "translate(290.094 67.481)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162045",
    "data-name": "Path 162045",
    d: "M76.815,52.938c-3.475-.277-6.971-.025-10.466-.057,1.2.013-8.9.849-3.85,1.881a35.945,35.945,0,0,0,9.039.893c.792-.038,9.2-2.384,5.277-2.717C72.186,52.555,77.744,53.014,76.815,52.938Z",
    transform: "translate(295.645 54.147)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162046",
    "data-name": "Path 162046",
    d: "M76.251,54.442c-1.973-.623-15.5-1.208-13.832,1.491.881,1.415,6.247.755,7.721.761.369.013,10.5-.855,6.11-2.252C74.558,53.914,77.418,54.813,76.251,54.442Z",
    transform: "translate(302.655 60.147)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162047",
    "data-name": "Path 162047",
    d: "M47.6,51.971c-2.164-.786-20.386-1.5-16.3,2.2,1.679,1.522,8.268,1.069,10.541,1.013.573-.031,10.22-1.617,5.755-3.208C43.3,50.411,48.687,52.355,47.6,51.971Z",
    transform: "translate(118.707 46.503)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162048",
    "data-name": "Path 162048",
    d: "M46.55,53.47c-2.683-1.522-21.014-2.069-17.382,1.264,1.461,1.327,7.421.7,9.49.837.492.044,12.9.723,7.892-2.1C42.508,51.181,47.608,54.074,46.55,53.47Z",
    transform: "translate(106.958 51.439)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162049",
    "data-name": "Path 162049",
    d: "M37.891,53.02c-2.308-.654-15.812,1.579-12.139,4.29,2.594,1.918,17.293-2.837,12.139-4.29C34.15,51.976,39.734,53.542,37.891,53.02Z",
    transform: "translate(86.151 53.455)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162050",
    "data-name": "Path 162050",
    d: "M46.162,51.445c-4.41-.78-8.93.881-13.265,1.208-2.512.2-10.794,2.636-3.659,3.6,3.318.453,7.223-.4,10.459-.8.594-.063,12.623-2.906,6.465-4.007C42.837,50.86,48.087,51.8,46.162,51.445Z",
    transform: "translate(93.61 45.978)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162051",
    "data-name": "Path 162051",
    d: "M35.432,53.578c-2.116-.182-16.617,3.353-12.992,5.29,1.611.849,5.933-1.352,7.394-1.774.15-.044,10.288-3.12,5.6-3.516C31.1,53.207,36.531,53.659,35.432,53.578Z",
    transform: "translate(67.146 57.565)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162052",
    "data-name": "Path 162052",
    d: "M45.371,54.6c-2.751-1.22-20.987.031-18.979,2.623,1.024,1.321,7.708-.151,9.244-.34.573-.075,12.91-.9,9.735-2.283C40.285,52.359,46.142,54.925,45.371,54.6Z",
    transform: "translate(92.647 58.859)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162053",
    "data-name": "Path 162053",
    d: "M44.113,52.282c-3.236-.289-6.383.56-9.592.629-2.048.044-2.11,2.554,0,2.554a90.382,90.382,0,0,0,10-.805c1.959-.226,1.01-2.246-.41-2.378C40.932,52,45.683,52.414,44.113,52.282Z",
    transform: "translate(131.829 50.96)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162054",
    "data-name": "Path 162054",
    d: "M35.824,53.1c-1.72,0-1.72,2.126,0,2.126S37.558,53.1,35.824,53.1Z",
    transform: "translate(140.992 55.833)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162055",
    "data-name": "Path 162055",
    d: "M51.227,50.731c-3.475-.289-6.977-.031-10.466-.05,1.195.019-8.9.843-3.85,1.881a36.454,36.454,0,0,0,9.046.881c.785-.044,9.217-2.378,5.271-2.711C46.591,50.36,52.169,50.812,51.227,50.731Z",
    transform: "translate(146.549 42.504)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162056",
    "data-name": "Path 162056",
    d: "M50.657,52.251c-1.966-.635-15.511-1.22-13.818,1.478.867,1.415,6.247.755,7.687.774.382,0,10.534-.868,6.131-2.252C48.95,51.716,51.8,52.6,50.657,52.251Z",
    transform: "translate(153.57 48.501)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162057",
    "data-name": "Path 162057",
    d: "M177.2,46.769c-3.12-.893-6.773-.371-9.995-.528-.232-.006-9.087,1.277-3.946,2.239a57.085,57.085,0,0,0,8.432,1.138c.826.038,10.329-1.466,5.51-2.849C175.095,46.172,178.652,47.191,177.2,46.769Z",
    transform: "translate(881.777 19.475)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162058",
    "data-name": "Path 162058",
    d: "M163.654,46.98c-1.85,0-1.85,2.29,0,2.29C165.525,49.27,165.525,46.98,163.654,46.98Z",
    transform: "translate(885.305 23.447)",
    fill: "#d3dd25",
    opacity: 0.5
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162059",
    "data-name": "Path 162059",
    d: "M173.88,47.193a57.559,57.559,0,0,1-10.807,1.283c-.287.006-8.5,2.164-3.646,2.346A51.178,51.178,0,0,0,172,50.187c2.56-.528,5.079-3.78,1.884-2.994C169.231,48.319,175.477,46.8,173.88,47.193Z",
    transform: "translate(859.835 23.926)",
    fill: "#d3dd25",
    opacity: 0.5
  }))))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "clouds",
    transform: "translate(-4882.589 2155.893)",
    opacity: 0.501
  }, /*#__PURE__*/React.createElement("g", {
    id: "cloud-6-group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cloud-6",
    transform: "translate(-124 153.481)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_162198",
    "data-name": "Path 162198",
    d: "M1986.573,2291.93c-3.078-9.057-12.2-15.131-24.975-15.131a46.2,46.2,0,0,0-15.242,2.722c1.627-12.648-3.281-21.863-12.665-21.863-6.915,0-14.64,4.984-20.963,12.637.761-14.523-5.776-24.8-17.378-24.8-12.54,0-27.042,12-35.788,28.4-4.563-4.016-11.132-6.41-19.125-6.41-16.779,0-34.25,10.481-42.2,24.445Z",
    transform: "translate(-1798.236 -2245.492)",
    fill: "#f3ffff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "cloud-5-group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cloud-5",
    d: "M1212.856,2205.66c9.056-9.057,22.207-15.132,34.978-15.132a32.179,32.179,0,0,1,13.427,2.715c6.759-12.648,17.751-21.853,27.146-21.853,6.906,0,11.333,4.981,12.59,12.634,8.829-14.523,22.182-24.8,33.784-24.8,12.538,0,19.1,11.995,17.028,28.393a48.618,48.618,0,0,1,23.348-6.407c16.775,0,27.313,10.483,26.026,24.447Z",
    transform: "translate(-1336.856 -2145.667)",
    fill: "#f3ffff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cloud-4-group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cloud-4",
    d: "M1529.686,2215.624a27.971,27.971,0,0,1,1.494-8.661c5.059-15.3,21.394-27.705,36.519-27.705,12.884,0,20.711,9,19.618,21.116a19.78,19.78,0,0,1,7.31-1.5c5.023,0,8.754,2.271,10.647,5.841a34.552,34.552,0,0,1,17.928-5.515c11.145,0,18.35,6.861,18.7,16.427Z",
    transform: "translate(-1653.686 -2133.208)",
    fill: "#f3ffff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cloud-3-group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cloud-3",
    d: "M2167.837,2192.258a27.632,27.632,0,0,1,1.449-8.655c5.056-15.31,21.423-27.715,36.555-27.715,12.885,0,20.663,9.007,19.608,21.125a19.878,19.878,0,0,1,7.325-1.5c5.02,0,8.754,2.266,10.611,5.837a34.531,34.531,0,0,1,17.968-5.511c11.14,0,18.329,6.858,18.692,16.423Z",
    transform: "translate(-2291.837 -2147.744)",
    fill: "#f3ffff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cloud-2-group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cloud-2",
    transform: "translate(-1429.098)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87783",
    "data-name": "Group 87783",
    transform: "translate(1367.04 172.619)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_162202",
    "data-name": "Path 162202",
    d: "M2182.059,2298.269a40.843,40.843,0,0,0,4.817-9.761c5.671-17.237-3.507-31.217-20.541-31.217-14.5,0-30,10.146-37.8,23.8a14.745,14.745,0,0,0-7.135-1.7c-5.651,0-11.558,2.563-16.327,6.584-3.677-3.878-9.228-6.217-16.116-6.217-12.551,0-25.742,7.732-33.283,18.51Z",
    transform: "translate(-2055.672 -2257.291)",
    fill: "#f3ffff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_87784",
    "data-name": "Group 87784",
    transform: "translate(1305.098 195.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_162204",
    "data-name": "Path 162204",
    d: "M2071.093,2289.418c-.915-10.517-8.832-17.9-20.9-17.9-12.054,0-24.841,7.38-32.707,17.9Z",
    transform: "translate(-2017.483 -2271.521)",
    fill: "#f3ffff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "cloud-1-group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cloud-1",
    transform: "translate(-879.577)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_162203",
    "data-name": "Path 162203",
    d: "M1898.931,2203.523c2.456-15.581-7.115-27.437-23.394-27.437-12.843,0-26.4,7.4-35.4,18.163a25.494,25.494,0,0,0-14.906-4.363c-.688,0-1.359.064-2.039.105,6.7-21.676-5.109-39.124-26.807-39.124-14.716,0-30.237,8.058-41.051,20.011-4.958-6.188-12.875-9.963-22.919-9.963-21.965,0-45.674,17.881-52.971,39.932-.3.91-.514,1.8-.752,2.677Z",
    transform: "translate(-923.112 -2150.867)",
    fill: "#f3ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162205",
    "data-name": "Path 162205",
    d: "M1865.667,2189.422c-.818-9.325-7.836-15.884-18.551-15.884s-22.054,6.56-29.056,15.884Z",
    transform: "translate(-836.425 -2136.766)",
    fill: "#f3ffff"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_87976",
    "data-name": "Group 87976",
    transform: "translate(-6708.32 2466.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_254247552",
    "data-name": 254247552,
    d: "M2850.15,1022.464s-35.417,6.655-34.823,22.011,35.809,9.2,75.723,4.106,73.424,6.078,80.158-2.628,23.488-5.092,53.383-6.406,54.369-8.542,7.392-16.426S2850.15,1022.464,2850.15,1022.464Z",
    transform: "translate(0 -874.911)",
    fill: "#332c2b",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87701",
    "data-name": "Group 87701",
    transform: "translate(2818.466 -19.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_253380568",
    "data-name": 253380568,
    d: "M3637.833,631.083l-3.8,51.423-119.18,2.521,15.523-73.177,67.715-9.98Z",
    transform: "translate(-3407.688 -503.925)",
    fill: "#a56446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_253380736",
    "data-name": 253380736,
    d: "M3640.315,863.681l.069,1.6-110.364.86.318-1.6,109.976-.859Zm.455,10.979.06,1.6-113.322,2.19.333-1.6,112.929-2.188Zm.358,9.9.053,1.6-116.074,3.586.347-1.606,115.674-3.584Zm.383,12.643.044,1.6-118.584.67.355-1.6Z",
    transform: "translate(-3414.529 -724.451)",
    fill: "#94533f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_254276296",
    "data-name": 254276296,
    d: "M3586.526,717.923l-34.7.776-3.728-24.7,9.638-45.765,5.037-3.177,20.221-2.976,14.991,10.265Z",
    transform: "translate(-3435.69 -537.798)",
    fill: "#332c2b",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "_253379896",
    "data-name": 253379896,
    d: "M3594.165,598.255l-1.8,7.2-137.062,1-2-6.6,57.225-31.614,42.221,14.607Z",
    transform: "translate(-3355.846 -475.599)",
    fill: "#e7b89c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_253379728",
    "data-name": 253379728,
    d: "M3370.8,237.6l130.063,7.118,23.811,75.033-140.863,1.6Z",
    transform: "translate(-3286.35 -197.094)",
    fill: "#6b3010"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_203233248",
    "data-name": 203233248,
    d: "M3563.45,248.143l2,.11,12.761,81.615-1.984.022-12.781-81.747Zm18.445,1.009,2.019.111L3598,329.643l-2,.023L3581.9,249.152Zm19,1.04,2.016.11,13.57,79.131-1.993.022-13.594-79.263Zm16.632.91,2.037.111,16.666,78-2.007.023-16.7-78.129Zm13.528.74,2.057.113,19.3,77.069-2.024.023Zm16.11.881,2.075.114,21.269,75.981-2.037.023-21.307-76.118Z",
    transform: "translate(-3448.625 -205.976)",
    fill: "#522309"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_203234880",
    "data-name": 203234880,
    d: "M3374.166,238.448l30.037,1.644,68.477,80.975-87.956,1-12.839-82.654q1.152-.5,2.282-.964Z",
    transform: "translate(-3287.267 -197.81)",
    fill: "#332c2b",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "_253600304",
    "data-name": 253600304,
    d: "M2854.9,169.912l7.343,92.641,125.584-3.6,5.18-95.042-67.77-71.833Z",
    transform: "translate(-2851.806 -74.519)",
    fill: "#a56446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_253624024",
    "data-name": 253624024,
    d: "M2859.293,282.461l.031.539,136.625.617.065-1.594L2860.3,281.41Zm.71,12.015.1,1.6,135.3.581.067-1.594L2860,294.476Zm1.113,17.756.1,1.589,133.656-5.075.071-1.6-133.831,5.089Zm.712,10.788.107,1.593,132.272-1.308.074-1.6Zm.809,11.777.112,1.591,130.935-2.16.078-1.6L2862.637,334.8Zm.789,11.051.116,1.6,129.435.955.082-1.594-129.633-.957Zm1,13.5.121,1.592,127.874-1.886.084-1.6-128.08,1.892Zm.691,8.984.124,1.591,126.718-2.221.086-1.6Zm125.051-98.009-1.588-1.616-114.74-1.6-1.477,1.575,117.8,1.64Zm-14.091-14.5-1.52-1.586-89.271.509-1.469,1.6,92.26-.525Zm-16.812-17.809-1.452-1.565-57.1,1.206-1.446,1.624Zm-9.907-10.77-1.406-1.547-37.882,1.325-1.436,1.645,40.725-1.423Z",
    transform: "translate(-2855.505 -187.069)",
    fill: "#94533f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_253851840",
    "data-name": 253851840,
    d: "M3213.474,901.426l21.83-.711,1.51-48.416-24.96-.15Z",
    transform: "translate(-3152.472 -714.738)",
    fill: "#e7b89c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_253805160",
    "data-name": 253805160,
    d: "M3173.113,858.324l4.43-.145-1.838-50.315,27.612.2-1.8,49.335,5.967-.195,2.237-56.443-39.117.5Z",
    transform: "translate(-3117.725 -671.453)",
    fill: "#c48e6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_253845144",
    "data-name": 253845144,
    d: "M3245.74,898.954l1.309-.043-1.07-49.517-1.309.026,1.071,49.534Zm9.792-.319,1.3-.042,1.1-49.023-1.309-.04-1.1,49.106Z",
    transform: "translate(-3180.112 -712.417)",
    fill: "#94533f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_253848576",
    "data-name": 253848576,
    d: "M3204.8,896.117l1.165-.038-1.592-49.276,24.96.15-1.514,48.416.931-.031L3230.579,846l-27.612-.2Z",
    transform: "translate(-3144.986 -709.392)",
    fill: "#94533f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_253378888",
    "data-name": 253378888,
    d: "M3166.445,369.713l-4.1-28.313,37.716-2.2-1.9,30.914Z",
    transform: "translate(-3110.769 -282.674)",
    fill: "#e7b89c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_253379056",
    "data-name": 253379056,
    d: "M3203.372,387.777l-.807-11.1,10.445-.018.374,11.04Zm-.953-13.108-.748-10.292,10.9-.707.348,10.255Zm13.314-11.2,12.15-.788-.122,10.2-11.679.827-.348-10.236Zm11.982,13.171-.132,10.957-11.027.084-.375-11.021Z",
    transform: "translate(-3143.894 -302.449)",
    fill: "#bdb5c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_251488808",
    "data-name": 251488808,
    d: "M3205.576,387.777l-.615-8.461,3.3-2.643,6.953-.012.2,6.022-5.69,5.062Zm-1.288-17.724,7.98-6.221,2.506-.163.038,1.125-10.355,7.592Zm7.073,4.138,3.67-2.939.091,2.673-3.76.266Zm6.757-5.412,7.238-5.8,4.731-.307-.084,7.032-3.862,3.436-7.855.556Zm4.083,7.87-3.7,3.295-.112-3.288Z",
    transform: "translate(-3146.099 -302.449)",
    fill: "#fefefe",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161447",
    "data-name": "Path 161447",
    d: "M3787.968,176.133l.471,28.583,20.759.7.774-30.287Z",
    transform: "translate(-3637.739 -144.473)",
    fill: "#bdb5c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_253380400",
    "data-name": 253380400,
    d: "M3788.073,179.085l.474,28.583,10.647.351-1.1-29.393Z",
    transform: "translate(-3637.828 -147.422)",
    fill: "#b4a5b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_40221480",
    "data-name": 40221480,
    d: "M3889.977,853.546l-1.982-28.894,26.216-.248-1.5,28.413Z",
    transform: "translate(-3721.993 -691.367)",
    fill: "#e7b89c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_40221648",
    "data-name": 40221648,
    d: "M3917.087,879.028l6.935-.268-.271-9.989-6.778.133Zm9.237-.357,7.884-.3.286-9.8-7.767.151-.4,9.957Zm8.232-12.219.308-10.579-7.632.35-.425,10.476ZM3923.415,856.4l-6.579.3.116,10.315,6.745-.216Z",
    transform: "translate(-3746.287 -717.874)",
    fill: "#bdb5c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_251489312",
    "data-name": 251489312,
    d: "M3924.116,872.841l-.11-4.073-6.067.118-.7.608.095,8.348Zm-6.98-12.088,5.591-4.315.941-.043.028,1.014-6.543,4.869-.017-1.525Zm3.085,6.162,3.648-3.151.082,3.031Zm7.08-6.114,5.593-4.83,2.225-.1-.264,9.059-2.155,1.588-5.637.18.239-5.9Zm2.493,7.855-2.9,2.136.085-2.081,2.813-.055Z",
    transform: "translate(-3746.54 -717.871)",
    fill: "#fefefe",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "_203235240",
    "data-name": 203235240,
    d: "M2886.031,169.913l1.025,8.181,65.22-70.824s39.526,47.329,62.429,75.451l1.583-18.811L2951.46,92.078l-65.429,77.835Z",
    transform: "translate(-2878.027 -74.521)",
    fill: "#332c2b",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "_253379560",
    "data-name": 253379560,
    d: "M2845.36,77.678l-3.7-3.4,14.707-17.808-3.8,1.5,18.908-21.21-4.1.1L2885.879,20.1l-4.8.3,17.709-19.059-3,.951L2906.539-8.91l-5.453,2.2,11.706-12.556L2925.1-6.759l-6.1-1.2L2938.8,11.449l-4.9.1,26.512,23.711-3.5-.1,21.51,20.91-3.3-.8,13.506,14.407-5.8,4.6L2915.255-.411Z",
    transform: "translate(-2840.652 19.265)",
    fill: "#522309"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_254240888",
    "data-name": 254240888,
    d: "M2835.272,145.127l73.633-86.039,74.634,81.637-8.4,5.2-66.029-76.234-67.031,78.235Z",
    transform: "translate(-2835.272 -46.733)",
    fill: "#e7b89c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_253476784",
    "data-name": 253476784,
    d: "M2835.272,145.127l73.633-86.039,74.634,81.637-4.469,2.766-70.193-80.155-70.553,83.047Z",
    transform: "translate(-2835.272 -46.733)",
    fill: "#332c2b",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "_253852464",
    "data-name": 253852464,
    cx: 1.417,
    cy: 1.417,
    r: 1.417,
    transform: "translate(60.868 162.838) rotate(-80.783)",
    fill: "#6b3010"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_254350496",
    "data-name": 254350496,
    d: "M3236.772,853.683l.042-1.384-24.96-.15.107,3.3Z",
    transform: "translate(-3152.472 -714.738)",
    fill: "#332c2b",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "_252949320",
    "data-name": 252949320,
    d: "M3094.554,747.479l2.043,8.85,56.093-.575,2.547-9.773-41.968-2.136Z",
    transform: "translate(-3053.669 -623.512)",
    fill: "#332c2b",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "_253379224",
    "data-name": 253379224,
    d: "M3084.41,735.4l-.1-6.6,63.928-1,.2,9.4Z",
    transform: "translate(-3045.039 -609.997)",
    fill: "#c48e6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_254180400",
    "data-name": 254180400,
    d: "M3174.958,547.832l35.931-.862-1.848,4.928-33.591-.616Z",
    transform: "translate(-3121.394 -457.681)",
    fill: "#332c2b",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "_251576888",
    "data-name": 251576888,
    d: "M3162.645,520.63l39.419-.3-.3,5.2-38.617.35Z",
    transform: "translate(-3111.022 -435.242)",
    fill: "#c48e6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_252662824",
    "data-name": 252662824,
    d: "M3895.8,1018.077l24.926-.535-1.027,5.05-22.543.042Z",
    transform: "translate(-3728.567 -854.05)",
    fill: "#332c2b",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "_40221312",
    "data-name": 40221312,
    d: "M3884.584,998.279l27.787-1.076v4.962l-27.249-.248Z",
    transform: "translate(-3719.12 -836.918)",
    fill: "#c48e6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161448",
    "data-name": "Path 161448",
    d: "M3808.108,175.667l-20.14.922.595,8.178,20.647-.052.694-8.31Q3809.043,176.023,3808.108,175.667Z",
    transform: "translate(-3637.739 -144.929)",
    fill: "#332c2b",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "_253380064",
    "data-name": 253380064,
    d: "M3767.792,131.043l27.133-.619-.389,11-25.835-.62Z",
    transform: "translate(-3620.745 -106.82)",
    fill: "#ccc1cf"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "sun",
    transform: "translate(-5492 1912.999)"
  }, _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    id: "Path_157146",
    "data-name": "Path 157146",
    d: "M166,0A166,166,0,1,1,0,166,166,166,0,0,1,166,0Z",
    transform: "translate(1560 116)",
    opacity: 0.602,
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_82621",
    "data-name": "Group 82621",
    transform: "translate(66 22)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10559",
    "data-name": "Ellipse 10559",
    cx: 60,
    cy: 60,
    r: 60,
    transform: "translate(1601 201)",
    fill: "#fdeca2",
    opacity: 0.25,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10558",
    "data-name": "Ellipse 10558",
    cx: 39.5,
    cy: 39.5,
    r: 39.5,
    transform: "translate(1621 221)",
    fill: "#ffcf00",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutside);
export default __webpack_public_path__ + "static/media/outside.44381cfc639866a372bc7745d358fb59.svg";
export { ForwardRef as ReactComponent };